/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import { Client, generateClient, GraphQLResult } from "aws-amplify/api";
import { Observable } from "rxjs";

export type __SubscriptionContainer = {
  subscribeLoadingPointSpeedPattern: SubscribeLoadingPointSpeedPatternSubscription;
  locationSvcOnLocationUpdate: LocationSvcOnLocationUpdateSubscription;
  onOrderSvcDownloadFileComplete: OnOrderSvcDownloadFileCompleteSubscription;
};

export type TruckInput = {
  Date: string;
  Location: LocationInput;
};

export type LocationInput = {
  lat: number;
  lng: number;
};

export type Truck = {
  __typename: "Truck";
  RMCProviderName: string;
  IMEI: string;
  Date?: string | null;
  Location?: Location | null;
  Registration?: string | null;
  DrumStatus?: DrumStatus | null;
  DrumDirection?: string | null;
  DrumAverageRpm?: number | null;
  TruckStatus?: TruckStatus | null;
  SlumpDescription?: string | null;
  RunId?: string | null;
  DateBatchLocal?: string | null;
  PredictionTripPosixTimestampStart?: number | null;
  SystemDatetimeUtcStr?: string | null;
  SystemDatetimePosixUtcSeconds?: number | null;
};

export type Location = {
  __typename: "Location";
  lat: number;
  lng: number;
};

export enum DrumStatus {
  IDLE = "IDLE",
  LOADING = "LOADING",
  LOADED = "LOADED",
  INTRANSIT = "INTRANSIT",
  WAITING = "WAITING",
  UNLOADING = "UNLOADING",
  UNLOADED = "UNLOADED",
  BASEUNLOADING = "BASEUNLOADING",
  BASEUNLOADED = "BASEUNLOADED",
  WASHOUT = "WASHOUT",
  UNKNOWN = "UNKNOWN"
}

export enum TruckStatus {
  IDLE = "IDLE",
  LOADING = "LOADING",
  LOADED = "LOADED",
  INTRANSIT = "INTRANSIT",
  WAITING = "WAITING",
  UNLOADING = "UNLOADING",
  UNLOADED = "UNLOADED",
  BASEUNLOADING = "BASEUNLOADING",
  BASEUNLOADED = "BASEUNLOADED",
  WASHOUT = "WASHOUT",
  UNKNOWN = "UNKNOWN"
}

export type UpdateTruckInput = {
  DrumStatus?: DrumStatus | null;
  TruckStatus?: TruckStatus | null;
  SlumpDescription?: string | null;
  DrumDirection?: string | null;
  DrumAverageRpm?: number | null;
  Location?: LocationInput | null;
  Date?: string | null;
  RunId?: string | null;
  DateBatchLocal?: string | null;
  PredictionTripPosixTimestampStart?: number | null;
  SystemDatetimeUtcStr?: string | null;
  SystemDatetimePosixUtcSeconds?: number | null;
};

export type LoadingPointSpeedPatternUpdateInput = {
  imei: string;
  eventType?: string | null;
  rmcProvider: string;
  plantCode: string;
  loadingPoint: string;
  truckPlate?: string | null;
  datetimeBatch?: string | null;
  leftBatchPlant?: string | null;
  systemDatetimeUtcStr?: string | null;
  batchSpeedPattern?: string | null;
  batchSpeedPatternTime?: string | null;
  drumVectorRpm?: number | null;
};

export type LoadingPointSpeedPatternUpdate = {
  __typename: "LoadingPointSpeedPatternUpdate";
  imei: string;
  eventType?: string | null;
  rmcProvider: string;
  plantCode: string;
  loadingPoint: string;
  truckPlate?: string | null;
  datetimeBatch?: string | null;
  leftBatchPlant?: string | null;
  systemDatetimeUtcStr?: string | null;
  batchSpeedPattern?: string | null;
  batchSpeedPatternTime?: string | null;
  drumVectorRpm?: number | null;
};

export type TruckTimeseriesInput = {
  imei: string;
  systemDatetimeUtcStr: string;
  gpsLatitudeDecimal?: number | null;
  gpsLongitudeDecimal?: number | null;
  gpsLatitudes?: string | null;
  gpsLongitudes?: string | null;
  pressureABarLowLatency?: number | null;
  pressureBBarLowLatency?: number | null;
  supplyVoltageMean?: number | null;
  drumVectorRpm?: number | null;
  temperatureModuleSurfaceTemperatureDegc?: number | null;
  temperatureModuleConcreteTemperatureDegc?: number | null;
  consistenceTestType?: string | null;
  consistenceMm?: number | null;
  consistenceMinMm?: number | null;
  consistenceMaxMm?: number | null;
  consistenceMmQualifier?: string | null;
  pressureABarMean?: number | null;
  pressureBBarMean?: number | null;
  co2?: number | null;
  rheometryPlasticViscosityPaS?: number | null;
  rheometryStaticYieldStressPa?: number | null;
  rheometryDynamicYieldStressPa?: number | null;
  delete_ttl?: number | null;
  percentAir?: number | null;
  concreteVolume?: number | null;
};

export type TruckTimeseries = {
  __typename: "TruckTimeseries";
  imei: string;
  systemDatetimeUtcStr: string;
  gpsLatitudeDecimal?: number | null;
  gpsLongitudeDecimal?: number | null;
  gpsLatitudes?: string | null;
  gpsLongitudes?: string | null;
  pressureABarLowLatency?: number | null;
  pressureBBarLowLatency?: number | null;
  supplyVoltageMean?: number | null;
  drumVectorRpm?: number | null;
  temperatureModuleSurfaceTemperatureDegc?: number | null;
  temperatureModuleConcreteTemperatureDegc?: number | null;
  consistenceTestType?: string | null;
  consistenceMm?: number | null;
  consistenceMinMm?: number | null;
  consistenceMaxMm?: number | null;
  consistenceMmQualifier?: string | null;
  pressureABarMean?: number | null;
  pressureBBarMean?: number | null;
  co2?: number | null;
  rheometryPlasticViscosityPaS?: number | null;
  rheometryStaticYieldStressPa?: number | null;
  rheometryDynamicYieldStressPa?: number | null;
  percentAir?: number | null;
  concreteVolume?: number | null;
  delete_ttl?: number | null;
};

export type GeolocationInput = {
  owner: string;
  owner_id: string;
  parent_id?: string | null;
  name?: string | null;
  type?: string | null;
  lng?: string | null;
  lat?: string | null;
  polygon?: string | null;
  status?: string | null;
  timezone?: string | null;
  timezone_date?: string | null;
  loading_points?: string | null;
  last_delivery_timestamp?: number | null;
};

export type GeolocationItem = {
  __typename: "GeolocationItem";
  owner: string;
  owner_id: string;
  parent_id?: string | null;
  name?: string | null;
  type?: string | null;
  lng?: string | null;
  lat?: string | null;
  polygon?: string | null;
  status?: string | null;
  timezone?: string | null;
  timezone_date?: string | null;
  loading_points?: string | null;
  last_delivery_timestamp?: number | null;
};

export enum EventType {
  TRUCK_LOADED = "TRUCK_LOADED",
  TRUCK_UNLOADED = "TRUCK_UNLOADED"
}

export type TruckRecordInput = {
  ext_truck_id?: string | null;
  ext_truck_name?: string | null;
  rmc_provider: string;
  registration: string;
  device_imei?: string | null;
  serial_no?: string | null;
  vin?: string | null;
  project?: string | null;
  config?: TruckConfigInput | null;
  permitted_rmcs: Array<string>;
};

export type TruckConfigInput = {
  physical?: TruckPhysicalConfigInput | null;
  operations?: TruckOperationsConfigInput | null;
  globalConfig?: TruckGlobalConfigInput | null;
};

export type TruckPhysicalConfigInput = {
  gearbox_ratio?: number | null;
  hydraulic_motor_displacement_cc?: number | null;
  drum_volume_m3?: number | null;
  is_charging_clockwise?: boolean | null;
  is_pressure_id1_charging?: boolean | null;
  is_pressure_b_insulated?: boolean | null;
  pressure_sensor_location?: PressureSensorLocation | null;
};

export enum PressureSensorLocation {
  motor = "motor",
  pump = "pump",
  not_installed = "not_installed"
}

export type TruckOperationsConfigInput = {
  is_fm_enabled?: boolean | null;
  is_pa_enabled?: boolean | null;
  is_pb_enabled?: boolean | null;
  is_smarthatch_enabled?: boolean | null;
  is_dm_temperature_fault?: boolean | null;
  is_dm_fault?: boolean | null;
  is_fm_fault?: boolean | null;
  is_pa_fault?: boolean | null;
  is_pb_fault?: boolean | null;
  is_cb_fault?: boolean | null;
  is_smarthatch_fault?: boolean | null;
  is_dm_fitted?: boolean | null;
  is_fm_fitted?: boolean | null;
  is_pa_fitted?: boolean | null;
  is_pb_fitted?: boolean | null;
  is_smarthatch_fitted?: boolean | null;
  maintenance_status?: string | null;
  cb_mounting_location?: CbMountingLocation | null;
  cb_mounting_direction?: CbMountingDirection | null;
};

export enum CbMountingLocation {
  front = "front",
  pedestal = "pedestal",
  rear = "rear",
  cab = "cab",
  waterTank = "waterTank"
}

export enum CbMountingDirection {
  port = "port",
  starboard = "starboard",
  forwards = "forwards",
  backwards = "backwards"
}

export type TruckGlobalConfigInput = {
  is_whitelisted?: boolean | null;
  is_off_the_road?: boolean | null;
  is_virtual?: boolean | null;
  misc?: string | null;
  manufacturer?: string | null;
  model?: string | null;
  no_consistence?: boolean | null;
  no_consistence_description?: string | null;
  rpm_sensor?: RpmSensor | null;
};

export enum RpmSensor {
  speed_ring = "speed_ring",
  temp_sensor = "temp_sensor"
}

export type TruckRecord = {
  __typename: "TruckRecord";
  truck_id?: number | null;
  ext_truck_id?: string | null;
  ext_truck_name?: string | null;
  rmc_provider: string;
  registration?: string | null;
  device_imei?: string | null;
  serial_no?: string | null;
  vin?: string | null;
  project?: string | null;
  valid_from?: string | null;
  valid_to?: string | null;
  config?: TruckConfig | null;
  permitted_rmcs: Array<string>;
};

export type TruckConfig = {
  __typename: "TruckConfig";
  physical?: TruckPhysicalConfig | null;
  operations?: TruckOperationsConfig | null;
  globalConfig?: TruckGlobalConfig | null;
};

export type TruckPhysicalConfig = {
  __typename: "TruckPhysicalConfig";
  gearbox_ratio?: number | null;
  hydraulic_motor_displacement_cc?: number | null;
  drum_volume_m3?: number | null;
  is_charging_clockwise?: boolean | null;
  is_pressure_id1_charging?: boolean | null;
  is_pressure_b_insulated?: boolean | null;
  pressure_sensor_location?: PressureSensorLocation | null;
};

export type TruckOperationsConfig = {
  __typename: "TruckOperationsConfig";
  is_fm_enabled?: boolean | null;
  is_pa_enabled?: boolean | null;
  is_pb_enabled?: boolean | null;
  is_smarthatch_enabled?: boolean | null;
  is_dm_temperature_fault?: boolean | null;
  is_dm_fault?: boolean | null;
  is_fm_fault?: boolean | null;
  is_pa_fault?: boolean | null;
  is_pb_fault?: boolean | null;
  is_cb_fault?: boolean | null;
  is_smarthatch_fault?: boolean | null;
  is_dm_fitted?: boolean | null;
  is_fm_fitted?: boolean | null;
  is_pa_fitted?: boolean | null;
  is_pb_fitted?: boolean | null;
  is_smarthatch_fitted?: boolean | null;
  maintenance_status?: string | null;
  cb_mounting_location?: CbMountingLocation | null;
  cb_mounting_direction?: CbMountingDirection | null;
};

export type TruckGlobalConfig = {
  __typename: "TruckGlobalConfig";
  is_whitelisted?: boolean | null;
  is_off_the_road?: boolean | null;
  is_virtual?: boolean | null;
  misc?: string | null;
  manufacturer?: string | null;
  model?: string | null;
  no_consistence?: boolean | null;
  no_consistence_description?: string | null;
  rpm_sensor?: RpmSensor | null;
};

export type ImeisToForwardResponse = {
  __typename: "ImeisToForwardResponse";
  imeis: Array<string>;
};

export type TruckIdsToForwardResponse = {
  __typename: "TruckIdsToForwardResponse";
  truck_ids: Array<number>;
};

export type MediaSvcUploadSupplierFileResponse = {
  __typename: "MediaSvcUploadSupplierFileResponse";
  success: boolean;
  uploadUrl?: string | null;
  error?: string | null;
};

export type MediaSvcGetSupplierFileUrlResponse = {
  __typename: "MediaSvcGetSupplierFileUrlResponse";
  success: boolean;
  downloadUrl?: string | null;
  error?: string | null;
};

export type MediaSvcListSupplierFilesResponse = {
  __typename: "MediaSvcListSupplierFilesResponse";
  success: boolean;
  files?: Array<string> | null;
  error?: string | null;
};

export type ReplayResponse = {
  __typename: "ReplayResponse";
  message?: string | null;
};

export type LoadTestResponse = {
  __typename: "LoadTestResponse";
  message?: string | null;
};

export type OrderSvcDownloadFileCompleteNotification = {
  __typename: "OrderSvcDownloadFileCompleteNotification";
  jobId: string;
  status: string;
  csvFileLink?: string | null;
};

export type OrderSvcTagMutationResponse = {
  __typename: "OrderSvcTagMutationResponse";
  success: boolean;
  tag?: OrderSvcTag | null;
  error?: string | null;
};

export type OrderSvcTag = {
  __typename: "OrderSvcTag";
  id: number;
  rmcId: string;
  name: string;
  usageCount?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type OrderSvcCreateManualTestMutationResponse = {
  __typename: "OrderSvcCreateManualTestMutationResponse";
  success: boolean;
  manualTest?: OrderSvcManualTest | null;
  uploadUrl?: string | null;
  uploadFields?: string | null;
  error?: string | null;
};

export type OrderSvcManualTest = {
  __typename: "OrderSvcManualTest";
  id: number;
  docketId: string;
  type: string;
  result: number;
  testResult: number;
  unit: string;
  testTime: string;
  createdBy: string;
  comment?: string | null;
  mediaS3Key?: string | null;
  accepted?: boolean | null;
  acceptanceReason?: string | null;
  reviewedBy?: string | null;
};

export type OrderSvcUpdateManualTestMutationResponse = {
  __typename: "OrderSvcUpdateManualTestMutationResponse";
  success: boolean;
  manualTest?: OrderSvcManualTest | null;
  error?: string | null;
};

export type OrderSvcEndDeliveryMutationResponse = {
  __typename: "OrderSvcEndDeliveryMutationResponse";
  success: boolean;
  error?: string | null;
};

export enum OrderSvcUserQueryType {
  orderSvcTrip = "orderSvcTrip",
  orderSvcOrder = "orderSvcOrder"
}

export type OrderSvcUserQueryMutationResponse = {
  __typename: "OrderSvcUserQueryMutationResponse";
  success: boolean;
  query?: OrderSvcUserQuery | null;
  error?: string | null;
};

export type OrderSvcUserQuery = {
  __typename: "OrderSvcUserQuery";
  id: number;
  name: string;
  type: OrderSvcUserQueryType;
  description?: string | null;
  usageCount: number;
  queryPayload: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCognitoUserInput = {
  username: string;
  email?: string | null;
  phoneNumber?: string | null;
  givenName?: string | null;
  familyName?: string | null;
  jobTitle?: string | null;
};

export type UpdateCognitoUserOutput = {
  __typename: "UpdateCognitoUserOutput";
  success: boolean;
  statusCode: number;
};

export type CreateCognitoUserInput = {
  email: string;
  phoneNumber: string;
  givenName: string;
  familyName: string;
  jobTitle: string;
};

export type CreateCognitoUserOutput = {
  __typename: "CreateCognitoUserOutput";
  success: boolean;
  user?: CognitoUserDetail | null;
  error: string;
};

export type CognitoUserDetail = {
  __typename: "CognitoUserDetail";
  username: string;
  email: string;
  phoneNumber: string;
  givenName?: string | null;
  familyName?: string | null;
  jobTitle?: string | null;
  status?: string | null;
  enabled?: boolean | null;
  groups?: Array<string> | null;
  created?: string | null;
  lastModified?: string | null;
};

export type DeleteCognitoUserOutput = {
  __typename: "DeleteCognitoUserOutput";
  success: boolean;
  error: string;
};

export type AddUserToCognitoGroupOutput = {
  __typename: "AddUserToCognitoGroupOutput";
  success: boolean;
};

export type RemoveUserFromCognitoGroupOutput = {
  __typename: "RemoveUserFromCognitoGroupOutput";
  success: boolean;
};

export type ResetUserPasswordInput = {
  username: string;
};

export type ResetUserPasswordOutput = {
  __typename: "ResetUserPasswordOutput";
  success: boolean;
  error: string;
};

export type ResendInviteOutput = {
  __typename: "ResendInviteOutput";
  success: boolean;
  error: string;
};

export type CreateUserInput = {
  subId: string;
  tenant: string;
  firstName?: string | null;
  lastName?: string | null;
  groupIds?: Array<string> | null;
  roleIds?: Array<string> | null;
  abilityIds?: Array<string> | null;
};

export type User = {
  __typename: "User";
  subId: string;
  tenant: string;
  firstName?: string | null;
  lastName?: string | null;
  groups: Array<Group>;
  roles: Array<Role>;
  abilities: Array<Ability>;
};

export type Group = {
  __typename: "Group";
  id: string;
  parentId?: string | null;
  tenant: string;
  name: string;
  description?: string | null;
  roles: Array<Role>;
};

export type Role = {
  __typename: "Role";
  id: string;
  name: string;
  description?: string | null;
  abilities: Array<Ability>;
  readonly: boolean;
};

export type Ability = {
  __typename: "Ability";
  id: string;
  action: string;
  subject: string;
  fields?: Array<string> | null;
  conditions?: string | null;
  inverted: boolean;
  description?: string | null;
  readonly: boolean;
};

export type UpdateUserInput = {
  groupIds?: Array<string> | null;
  roleIds?: Array<string> | null;
  abilityIds?: Array<string> | null;
};

export type CreateGroupInput = {
  tenant: string;
  name: string;
  description?: string | null;
  roleIds?: Array<string> | null;
  parentId?: string | null;
};

export type UpdateGroupInput = {
  name?: string | null;
  description?: string | null;
  roleIds?: Array<string> | null;
  parentId?: string | null;
};

export type CreateRoleInput = {
  name: string;
  description?: string | null;
  abilityIds?: Array<string> | null;
};

export type UpdateRoleInput = {
  name?: string | null;
  description?: string | null;
  abilityIds?: Array<string> | null;
};

export type CreateAbilityInput = {
  action: string;
  subject: string;
  fields?: Array<string> | null;
  conditions?: string | null;
  inverted?: boolean | null;
  description?: string | null;
};

export type UpdateAbilityInput = {
  action?: string | null;
  subject?: string | null;
  fields?: Array<string> | null;
  conditions?: string | null;
  inverted?: boolean | null;
  description?: string | null;
};

export type RoleAssignmentInput = {
  subId: string;
  roleIds: Array<string>;
};

export type MutationResponse = {
  __typename: "MutationResponse";
  success: boolean;
  errors?: Array<Error> | null;
};

export type Error = {
  __typename: "Error";
  code: ErrorCode;
  message: string;
  field?: string | null;
};

export enum ErrorCode {
  NOT_FOUND = "NOT_FOUND",
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
  INVALID_INPUT = "INVALID_INPUT",
  CIRCULAR_REFERENCE = "CIRCULAR_REFERENCE",
  DEPENDENCY_EXISTS = "DEPENDENCY_EXISTS"
}

export type UserTrackingEventInput = {
  uId: string;
  uName: string;
  email: string;
  rmcId: string;
  timestampUTC: string;
  action: string;
  category: string;
  label?: string | null;
};

export type BatchPlantsInput = {
  batchPlantIds: Array<string>;
};

export type TaxonomyRecordOutput = {
  __typename: "TaxonomyRecordOutput";
  id: string;
  parentId?: string | null;
  rmc: string;
  groupName: string;
  groupType: string;
  groupDescription: string;
};

export type UpdateGeofenceResponse = {
  __typename: "UpdateGeofenceResponse";
  success: boolean;
  location?: Geolocation | null;
};

export type Geolocation = {
  __typename: "Geolocation";
  Owner: string;
  OwnerId: string;
  ParentId?: string | null;
  Name?: string | null;
  Type?: string | null;
  Lng?: string | null;
  Lat?: string | null;
  Polygon?: string | null;
  Status?: string | null;
  Timezone?: string | null;
  TimezoneDate?: string | null;
  LoadingPoints?: string | null;
  LastDeliveryTimestamp?: number | null;
};

export type SaveGeofenceResponse = {
  __typename: "SaveGeofenceResponse";
  success: boolean;
  location?: GeolocationItem | null;
};

export type DocketSvcPostDocketResult = {
  __typename: "DocketSvcPostDocketResult";
  success: boolean;
  message: string;
  docketId?: string | null;
  ticketId?: string | null;
  errors?: Array<string> | null;
};

export type BFDSvcImeiMutationResponse = {
  __typename: "BFDSvcImeiMutationResponse";
  success: boolean;
  message: string;
  imei?: string | null;
  errorCode?: string | null;
};

export type TruckTimeseriesSpan = {
  __typename: "TruckTimeseriesSpan";
  items?: Array<TruckTimeseries | null> | null;
  nextToken?: string | null;
};

export type TruckInformationSnapshotsConnection = {
  __typename: "TruckInformationSnapshotsConnection";
  items?: Array<TruckSnapshot | null> | null;
  nextToken?: string | null;
  timestamp?: string | null;
};

export type TruckSnapshot = {
  __typename: "TruckSnapshot";
  imei: string;
  eventType?: string | null;
  rmcProvider?: string | null;
  rmcCustomerId?: string | null;
  rmcCustomerName?: string | null;
  rmcAndCustomerId?: string | null;
  systemDatetimeUtcStr?: string | null;
  truckId?: number | null;
  truckPlate?: string | null;
  truckImei?: string | null;
  datetimeBatch?: string | null;
  slumpCode?: string | null;
  orderCode?: string | null;
  docketId?: string | null;
  docketId1?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  deliveredQuantity?: number | null;
  plantCode?: string | null;
  loadingPoint?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  siteLocation?: string | null;
  plantLocation?: string | null;
  tripStartTime?: string | null;
  tripEndTime?: string | null;
  pourTime?: string | null;
  pourEvents?: string | null;
  pourLocation?: string | null;
  leftBatchPlant?: string | null;
  arrivedAtSite?: string | null;
  leftSite?: string | null;
  deliveryStartTime?: string | null;
  deliveryEndTime?: string | null;
  consistenceMmAtLoadMix?: number | null;
  consistenceMmAtLoadMixOk?: boolean | null;
  consistenceMmQualifierAtLoadMix?: string | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmAtPlantExitOk?: boolean | null;
  consistenceMmQualifierAtPlantExit?: string | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtSiteArrivalOk?: boolean | null;
  consistenceMmQualifierAtSiteArrival?: string | null;
  consistenceMmAtPour?: number | null;
  consistenceMmAtPourOk?: boolean | null;
  consistenceMmQualifierAtPour?: string | null;
  siteWaitTimeSeconds?: number | null;
  siteTimeSeconds?: number | null;
  waterAdditions?: string | null;
  gpsLatitudeDecimal?: number | null;
  gpsLongitudeDecimal?: number | null;
  gpsLatitudes?: string | null;
  gpsLongitudes?: string | null;
  pressureABarLowLatency?: number | null;
  pressureBBarLowLatency?: number | null;
  supplyVoltageMean?: number | null;
  drumLowLatencyRpm?: number | null;
  drumVectorRpm?: number | null;
  temperatureModuleSurfaceTemperatureDegc?: number | null;
  temperatureModuleConcreteTemperatureDegc?: number | null;
  consistenceMmUtcStr?: string | null;
  consistenceMm?: number | null;
  consistenceMinMm?: number | null;
  consistenceMaxMm?: number | null;
  consistenceTestType?: string | null;
  pressureABarMean?: number | null;
  pressureBBarMean?: number | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  consistenceClassMax?: number | null;
  consistenceClassMin?: number | null;
  consistenceLowerLimitSpot?: number | null;
  consistenceStandard?: string | null;
  consistenceUpperLimitSpot?: number | null;
  consistencePredictionType?: string | null;
  consistenceMmQualifier?: string | null;
  plantGeofenceIdMostRecent?: string | null;
  co2?: number | null;
  tempAtLoadMix?: number | null;
  tempAtPlantExit?: number | null;
  tempAtSiteArrival?: number | null;
  tempAtPour?: number | null;
  tz?: string | null;
  batchSpeedPattern?: string | null;
  batchSpeedPatternTime?: string | null;
  speedPatternAtSite?: string | null;
  speedPatternAtSiteTime?: string | null;
  rmcPlantCodeLoadingPoint?: string | null;
  rheometryPredictionType?: string | null;
  rheometryPlasticViscosityPaS?: number | null;
  rheometryStaticYieldStressPa?: number | null;
  rheometryDynamicYieldStressPa?: number | null;
  rheometryStaticYieldStressTargetMinPa?: number | null;
  rheometryStaticYieldStressTargetMaxPa?: number | null;
  rheometryPlasticViscosityTargetMinPas?: number | null;
  rheometryPlasticViscosityTargetMaxPas?: number | null;
  delete_ttl?: number | null;
  extTruckName?: string | null;
  extTruckId?: string | null;
  config?: string | null;
  inBatchPlant?: boolean | null;
  inSite?: boolean | null;
  canTrackGeo?: boolean | null;
  deliveryTags?: Array<string | null> | null;
  allowableWaterToAddLitres?: number | null;
  excessWaterAddedDuringBatchingLitres?: number | null;
  mixDesignCode?: string | null;
  maxWaterCementRatio?: number | null;
  spinUpStatus?: string | null;
  spinUpStatusUpdateTime?: string | null;
  emptyDrumStage?: string | null;
  emptyDrumType?: string | null;
  emptyDrumTime?: string | null;
  additionalWaterDetected?: boolean | null;
  washoutWaterMeasured?: number | null;
  additionalWaterPerM3?: number | null;
  midPourWaterAdded?: number | null;
  prePourWaterAdded?: number | null;
  unclassifiedWaterAdded?: number | null;
  waterAddedAtPlant?: number | null;
  additionalWaterMeasured?: number | null;
  percentAir?: number | null;
  concreteVolume?: number | null;
  concreteVolumeM3AtPlantExit?: number | null;
  concreteVolumeM3AtSiteArrival?: number | null;
  concreteVolumeM3AtPour?: number | null;
  concreteVolumeM3AtSiteExit?: number | null;
  airPercentAtPlantExit?: number | null;
  airPercentAtSiteArrival?: number | null;
  airPercentAtPour?: number | null;
  airPercentAtSiteExit?: number | null;
  airPercentAtLoadMix?: number | null;
  weatherTempDegcAtPlant?: number | null;
  weatherCodeAtPlant?: number | null;
  weatherTempDegcAtSiteArrival?: number | null;
  weatherCodeAtSiteArrival?: number | null;
  deviceHealthStatus?: string | null;
};

export type DeviceRecordList = {
  __typename: "DeviceRecordList";
  items?: Array<DeviceRecordListItem | null> | null;
  lastEvaluatedKey?: string | null;
};

export type DeviceRecordListItem = {
  __typename: "DeviceRecordListItem";
  imei: string;
  serialNumber?: string | null;
  hostosVersion?: string | null;
  hardwareVersion?: string | null;
  applicationVersion?: string | null;
  systemUpTimeSeconds?: number | null;
  connectionLastReceived?: number | null;
};

export type AuditResponse = {
  __typename: "AuditResponse";
  item?: string | null;
  items?: Array<string | null> | null;
};

export type TruckRecordList = {
  __typename: "TruckRecordList";
  items?: Array<TruckRecordListItem | null> | null;
  lastEvaluatedKey?: string | null;
};

export type TruckRecordListItem = {
  __typename: "TruckRecordListItem";
  truckId?: number | null;
  rmcProvider: string;
  registration?: string | null;
  deviceImei?: string | null;
  serialNo?: string | null;
  vin?: string | null;
  project?: string | null;
  permitted_rmcs: Array<string>;
};

export type SloRecordList = {
  __typename: "SloRecordList";
  items?: Array<SloRecord | null> | null;
  lastEvaluatedKey?: string | null;
};

export type SloRecord = {
  __typename: "SloRecord";
  ts?: number | null;
  imei?: string | null;
  slo_type?: string | null;
  slo_metrics?: SloMetrics | null;
  metadata?: SloMetadata | null;
  delete_ttl?: number | null;
};

export type SloMetrics = {
  __typename: "SloMetrics";
  connection?: SloMetricDetails | null;
  dockets?: SloMetricDetails | null;
  drum_module?: SloMetricDetails | null;
  pressure?: SloMetricDetails | null;
  water_flowmeter?: SloMetricDetails | null;
};

export type SloMetricDetails = {
  __typename: "SloMetricDetails";
  slo?: string | null;
  details?: string | null;
  sli_metrics?: Array<SliMetric | null> | null;
};

export type SliMetric = {
  __typename: "SliMetric";
  sli_name?: string | null;
  sli_status?: string | null;
  sli_reason?: string | null;
};

export type SloMetadata = {
  __typename: "SloMetadata";
  truck_id?: number | null;
  registration?: string | null;
  rmc_provider: string;
  application_version?: string | null;
  hardware_version?: string | null;
  host_os_version?: string | null;
  imsi?: string | null;
  serial_number?: number | null;
  system_up_time_seconds?: number | null;
};

export enum ListLatestSlosStatus {
  all = "all",
  fail = "fail"
}

export type ListLatestSlosStatusFilter = {
  drum_module?: ListLatestSlosStatus | null;
  connection?: ListLatestSlosStatus | null;
  pressure?: ListLatestSlosStatus | null;
  dockets?: ListLatestSlosStatus | null;
  water_flowmeter?: ListLatestSlosStatus | null;
};

export enum TruckKeysTypes {
  device_imei = "device_imei",
  truck_id = "truck_id",
  registration = "registration",
  serial_no = "serial_no",
  ext_truck_id = "ext_truck_id"
}

export type RmcPermittedResult = {
  __typename: "RmcPermittedResult";
  permitted: boolean;
  reason?: string | null;
  truckId: number;
  rmc: string;
  permittedRmcs: Array<string>;
  currentRmc: string;
};

export type MediaDetail = {
  __typename: "MediaDetail";
  truckId: number;
  orderId?: string | null;
  docketId?: string | null;
  targetTimestamp?: string | null;
  createdTimestamp?: string | null;
  comment?: string | null;
  s3Key?: string | null;
  rmcId?: string | null;
  userSubId?: string | null;
  userFirstName?: string | null;
  userLastName?: string | null;
  metadata?: string | null;
};

export type MediaCreateOutput = {
  __typename: "MediaCreateOutput";
  url: string;
};

export type MediaFileLinkOutput = {
  __typename: "MediaFileLinkOutput";
  url: string;
};

export type CubeOrdersListOrdersResponse = {
  __typename: "CubeOrdersListOrdersResponse";
  orders?: Array<CubeOrdersListOrders> | null;
  cursor?: string | null;
};

export type CubeOrdersListOrders = {
  __typename: "CubeOrdersListOrders";
  rmcId?: string | null;
  orderCode?: string | null;
  slumpCode?: string | null;
  jobsiteDescription?: string | null;
  jobsiteCode?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  aggregateSize?: string | null;
  deliveryQuantity?: number | null;
  consistenceTarget?: number | null;
  consistenceClass?: string | null;
  rmcCustomerName?: string | null;
  deliveries?: number | null;
  volumeDelivered?: number | null;
  firstBatchingTimestamp?: string | null;
  lastBatchingTimestamp?: string | null;
  timezone?: string | null;
};

export type GetDeliveriesByRmcResponse = {
  __typename: "GetDeliveriesByRmcResponse";
  deliveries?: Array<OrderSvcTrip | null> | null;
  cursor?: number | null;
};

export type OrderSvcTrip = {
  __typename: "OrderSvcTrip";
  rmcId?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  truckImei?: string | null;
  tripStartTime?: string | null;
  tripEndTime?: string | null;
  datetimeBatch?: string | null;
  slumpCode?: string | null;
  orderCode?: string | null;
  docketId?: string | null;
  docketId1?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  deliveredQuantity?: number | null;
  plantCode?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  pourTime?: string | null;
  pourEvents?: string | null;
  pourLocation?: string | null;
  siteLocation?: string | null;
  plantLocation?: string | null;
  plantName?: string | null;
  loadingPoint?: string | null;
  leftBatchPlant?: string | null;
  arrivedAtSite?: string | null;
  leftSite?: string | null;
  consistenceMmAtLoadMix?: number | null;
  consistenceMmAtLoadMixOk?: boolean | null;
  consistenceMmQualifierAtLoadMix?: string | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmAtPlantExitOk?: boolean | null;
  consistenceMmQualifierAtPlantExit?: string | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtSiteArrivalOk?: boolean | null;
  consistenceMmQualifierAtSiteArrival?: string | null;
  consistenceMmAtPour?: number | null;
  consistenceMmAtPourOk?: boolean | null;
  consistenceMmQualifierAtPour?: string | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  consistenceClassMax?: number | null;
  consistenceClassMin?: number | null;
  consistenceLowerLimitSpot?: number | null;
  consistenceStandard?: string | null;
  consistenceTestType?: string | null;
  consistenceUpperLimitSpot?: number | null;
  customerName?: string | null;
  rheometryPlasticViscosityPasAtPlantExit?: number | null;
  rheometryPlasticViscosityPasAtSiteArrival?: number | null;
  rheometryPlasticViscosityPasAtPour?: number | null;
  rheometryPlasticViscosityPasPredictionType?: string | null;
  rheometryYieldStressPaAtPlantExit?: number | null;
  rheometryYieldStressPaAtSiteArrival?: number | null;
  rheometryYieldStressPaAtPour?: number | null;
  rheometryYieldStressPaPredictionType?: string | null;
  rheometryStaticYieldStressTargetMinPa?: number | null;
  rheometryStaticYieldStressTargetMaxPa?: number | null;
  rheometryPlasticViscosityTargetMinPas?: number | null;
  rheometryPlasticViscosityTargetMaxPas?: number | null;
  waterAdditions?: string | null;
  additionalWaterMeasured?: number | null;
  additionalWaterDetected?: boolean | null;
  washoutWaterMeasured?: number | null;
  additionalWaterPerM3?: number | null;
  midPourWaterAdded?: number | null;
  prePourWaterAdded?: number | null;
  unclassifiedWaterAdded?: number | null;
  waterAddedAtPlant?: number | null;
  timezone?: string | null;
  tempAtLoadMix?: number | null;
  tempAtSiteArrival?: number | null;
  tempAtPour?: number | null;
  tempAtPlantExit?: number | null;
  consistenceSpeedPattern?: string | null;
  speedPatternAtSite?: string | null;
  consistencePredictionType?: string | null;
  deliveryTags?: Array<OrderSvcTag> | null;
  batchToDepartureTimeMinutes?: number | null;
  outboundTransitTimeMinutes?: number | null;
  siteWaitTimeMinutes?: number | null;
  pouringTimeMinutes?: number | null;
  leavingSiteTimeMinutes?: number | null;
  totalSiteTimeMinutes?: number | null;
  inboundTransitTimeMinutes?: number | null;
  totalCycleTimeMinutes?: number | null;
  deliveryManualTests?: Array<OrderSvcManualTest> | null;
  allowableWaterToAddLitres?: number | null;
  excessWaterAddedDuringBatchingLitres?: number | null;
  mixDesignCode?: string | null;
  docketTargetWeights?: DocketMixDesign | null;
  docketBatchedWeights?: DocketBatchedWeights | null;
  docketTestResults?: Array<DocketTestResult | null> | null;
  spinUpStatus?: string | null;
  spinUpStatusUpdateTime?: string | null;
  mediaCount?: number | null;
  commentCount?: number | null;
  comments?: Array<string> | null;
  spinUpStatusBeforeFirstNonSamplePour?: string | null;
  spinUpStatusBeforeLastSamplePour?: string | null;
  emptyDrumStage?: string | null;
  emptyDrumType?: string | null;
  emptyDrumTime?: string | null;
  truckConfig?: DocketTruckConfig | null;
  concreteVolumeM3AtPlantExit?: number | null;
  concreteVolumeM3AtSiteArrival?: number | null;
  concreteVolumeM3AtPour?: number | null;
  concreteVolumeM3AtSiteExit?: number | null;
  airPercentAtPlantExit?: number | null;
  airPercentAtSiteArrival?: number | null;
  airPercentAtPour?: number | null;
  airPercentAtSiteExit?: number | null;
  airPercentAtLoadMix?: number | null;
  weatherTempDegcAtPlant?: number | null;
  weatherCodeAtPlant?: number | null;
  weatherTempDegcAtSiteArrival?: number | null;
  weatherCodeAtSiteArrival?: number | null;
  deviceHealthStatus?: string | null;
};

export type DocketMixDesign = {
  __typename: "DocketMixDesign";
  maxWaterCementRatio?: number | null;
  aggregate?: Array<DocketAggregate | null> | null;
  fillers?: Array<DocketFiller | null> | null;
  water?: Array<DocketWater | null> | null;
  binders?: Array<DocketBinder | null> | null;
  admixture?: Array<DocketAdmixture | null> | null;
  reinforcement?: Array<DocketReinforcement | null> | null;
};

export type DocketAggregate = {
  __typename: "DocketAggregate";
  name?: string | null;
  type?: string | null;
  maxSizeMM?: string | null;
  value?: number | null;
  units?: string | null;
};

export type DocketFiller = {
  __typename: "DocketFiller";
  type?: string | null;
  value?: number | null;
  units?: string | null;
};

export type DocketWater = {
  __typename: "DocketWater";
  name?: string | null;
  value?: number | null;
  units?: string | null;
};

export type DocketBinder = {
  __typename: "DocketBinder";
  type?: string | null;
  value?: number | null;
  units?: string | null;
};

export type DocketAdmixture = {
  __typename: "DocketAdmixture";
  name?: string | null;
  value?: number | null;
  units?: string | null;
  type?: string | null;
};

export type DocketReinforcement = {
  __typename: "DocketReinforcement";
  name?: string | null;
  value?: number | null;
  units?: string | null;
};

export type DocketBatchedWeights = {
  __typename: "DocketBatchedWeights";
  aggregate?: Array<DocketAggregate | null> | null;
  fillers?: Array<DocketFiller | null> | null;
  water?: Array<DocketWater | null> | null;
  binders?: Array<DocketBinder | null> | null;
  admixture?: Array<DocketAdmixture | null> | null;
  reinforcement?: Array<DocketReinforcement | null> | null;
};

export type DocketTestResult = {
  __typename: "DocketTestResult";
  type?: string | null;
  value?: number | null;
  units?: string | null;
  datetimeUTC?: string | null;
};

export type DocketTruckConfig = {
  __typename: "DocketTruckConfig";
  physical?: DocketPhysicalTruckConfig | null;
  operations?: DocketOperationsTruckConfig | null;
  globalConfig?: DocketGlobalTruckConfig | null;
};

export type DocketPhysicalTruckConfig = {
  __typename: "DocketPhysicalTruckConfig";
  gearboxRatio?: number | null;
  hydraulicMotorDisplacementCc?: number | null;
  drumVolumeM3?: number | null;
  isChargingClockwise?: boolean | null;
  isPressureId1Charging?: boolean | null;
  isPressureBInsulated?: boolean | null;
  pressureSensorLocation?: string | null;
};

export type DocketOperationsTruckConfig = {
  __typename: "DocketOperationsTruckConfig";
  isDmTemperatureFault?: boolean | null;
  isDmFault?: boolean | null;
  isFmFault?: boolean | null;
  isCbFault?: boolean | null;
  isDmFitted?: boolean | null;
  isFmFitted?: boolean | null;
  maintenanceStatus?: string | null;
  cbMountingLocation?: string | null;
  cbMountingDirection?: string | null;
};

export type DocketGlobalTruckConfig = {
  __typename: "DocketGlobalTruckConfig";
  isWhitelisted?: boolean | null;
  isOffTheRoad?: boolean | null;
  isVirtual?: boolean | null;
  rpmSensor?: string | null;
  misc?: string | null;
  manufacturer?: string | null;
  model?: string | null;
  noConsistence?: boolean | null;
  noConsistenceDescription?: string | null;
};

export type CubeOrdersTrip = {
  __typename: "CubeOrdersTrip";
  rmcId?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  tripStartTime?: string | null;
  tripEndTime?: string | null;
  datetimeBatch?: string | null;
  slumpCode?: string | null;
  orderCode?: string | null;
  docketId?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  customerName?: string | null;
  deliveredQuantity?: number | null;
  plantCode?: string | null;
  plantName?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  pourTime?: string | null;
  pourEvents?: string | null;
  pourLocation?: string | null;
  siteLocation?: string | null;
  plantLocation?: string | null;
  loadingPoint?: string | null;
  leftBatchPlant?: string | null;
  arrivedAtSite?: string | null;
  leftSite?: string | null;
  consistenceMmAtLoadMix?: number | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtPour?: number | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  waterAdditions?: string | null;
  additionalWaterMeasured?: number | null;
  timezone?: string | null;
  tempAtLoadMix?: number | null;
  tempAtSiteArrival?: number | null;
  tempAtPour?: number | null;
  tempAtPlantExit?: number | null;
};

export type CubeOrdersDeliveryTimeseries = {
  __typename: "CubeOrdersDeliveryTimeseries";
  timeseries?: Array<Timeseries | null> | null;
};

export type Timeseries = {
  __typename: "Timeseries";
  timestamp?: string | null;
  geo?: string | null;
  rpm?: number | null;
  pressure?: number | null;
  pressureABarMean?: number | null;
  pressureBBarMean?: number | null;
  temp?: number | null;
  consistenceMm?: number | null;
  consistenceMmQualifier?: string | null;
  consistenceMinMm?: number | null;
  consistenceMaxMm?: number | null;
  rheometryPlasticViscosityPas?: number | null;
  rheometryStaticYieldStressPa?: number | null;
  gpsLongitudes?: string | null;
  gpsLatitudes?: string | null;
  percentAir?: number | null;
  concreteVolume?: number | null;
};

export enum OrderSortField {
  orderCode = "orderCode"
}

export enum SortDirection {
  asc = "asc",
  desc = "desc"
}

export type OrderSvcListOrdersResponse = {
  __typename: "OrderSvcListOrdersResponse";
  orders?: Array<OrderSvcListOrders> | null;
  cursor?: string | null;
};

export type OrderSvcListOrders = {
  __typename: "OrderSvcListOrders";
  rmcId?: string | null;
  orderCode?: string | null;
  slumpCode?: string | null;
  jobsiteDescription?: string | null;
  jobsiteCode?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  aggregateSize?: string | null;
  deliveryQuantity?: number | null;
  consistenceTarget?: number | null;
  consistenceClass?: string | null;
  rmcCustomerName?: string | null;
  deliveries?: number | null;
  volumeDelivered?: number | null;
  firstBatchingTimestamp?: string | null;
  lastBatchingTimestamp?: string | null;
  timezone?: string | null;
};

export enum DeliverySortField {
  orderCode = "orderCode",
  datetimeBatch = "datetimeBatch",
  docketId = "docketId",
  deliveredQuantity = "deliveredQuantity",
  tripStartTime = "tripStartTime",
  tripEndTime = "tripEndTime",
  leftBatchPlant = "leftBatchPlant",
  arrivedAtSite = "arrivedAtSite",
  leftSite = "leftSite",
  pourTime = "pourTime",
  commercialProductCode = "commercialProductCode",
  commercialProductDescription = "commercialProductDescription",
  truckPlate = "truckPlate",
  truckImei = "truckImei",
  slumpCode = "slumpCode",
  docketId1 = "docketId1",
  extTruckName = "extTruckName",
  technicalProductCode = "technicalProductCode",
  technicalProductDescription = "technicalProductDescription",
  plantCode = "plantCode",
  jobsiteCode = "jobsiteCode",
  jobsiteDescription = "jobsiteDescription",
  loadingPoint = "loadingPoint",
  consistenceMmAtLoadMix = "consistenceMmAtLoadMix",
  consistenceMmAtPlantExit = "consistenceMmAtPlantExit",
  consistenceMmAtSiteArrival = "consistenceMmAtSiteArrival",
  consistenceMmAtPour = "consistenceMmAtPour",
  consistenceClass = "consistenceClass",
  consistenceTarget = "consistenceTarget",
  consistenceStandard = "consistenceStandard",
  consistenceTestType = "consistenceTestType",
  customerName = "customerName",
  additionalWaterMeasured = "additionalWaterMeasured",
  additionalWaterDetected = "additionalWaterDetected",
  washoutWaterMeasured = "washoutWaterMeasured",
  additionalWaterPerM3 = "additionalWaterPerM3",
  midPourWaterAdded = "midPourWaterAdded",
  prePourWaterAdded = "prePourWaterAdded",
  unclassifiedWaterAdded = "unclassifiedWaterAdded",
  waterAddedAtPlant = "waterAddedAtPlant",
  tempAtLoadMix = "tempAtLoadMix",
  tempAtSiteArrival = "tempAtSiteArrival",
  tempAtPour = "tempAtPour",
  tempAtPlantExit = "tempAtPlantExit",
  consistencePredictionType = "consistencePredictionType",
  batchToDepartureTimeMinutes = "batchToDepartureTimeMinutes",
  outboundTransitTimeMinutes = "outboundTransitTimeMinutes",
  siteWaitTimeMinutes = "siteWaitTimeMinutes",
  pouringTimeMinutes = "pouringTimeMinutes",
  leavingSiteTimeMinutes = "leavingSiteTimeMinutes",
  totalSiteTimeMinutes = "totalSiteTimeMinutes",
  inboundTransitTimeMinutes = "inboundTransitTimeMinutes",
  totalCycleTimeMinutes = "totalCycleTimeMinutes",
  allowableWaterToAddLitres = "allowableWaterToAddLitres",
  mixDesignCode = "mixDesignCode",
  spinUpStatus = "spinUpStatus",
  mediaCount = "mediaCount",
  commentCount = "commentCount",
  spinUpStatusBeforeFirstNonSamplePour = "spinUpStatusBeforeFirstNonSamplePour",
  spinUpStatusBeforeLastSamplePour = "spinUpStatusBeforeLastSamplePour",
  excessWaterAddedDuringBatchingLitres = "excessWaterAddedDuringBatchingLitres",
  consistenceClassMax = "consistenceClassMax",
  consistenceClassMin = "consistenceClassMin",
  consistenceLowerLimitSpot = "consistenceLowerLimitSpot",
  consistenceUpperLimitSpot = "consistenceUpperLimitSpot",
  rheometryPlasticViscosityPasAtPlantExit = "rheometryPlasticViscosityPasAtPlantExit",
  rheometryPlasticViscosityPasAtSiteArrival = "rheometryPlasticViscosityPasAtSiteArrival",
  rheometryPlasticViscosityPasAtPour = "rheometryPlasticViscosityPasAtPour",
  rheometryPlasticViscosityPasPredictionType = "rheometryPlasticViscosityPasPredictionType",
  rheometryYieldStressPaAtPlantExit = "rheometryYieldStressPaAtPlantExit",
  rheometryYieldStressPaAtSiteArrival = "rheometryYieldStressPaAtSiteArrival",
  rheometryYieldStressPaAtPour = "rheometryYieldStressPaAtPour",
  rheometryYieldStressPaPredictionType = "rheometryYieldStressPaPredictionType",
  rheometryStaticYieldStressTargetMinPa = "rheometryStaticYieldStressTargetMinPa",
  rheometryStaticYieldStressTargetMaxPa = "rheometryStaticYieldStressTargetMaxPa",
  rheometryPlasticViscosityTargetMinPas = "rheometryPlasticViscosityTargetMinPas",
  rheometryPlasticViscosityTargetMaxPas = "rheometryPlasticViscosityTargetMaxPas",
  concreteVolumeM3AtPlantExit = "concreteVolumeM3AtPlantExit",
  concreteVolumeM3AtSiteArrival = "concreteVolumeM3AtSiteArrival",
  concreteVolumeM3AtPour = "concreteVolumeM3AtPour",
  concreteVolumeM3AtSiteExit = "concreteVolumeM3AtSiteExit",
  airPercentAtPlantExit = "airPercentAtPlantExit",
  airPercentAtSiteArrival = "airPercentAtSiteArrival",
  airPercentAtPour = "airPercentAtPour",
  airPercentAtSiteExit = "airPercentAtSiteExit",
  airPercentAtLoadMix = "airPercentAtLoadMix",
  weatherTempDegcAtPlant = "weatherTempDegcAtPlant",
  weatherTempDegcAtSiteArrival = "weatherTempDegcAtSiteArrival"
}

export type orderSvcDownloadDeliveriesSelectedFields = {
  fieldName: string;
  fieldHeader: string;
  dataType: ordeSvcFormattingDataType;
};

export enum ordeSvcFormattingDataType {
  date = "date",
  time = "time",
  temperature = "temperature",
  consistencePrediction = "consistencePrediction",
  string = "string",
  number = "number",
  waterVolume = "waterVolume"
}

export type orderSvcDownloadDeliveriesForRmcResponse = {
  __typename: "orderSvcDownloadDeliveriesForRmcResponse";
  jobId?: string | null;
};

export type OrderSvcDeliveryTimeseries = {
  __typename: "OrderSvcDeliveryTimeseries";
  timeseries?: Array<Timeseries | null> | null;
};

export type OrderSvcDocket = {
  __typename: "OrderSvcDocket";
  id?: string | null;
  rmcId?: string | null;
  status?: DocketStatus | null;
  docketId?: string | null;
  docketId1?: string | null;
  orderCode?: string | null;
  slumpCode?: string | null;
  slumpDescription?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  truckId?: number | null;
  truckImei?: string | null;
  truckReg?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  jobsiteLongitude?: number | null;
  jobsiteLatitude?: number | null;
  plantCode?: string | null;
  plantLongitude?: number | null;
  plantLatitude?: number | null;
  rmcCustomerId?: string | null;
  rmcCustomerName?: string | null;
  datetimeBatchLocal?: string | null;
  datetimeBatch?: string | null;
  aggregateSizeCode?: string | null;
  aggregateSizeDescription?: string | null;
  deliveredQuantity?: number | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  unitDescription?: string | null;
  unitCode?: string | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  consistenceClassMax?: number | null;
  consistenceClassMin?: number | null;
  consistenceStandard?: string | null;
  consistenceTestType?: string | null;
  consistenceLowerLimitSpot?: number | null;
  consistenceUpperLimitSpot?: number | null;
  allowableWaterToAddLitres?: number | null;
  excessWaterAddedDuringBatchingLitres?: number | null;
  mixDesignCode?: string | null;
  targetWeights?: DocketMixDesign | null;
  batchedWeights?: DocketBatchedWeights | null;
  testResults?: Array<DocketTestResult | null> | null;
  truckConfig?: DocketTruckConfig | null;
  timezone?: string | null;
  weatherTempDegcAtPlant?: number | null;
  weatherCodeAtPlant?: number | null;
};

export enum DocketStatus {
  UNKNOWN = "UNKNOWN",
  CANCELLED = "CANCELLED"
}

export type OrderSvcPourLocation = {
  __typename: "OrderSvcPourLocation";
  docketId?: string | null;
  pourLocation?: string | null;
  pourTime?: string | null;
};

export type OrderSvcDeliveryHealth = {
  __typename: "OrderSvcDeliveryHealth";
  checks?: string | null;
};

export type OrderSvcTags = {
  __typename: "OrderSvcTags";
  tags: Array<OrderSvcTag | null>;
  nextToken?: string | null;
};

export type OrderSvcListJobsitesResponse = {
  __typename: "OrderSvcListJobsitesResponse";
  jobsites?: Array<OrderSvcJobsite> | null;
  cursor?: string | null;
};

export type OrderSvcJobsite = {
  __typename: "OrderSvcJobsite";
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
};

export type OrderSvcListCustomersResponse = {
  __typename: "OrderSvcListCustomersResponse";
  customers?: Array<OrderSvcCustomer> | null;
  cursor?: string | null;
};

export type OrderSvcCustomer = {
  __typename: "OrderSvcCustomer";
  customerId: string;
  customerName: string;
};

export type OrderSvcGetManualTestMediaFileLinkResponse = {
  __typename: "OrderSvcGetManualTestMediaFileLinkResponse";
  mediaFileLink?: string | null;
};

export type OrderSvcListPendingManualTestsResponse = {
  __typename: "OrderSvcListPendingManualTestsResponse";
  manualTests: Array<OrderSvcManualTest>;
  cursor?: string | null;
};

export type SearchOrderSvcTripResponse = {
  __typename: "SearchOrderSvcTripResponse";
  deliveries?: Array<OrderSvcTrip> | null;
  cursor?: number | null;
  errors?: Array<string> | null;
};

export type OrderSvcListUserQueriesResponse = {
  __typename: "OrderSvcListUserQueriesResponse";
  queries: Array<OrderSvcUserQuery>;
  cursor?: string | null;
};

export type SearchOrderSvcOrderResponse = {
  __typename: "SearchOrderSvcOrderResponse";
  orders?: Array<OrderSvcListOrders> | null;
  cursor?: string | null;
  errors?: Array<string> | null;
};

export type ReportsResponse = {
  __typename: "ReportsResponse";
  success: boolean;
  item?: string | null;
  items?: Array<string> | null;
};

export type ListCognitoUsersOutput = {
  __typename: "ListCognitoUsersOutput";
  items: Array<CognitoUserDetail>;
};

export type GetCognitoUserOutput = {
  __typename: "GetCognitoUserOutput";
  user: CognitoUserDetail;
};

export type UserConnection = {
  __typename: "UserConnection";
  items: Array<User>;
  nextToken?: string | null;
};

export type GroupConnection = {
  __typename: "GroupConnection";
  items: Array<Group>;
  nextToken?: string | null;
};

export type RoleConnection = {
  __typename: "RoleConnection";
  items: Array<Role>;
  nextToken?: string | null;
};

export type AbilityConnection = {
  __typename: "AbilityConnection";
  items: Array<Ability>;
  nextToken?: string | null;
};

export type TaxonomyHierarchyRecord = {
  __typename: "TaxonomyHierarchyRecord";
  id: string;
  parentId?: string | null;
  rmc?: string | null;
  groupName?: string | null;
  groupType?: string | null;
  groupDescription?: string | null;
  batchPlantIds: Array<string>;
};

export type WeatherSvcWeatherData = {
  __typename: "WeatherSvcWeatherData";
  weatherTemp: number;
  weatherCode: number;
  weatherDesc: string;
};

export type LocationSvcGetLocationsForRMCProviderResponse = {
  __typename: "LocationSvcGetLocationsForRMCProviderResponse";
  items?: Array<Geolocation | null> | null;
  nextToken?: string | null;
};

export type BFDSvcImeiList = {
  __typename: "BFDSvcImeiList";
  items: Array<BFDSvcImei>;
  nextToken?: string | null;
};

export type BFDSvcImei = {
  __typename: "BFDSvcImei";
  imei: string;
};

export enum Granularity {
  week = "week",
  month = "month"
}

export type BatchingPerformanceDashboardResponse = {
  __typename: "BatchingPerformanceDashboardResponse";
  deliveries: Array<BatchingPerformanceDashboardDelivery>;
  metadata: BatchingPerformanceDashboardMetadata;
  thresholds: DashboardMetadataThresholds;
  plantLeaderboard?: DashboardPlantLeaderboard | null;
  plantPerformance?: DashboardPlantPerformance | null;
  plantPerformanceOverTime?: DashboardPlantPerformanceOverTime | null;
  periodOverPeriodChange?: DashboardPeriodOverPeriodChange | null;
  percentMixedAtPlant?: DashboardPercentMixedAtPlant | null;
};

export type BatchingPerformanceDashboardDelivery = {
  __typename: "BatchingPerformanceDashboardDelivery";
  rmcId: string;
  docketId: string;
  plantCode: string;
  plantName?: string | null;
  siteName?: string | null;
  consistenceClass?: string | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmQualifierAtPlantExit?: string | null;
  consistenceMmQualifierAtSiteArrival?: string | null;
  statusAtPlantExit?: PlantStatusAtDeliveryStage | null;
  statusAtSiteArrival?: PlantStatusAtDeliveryStage | null;
};

export enum PlantStatusAtDeliveryStage {
  on_target = "on_target",
  too_wet = "too_wet",
  too_dry = "too_dry"
}

export type BatchingPerformanceDashboardMetadata = {
  __typename: "BatchingPerformanceDashboardMetadata";
  granularity: Granularity;
  period: string;
  periodLabel: string;
  plantCodes: Array<string>;
  generatedAt: string;
  consistenceClassHistogramRange: Array<
    DashboardMetadataConsistenceClassRangeEntry
  >;
  consistenceTestTypeRange: DashboardMetadataConsistenceTestTypeRange;
};

export type DashboardMetadataConsistenceClassRangeEntry = {
  __typename: "DashboardMetadataConsistenceClassRangeEntry";
  consistenceClass: string;
  consistenceClassRange: DashboardMetadataConsistenceRangeEntry;
};

export type DashboardMetadataConsistenceRangeEntry = {
  __typename: "DashboardMetadataConsistenceRangeEntry";
  min_mm: number;
  max_mm: number;
};

export type DashboardMetadataConsistenceTestTypeRange = {
  __typename: "DashboardMetadataConsistenceTestTypeRange";
  slumpTest: DashboardMetadataConsistenceRangeEntry;
  flowTest: DashboardMetadataConsistenceRangeEntry;
  slumpflowTest: DashboardMetadataConsistenceRangeEntry;
};

export type DashboardMetadataThresholds = {
  __typename: "DashboardMetadataThresholds";
  plantPerformance: DashboardMetadataThresholdEntry;
  percentMixedAtPlant: DashboardMetadataThresholdEntry;
  periodOverPeriodChange: DashboardMetadataThresholdEntry;
};

export type DashboardMetadataThresholdEntry = {
  __typename: "DashboardMetadataThresholdEntry";
  metric: string;
  bands: Array<DashboardMetadataThresholdMetricEntry>;
};

export type DashboardMetadataThresholdMetricEntry = {
  __typename: "DashboardMetadataThresholdMetricEntry";
  status?: string | null;
  min: number;
  max: number;
};

export type DashboardPlantLeaderboard = {
  __typename: "DashboardPlantLeaderboard";
  maxScore: number;
  rankings: Array<DashboardPlantLeaderboardEntry>;
};

export type DashboardPlantLeaderboardEntry = {
  __typename: "DashboardPlantLeaderboardEntry";
  rank: number;
  plantCode: string;
  plantName?: string | null;
  score?: number | null;
};

export type DashboardPlantPerformance = {
  __typename: "DashboardPlantPerformance";
  unit: string;
  siteArrival: Array<DashboardPlantPerformanceEntry>;
  plantExit: Array<DashboardPlantPerformanceEntry>;
};

export type DashboardPlantPerformanceEntry = {
  __typename: "DashboardPlantPerformanceEntry";
  plantCode: string;
  plantName?: string | null;
  value: number;
  deliveriesWithDigitalConsistence: number;
};

export type DashboardPlantPerformanceOverTime = {
  __typename: "DashboardPlantPerformanceOverTime";
  unit: string;
  siteArrival: DashboardPerformanceOverTime;
  plantExit: DashboardPerformanceOverTime;
};

export type DashboardPerformanceOverTime = {
  __typename: "DashboardPerformanceOverTime";
  last6Weeks: DashboardPerformanceOverTimeForPlant;
  last6Months: DashboardPerformanceOverTimeForPlant;
};

export type DashboardPerformanceOverTimeForPlant = {
  __typename: "DashboardPerformanceOverTimeForPlant";
  all: Array<DashboardPerformanceOverTimeSeries>;
  byPlant: Array<DashboardPerformanceOverTimePlantEntry>;
};

export type DashboardPerformanceOverTimeSeries = {
  __typename: "DashboardPerformanceOverTimeSeries";
  key: string;
  label: string;
  points: Array<DashboardPerformanceOverTimePoint>;
};

export type DashboardPerformanceOverTimePoint = {
  __typename: "DashboardPerformanceOverTimePoint";
  bucket: string;
  bucketLabel: string;
  value: number;
  deliveriesWithDigitalConsistence: number;
};

export type DashboardPerformanceOverTimePlantEntry = {
  __typename: "DashboardPerformanceOverTimePlantEntry";
  plantCode: string;
  series: Array<DashboardPerformanceOverTimeSeries>;
};

export type DashboardPeriodOverPeriodChange = {
  __typename: "DashboardPeriodOverPeriodChange";
  unit: string;
  comparison: DashboardPeriodOverPeriodComparison;
  siteArrival: Array<DashboardPeriodOverPeriodChangeEntry>;
  plantExit: Array<DashboardPeriodOverPeriodChangeEntry>;
};

export type DashboardPeriodOverPeriodComparison = {
  __typename: "DashboardPeriodOverPeriodComparison";
  granularity: Granularity;
  currentPeriod: PeriodInfo;
  previousPeriod: PeriodInfo;
};

export type PeriodInfo = {
  __typename: "PeriodInfo";
  key: string;
  label: string;
};

export type DashboardPeriodOverPeriodChangeEntry = {
  __typename: "DashboardPeriodOverPeriodChangeEntry";
  plantCode: string;
  plantName?: string | null;
  value: number;
  currentValue: number;
  previousValue: number;
  deliveriesWithDigitalConsistence: number;
};

export type DashboardPercentMixedAtPlant = {
  __typename: "DashboardPercentMixedAtPlant";
  unit: string;
  values: Array<DashboardPlantPerformanceEntry>;
};

export type PutTruckMutation = {
  __typename: "Truck";
  RMCProviderName: string;
  IMEI: string;
  Date?: string | null;
  Location?: {
    __typename: "Location";
    lat: number;
    lng: number;
  } | null;
  Registration?: string | null;
  DrumStatus?: DrumStatus | null;
  DrumDirection?: string | null;
  DrumAverageRpm?: number | null;
  TruckStatus?: TruckStatus | null;
  SlumpDescription?: string | null;
  RunId?: string | null;
  DateBatchLocal?: string | null;
  PredictionTripPosixTimestampStart?: number | null;
  SystemDatetimeUtcStr?: string | null;
  SystemDatetimePosixUtcSeconds?: number | null;
};

export type UpdateLocationMutation = {
  __typename: "Truck";
  RMCProviderName: string;
  IMEI: string;
  Date?: string | null;
  Location?: {
    __typename: "Location";
    lat: number;
    lng: number;
  } | null;
  Registration?: string | null;
  DrumStatus?: DrumStatus | null;
  DrumDirection?: string | null;
  DrumAverageRpm?: number | null;
  TruckStatus?: TruckStatus | null;
  SlumpDescription?: string | null;
  RunId?: string | null;
  DateBatchLocal?: string | null;
  PredictionTripPosixTimestampStart?: number | null;
  SystemDatetimeUtcStr?: string | null;
  SystemDatetimePosixUtcSeconds?: number | null;
};

export type UpdateTruckMutation = {
  __typename: "Truck";
  RMCProviderName: string;
  IMEI: string;
  Date?: string | null;
  Location?: {
    __typename: "Location";
    lat: number;
    lng: number;
  } | null;
  Registration?: string | null;
  DrumStatus?: DrumStatus | null;
  DrumDirection?: string | null;
  DrumAverageRpm?: number | null;
  TruckStatus?: TruckStatus | null;
  SlumpDescription?: string | null;
  RunId?: string | null;
  DateBatchLocal?: string | null;
  PredictionTripPosixTimestampStart?: number | null;
  SystemDatetimeUtcStr?: string | null;
  SystemDatetimePosixUtcSeconds?: number | null;
};

export type PublishLoadingPointSpeedPatternMutation = {
  __typename: "LoadingPointSpeedPatternUpdate";
  imei: string;
  eventType?: string | null;
  rmcProvider: string;
  plantCode: string;
  loadingPoint: string;
  truckPlate?: string | null;
  datetimeBatch?: string | null;
  leftBatchPlant?: string | null;
  systemDatetimeUtcStr?: string | null;
  batchSpeedPattern?: string | null;
  batchSpeedPatternTime?: string | null;
  drumVectorRpm?: number | null;
};

export type PutTruckTimeseriesMutation = {
  __typename: "TruckTimeseries";
  imei: string;
  systemDatetimeUtcStr: string;
  gpsLatitudeDecimal?: number | null;
  gpsLongitudeDecimal?: number | null;
  gpsLatitudes?: string | null;
  gpsLongitudes?: string | null;
  pressureABarLowLatency?: number | null;
  pressureBBarLowLatency?: number | null;
  supplyVoltageMean?: number | null;
  drumVectorRpm?: number | null;
  temperatureModuleSurfaceTemperatureDegc?: number | null;
  temperatureModuleConcreteTemperatureDegc?: number | null;
  consistenceTestType?: string | null;
  consistenceMm?: number | null;
  consistenceMinMm?: number | null;
  consistenceMaxMm?: number | null;
  consistenceMmQualifier?: string | null;
  pressureABarMean?: number | null;
  pressureBBarMean?: number | null;
  co2?: number | null;
  rheometryPlasticViscosityPaS?: number | null;
  rheometryStaticYieldStressPa?: number | null;
  rheometryDynamicYieldStressPa?: number | null;
  percentAir?: number | null;
  concreteVolume?: number | null;
  delete_ttl?: number | null;
};

export type RecordLocationUpdateMutation = {
  __typename: "GeolocationItem";
  owner: string;
  owner_id: string;
  parent_id?: string | null;
  name?: string | null;
  type?: string | null;
  lng?: string | null;
  lat?: string | null;
  polygon?: string | null;
  status?: string | null;
  timezone?: string | null;
  timezone_date?: string | null;
  loading_points?: string | null;
  last_delivery_timestamp?: number | null;
};

export type TruckServiceUpdateTruckMutation = {
  __typename: "TruckRecord";
  truck_id?: number | null;
  ext_truck_id?: string | null;
  ext_truck_name?: string | null;
  rmc_provider: string;
  registration?: string | null;
  device_imei?: string | null;
  serial_no?: string | null;
  vin?: string | null;
  project?: string | null;
  valid_from?: string | null;
  valid_to?: string | null;
  config?: {
    __typename: "TruckConfig";
    physical?: {
      __typename: "TruckPhysicalConfig";
      gearbox_ratio?: number | null;
      hydraulic_motor_displacement_cc?: number | null;
      drum_volume_m3?: number | null;
      is_charging_clockwise?: boolean | null;
      is_pressure_id1_charging?: boolean | null;
      is_pressure_b_insulated?: boolean | null;
      pressure_sensor_location?: PressureSensorLocation | null;
    } | null;
    operations?: {
      __typename: "TruckOperationsConfig";
      is_fm_enabled?: boolean | null;
      is_pa_enabled?: boolean | null;
      is_pb_enabled?: boolean | null;
      is_smarthatch_enabled?: boolean | null;
      is_dm_temperature_fault?: boolean | null;
      is_dm_fault?: boolean | null;
      is_fm_fault?: boolean | null;
      is_pa_fault?: boolean | null;
      is_pb_fault?: boolean | null;
      is_cb_fault?: boolean | null;
      is_smarthatch_fault?: boolean | null;
      is_dm_fitted?: boolean | null;
      is_fm_fitted?: boolean | null;
      is_pa_fitted?: boolean | null;
      is_pb_fitted?: boolean | null;
      is_smarthatch_fitted?: boolean | null;
      maintenance_status?: string | null;
      cb_mounting_location?: CbMountingLocation | null;
      cb_mounting_direction?: CbMountingDirection | null;
    } | null;
    globalConfig?: {
      __typename: "TruckGlobalConfig";
      is_whitelisted?: boolean | null;
      is_off_the_road?: boolean | null;
      is_virtual?: boolean | null;
      misc?: string | null;
      manufacturer?: string | null;
      model?: string | null;
      no_consistence?: boolean | null;
      no_consistence_description?: string | null;
      rpm_sensor?: RpmSensor | null;
    } | null;
  } | null;
  permitted_rmcs: Array<string>;
};

export type TruckServiceSetRmcMutation = {
  __typename: "TruckRecord";
  truck_id?: number | null;
  ext_truck_id?: string | null;
  ext_truck_name?: string | null;
  rmc_provider: string;
  registration?: string | null;
  device_imei?: string | null;
  serial_no?: string | null;
  vin?: string | null;
  project?: string | null;
  valid_from?: string | null;
  valid_to?: string | null;
  config?: {
    __typename: "TruckConfig";
    physical?: {
      __typename: "TruckPhysicalConfig";
      gearbox_ratio?: number | null;
      hydraulic_motor_displacement_cc?: number | null;
      drum_volume_m3?: number | null;
      is_charging_clockwise?: boolean | null;
      is_pressure_id1_charging?: boolean | null;
      is_pressure_b_insulated?: boolean | null;
      pressure_sensor_location?: PressureSensorLocation | null;
    } | null;
    operations?: {
      __typename: "TruckOperationsConfig";
      is_fm_enabled?: boolean | null;
      is_pa_enabled?: boolean | null;
      is_pb_enabled?: boolean | null;
      is_smarthatch_enabled?: boolean | null;
      is_dm_temperature_fault?: boolean | null;
      is_dm_fault?: boolean | null;
      is_fm_fault?: boolean | null;
      is_pa_fault?: boolean | null;
      is_pb_fault?: boolean | null;
      is_cb_fault?: boolean | null;
      is_smarthatch_fault?: boolean | null;
      is_dm_fitted?: boolean | null;
      is_fm_fitted?: boolean | null;
      is_pa_fitted?: boolean | null;
      is_pb_fitted?: boolean | null;
      is_smarthatch_fitted?: boolean | null;
      maintenance_status?: string | null;
      cb_mounting_location?: CbMountingLocation | null;
      cb_mounting_direction?: CbMountingDirection | null;
    } | null;
    globalConfig?: {
      __typename: "TruckGlobalConfig";
      is_whitelisted?: boolean | null;
      is_off_the_road?: boolean | null;
      is_virtual?: boolean | null;
      misc?: string | null;
      manufacturer?: string | null;
      model?: string | null;
      no_consistence?: boolean | null;
      no_consistence_description?: string | null;
      rpm_sensor?: RpmSensor | null;
    } | null;
  } | null;
  permitted_rmcs: Array<string>;
};

export type TruckServiceSetImeisToForwardMutation = {
  __typename: "ImeisToForwardResponse";
  imeis: Array<string>;
};

export type TruckServiceSetTruckIdsToForwardMutation = {
  __typename: "TruckIdsToForwardResponse";
  truck_ids: Array<number>;
};

export type MediaSvcUploadSupplierFileMutation = {
  __typename: "MediaSvcUploadSupplierFileResponse";
  success: boolean;
  uploadUrl?: string | null;
  error?: string | null;
};

export type MediaSvcGetSupplierFileUrlMutation = {
  __typename: "MediaSvcGetSupplierFileUrlResponse";
  success: boolean;
  downloadUrl?: string | null;
  error?: string | null;
};

export type MediaSvcListSupplierFilesMutation = {
  __typename: "MediaSvcListSupplierFilesResponse";
  success: boolean;
  files?: Array<string> | null;
  error?: string | null;
};

export type OrderSvcReplayDeliveryMutation = {
  __typename: "ReplayResponse";
  message?: string | null;
};

export type TriggerLoadTestMutation = {
  __typename: "LoadTestResponse";
  message?: string | null;
};

export type OrderSvcNotifyDownloadFileCompleteMutation = {
  __typename: "OrderSvcDownloadFileCompleteNotification";
  jobId: string;
  status: string;
  csvFileLink?: string | null;
};

export type CreateOrderSvcTagMutation = {
  __typename: "OrderSvcTagMutationResponse";
  success: boolean;
  tag?: {
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
  error?: string | null;
};

export type UpdateOrderSvcTagMutation = {
  __typename: "OrderSvcTagMutationResponse";
  success: boolean;
  tag?: {
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
  error?: string | null;
};

export type DeleteOrderSvcTagMutation = {
  __typename: "OrderSvcTagMutationResponse";
  success: boolean;
  tag?: {
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
  error?: string | null;
};

export type AddTagToOrderSvcDeliveryMutation = {
  __typename: "OrderSvcTagMutationResponse";
  success: boolean;
  tag?: {
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
  error?: string | null;
};

export type RemoveTagFromOrderSvcDeliveryMutation = {
  __typename: "OrderSvcTagMutationResponse";
  success: boolean;
  tag?: {
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
  error?: string | null;
};

export type OrderSvcCreateManualTestMutation = {
  __typename: "OrderSvcCreateManualTestMutationResponse";
  success: boolean;
  manualTest?: {
    __typename: "OrderSvcManualTest";
    id: number;
    docketId: string;
    type: string;
    result: number;
    testResult: number;
    unit: string;
    testTime: string;
    createdBy: string;
    comment?: string | null;
    mediaS3Key?: string | null;
    accepted?: boolean | null;
    acceptanceReason?: string | null;
    reviewedBy?: string | null;
  } | null;
  uploadUrl?: string | null;
  uploadFields?: string | null;
  error?: string | null;
};

export type OrderSvcUpdateManualTestMutation = {
  __typename: "OrderSvcUpdateManualTestMutationResponse";
  success: boolean;
  manualTest?: {
    __typename: "OrderSvcManualTest";
    id: number;
    docketId: string;
    type: string;
    result: number;
    testResult: number;
    unit: string;
    testTime: string;
    createdBy: string;
    comment?: string | null;
    mediaS3Key?: string | null;
    accepted?: boolean | null;
    acceptanceReason?: string | null;
    reviewedBy?: string | null;
  } | null;
  error?: string | null;
};

export type OrderSvcEndDeliveryMutation = {
  __typename: "OrderSvcEndDeliveryMutationResponse";
  success: boolean;
  error?: string | null;
};

export type OrderSvcCreateUserQueryMutation = {
  __typename: "OrderSvcUserQueryMutationResponse";
  success: boolean;
  query?: {
    __typename: "OrderSvcUserQuery";
    id: number;
    name: string;
    type: OrderSvcUserQueryType;
    description?: string | null;
    usageCount: number;
    queryPayload: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  error?: string | null;
};

export type OrderSvcUpdateUserQueryMutation = {
  __typename: "OrderSvcUserQueryMutationResponse";
  success: boolean;
  query?: {
    __typename: "OrderSvcUserQuery";
    id: number;
    name: string;
    type: OrderSvcUserQueryType;
    description?: string | null;
    usageCount: number;
    queryPayload: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  error?: string | null;
};

export type OrderSvcDeleteUserQueryMutation = {
  __typename: "OrderSvcUserQueryMutationResponse";
  success: boolean;
  query?: {
    __typename: "OrderSvcUserQuery";
    id: number;
    name: string;
    type: OrderSvcUserQueryType;
    description?: string | null;
    usageCount: number;
    queryPayload: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  error?: string | null;
};

export type UserSvcUpdateUserMutation = {
  __typename: "UpdateCognitoUserOutput";
  success: boolean;
  statusCode: number;
};

export type UserSvcCreateUserMutation = {
  __typename: "CreateCognitoUserOutput";
  success: boolean;
  user?: {
    __typename: "CognitoUserDetail";
    username: string;
    email: string;
    phoneNumber: string;
    givenName?: string | null;
    familyName?: string | null;
    jobTitle?: string | null;
    status?: string | null;
    enabled?: boolean | null;
    groups?: Array<string> | null;
    created?: string | null;
    lastModified?: string | null;
  } | null;
  error: string;
};

export type UserSvcDeleteUserMutation = {
  __typename: "DeleteCognitoUserOutput";
  success: boolean;
  error: string;
};

export type UserSvcAddUserToGroupMutation = {
  __typename: "AddUserToCognitoGroupOutput";
  success: boolean;
};

export type UserSvcRemoveUserFromGroupMutation = {
  __typename: "RemoveUserFromCognitoGroupOutput";
  success: boolean;
};

export type UserSvcResetUserPasswordMutation = {
  __typename: "ResetUserPasswordOutput";
  success: boolean;
  error: string;
};

export type UserSvcResendInviteMutation = {
  __typename: "ResendInviteOutput";
  success: boolean;
  error: string;
};

export type UserSvcRbacCreateUserMutation = {
  __typename: "User";
  subId: string;
  tenant: string;
  firstName?: string | null;
  lastName?: string | null;
  groups: Array<{
    __typename: "Group";
    id: string;
    parentId?: string | null;
    tenant: string;
    name: string;
    description?: string | null;
    roles: Array<{
      __typename: "Role";
      id: string;
      name: string;
      description?: string | null;
      abilities: Array<{
        __typename: "Ability";
        id: string;
        action: string;
        subject: string;
        fields?: Array<string> | null;
        conditions?: string | null;
        inverted: boolean;
        description?: string | null;
        readonly: boolean;
      }>;
      readonly: boolean;
    }>;
  }>;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
};

export type UserSvcRbacUpdateUserMutation = {
  __typename: "User";
  subId: string;
  tenant: string;
  firstName?: string | null;
  lastName?: string | null;
  groups: Array<{
    __typename: "Group";
    id: string;
    parentId?: string | null;
    tenant: string;
    name: string;
    description?: string | null;
    roles: Array<{
      __typename: "Role";
      id: string;
      name: string;
      description?: string | null;
      abilities: Array<{
        __typename: "Ability";
        id: string;
        action: string;
        subject: string;
        fields?: Array<string> | null;
        conditions?: string | null;
        inverted: boolean;
        description?: string | null;
        readonly: boolean;
      }>;
      readonly: boolean;
    }>;
  }>;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
};

export type UserSvcRbacDeleteUserMutation = {
  __typename: "User";
  subId: string;
  tenant: string;
  firstName?: string | null;
  lastName?: string | null;
  groups: Array<{
    __typename: "Group";
    id: string;
    parentId?: string | null;
    tenant: string;
    name: string;
    description?: string | null;
    roles: Array<{
      __typename: "Role";
      id: string;
      name: string;
      description?: string | null;
      abilities: Array<{
        __typename: "Ability";
        id: string;
        action: string;
        subject: string;
        fields?: Array<string> | null;
        conditions?: string | null;
        inverted: boolean;
        description?: string | null;
        readonly: boolean;
      }>;
      readonly: boolean;
    }>;
  }>;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
};

export type UserSvcRbacCreateGroupMutation = {
  __typename: "Group";
  id: string;
  parentId?: string | null;
  tenant: string;
  name: string;
  description?: string | null;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
};

export type UserSvcRbacUpdateGroupMutation = {
  __typename: "Group";
  id: string;
  parentId?: string | null;
  tenant: string;
  name: string;
  description?: string | null;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
};

export type UserSvcRbacDeleteGroupMutation = {
  __typename: "Group";
  id: string;
  parentId?: string | null;
  tenant: string;
  name: string;
  description?: string | null;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
};

export type UserSvcRbacCreateRoleMutation = {
  __typename: "Role";
  id: string;
  name: string;
  description?: string | null;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
  readonly: boolean;
};

export type UserSvcRbacUpdateRoleMutation = {
  __typename: "Role";
  id: string;
  name: string;
  description?: string | null;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
  readonly: boolean;
};

export type UserSvcRbacDeleteRoleMutation = {
  __typename: "Role";
  id: string;
  name: string;
  description?: string | null;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
  readonly: boolean;
};

export type UserSvcRbacCreateAbilityMutation = {
  __typename: "Ability";
  id: string;
  action: string;
  subject: string;
  fields?: Array<string> | null;
  conditions?: string | null;
  inverted: boolean;
  description?: string | null;
  readonly: boolean;
};

export type UserSvcRbacUpdateAbilityMutation = {
  __typename: "Ability";
  id: string;
  action: string;
  subject: string;
  fields?: Array<string> | null;
  conditions?: string | null;
  inverted: boolean;
  description?: string | null;
  readonly: boolean;
};

export type UserSvcRbacDeleteAbilityMutation = {
  __typename: "Ability";
  id: string;
  action: string;
  subject: string;
  fields?: Array<string> | null;
  conditions?: string | null;
  inverted: boolean;
  description?: string | null;
  readonly: boolean;
};

export type UserSvcRbacAssignAbilitiesToRoleMutation = {
  __typename: "Role";
  id: string;
  name: string;
  description?: string | null;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
  readonly: boolean;
};

export type UserSvcRbacRemoveAbilitiesFromRoleMutation = {
  __typename: "Role";
  id: string;
  name: string;
  description?: string | null;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
  readonly: boolean;
};

export type UserSvcRbacAssignAbilitiesToUserMutation = {
  __typename: "User";
  subId: string;
  tenant: string;
  firstName?: string | null;
  lastName?: string | null;
  groups: Array<{
    __typename: "Group";
    id: string;
    parentId?: string | null;
    tenant: string;
    name: string;
    description?: string | null;
    roles: Array<{
      __typename: "Role";
      id: string;
      name: string;
      description?: string | null;
      abilities: Array<{
        __typename: "Ability";
        id: string;
        action: string;
        subject: string;
        fields?: Array<string> | null;
        conditions?: string | null;
        inverted: boolean;
        description?: string | null;
        readonly: boolean;
      }>;
      readonly: boolean;
    }>;
  }>;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
};

export type UserSvcRbacRemoveAbilitiesFromUserMutation = {
  __typename: "User";
  subId: string;
  tenant: string;
  firstName?: string | null;
  lastName?: string | null;
  groups: Array<{
    __typename: "Group";
    id: string;
    parentId?: string | null;
    tenant: string;
    name: string;
    description?: string | null;
    roles: Array<{
      __typename: "Role";
      id: string;
      name: string;
      description?: string | null;
      abilities: Array<{
        __typename: "Ability";
        id: string;
        action: string;
        subject: string;
        fields?: Array<string> | null;
        conditions?: string | null;
        inverted: boolean;
        description?: string | null;
        readonly: boolean;
      }>;
      readonly: boolean;
    }>;
  }>;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
};

export type UserSvcRbacBatchCreateUsersMutation = {
  __typename: "User";
  subId: string;
  tenant: string;
  firstName?: string | null;
  lastName?: string | null;
  groups: Array<{
    __typename: "Group";
    id: string;
    parentId?: string | null;
    tenant: string;
    name: string;
    description?: string | null;
    roles: Array<{
      __typename: "Role";
      id: string;
      name: string;
      description?: string | null;
      abilities: Array<{
        __typename: "Ability";
        id: string;
        action: string;
        subject: string;
        fields?: Array<string> | null;
        conditions?: string | null;
        inverted: boolean;
        description?: string | null;
        readonly: boolean;
      }>;
      readonly: boolean;
    }>;
  }>;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
};

export type UserSvcRbacBatchAssignRolesMutation = {
  __typename: "MutationResponse";
  success: boolean;
  errors?: Array<{
    __typename: "Error";
    code: ErrorCode;
    message: string;
    field?: string | null;
  }> | null;
};

export type UserSvcSendTrackingEventMutation = {
  __typename: "MutationResponse";
  success: boolean;
  errors?: Array<{
    __typename: "Error";
    code: ErrorCode;
    message: string;
    field?: string | null;
  }> | null;
};

export type LocationSvcPutTaxonomyRecordMutation = {
  __typename: "TaxonomyRecordOutput";
  id: string;
  parentId?: string | null;
  rmc: string;
  groupName: string;
  groupType: string;
  groupDescription: string;
};

export type LocationSvcUpdateLocationMutation = {
  __typename: "UpdateGeofenceResponse";
  success: boolean;
  location?: {
    __typename: "Geolocation";
    Owner: string;
    OwnerId: string;
    ParentId?: string | null;
    Name?: string | null;
    Type?: string | null;
    Lng?: string | null;
    Lat?: string | null;
    Polygon?: string | null;
    Status?: string | null;
    Timezone?: string | null;
    TimezoneDate?: string | null;
    LoadingPoints?: string | null;
    LastDeliveryTimestamp?: number | null;
  } | null;
};

export type LocationSvcUpdateLocationStatusMutation = {
  __typename: "UpdateGeofenceResponse";
  success: boolean;
  location?: {
    __typename: "Geolocation";
    Owner: string;
    OwnerId: string;
    ParentId?: string | null;
    Name?: string | null;
    Type?: string | null;
    Lng?: string | null;
    Lat?: string | null;
    Polygon?: string | null;
    Status?: string | null;
    Timezone?: string | null;
    TimezoneDate?: string | null;
    LoadingPoints?: string | null;
    LastDeliveryTimestamp?: number | null;
  } | null;
};

export type LocationSvcSaveLocationMutation = {
  __typename: "SaveGeofenceResponse";
  success: boolean;
  location?: {
    __typename: "GeolocationItem";
    owner: string;
    owner_id: string;
    parent_id?: string | null;
    name?: string | null;
    type?: string | null;
    lng?: string | null;
    lat?: string | null;
    polygon?: string | null;
    status?: string | null;
    timezone?: string | null;
    timezone_date?: string | null;
    loading_points?: string | null;
    last_delivery_timestamp?: number | null;
  } | null;
};

export type LocationSvcRecordLocationUpdateMutation = {
  __typename: "GeolocationItem";
  owner: string;
  owner_id: string;
  parent_id?: string | null;
  name?: string | null;
  type?: string | null;
  lng?: string | null;
  lat?: string | null;
  polygon?: string | null;
  status?: string | null;
  timezone?: string | null;
  timezone_date?: string | null;
  loading_points?: string | null;
  last_delivery_timestamp?: number | null;
};

export type DocketSvcPostDocketMutation = {
  __typename: "DocketSvcPostDocketResult";
  success: boolean;
  message: string;
  docketId?: string | null;
  ticketId?: string | null;
  errors?: Array<string> | null;
};

export type BfdSvcPutImeiMutation = {
  __typename: "BFDSvcImeiMutationResponse";
  success: boolean;
  message: string;
  imei?: string | null;
  errorCode?: string | null;
};

export type BfdSvcDeleteImeiMutation = {
  __typename: "BFDSvcImeiMutationResponse";
  success: boolean;
  message: string;
  imei?: string | null;
  errorCode?: string | null;
};

export type GetTruckTimeseriesQuery = {
  __typename: "TruckTimeseriesSpan";
  items?: Array<{
    __typename: "TruckTimeseries";
    imei: string;
    systemDatetimeUtcStr: string;
    gpsLatitudeDecimal?: number | null;
    gpsLongitudeDecimal?: number | null;
    gpsLatitudes?: string | null;
    gpsLongitudes?: string | null;
    pressureABarLowLatency?: number | null;
    pressureBBarLowLatency?: number | null;
    supplyVoltageMean?: number | null;
    drumVectorRpm?: number | null;
    temperatureModuleSurfaceTemperatureDegc?: number | null;
    temperatureModuleConcreteTemperatureDegc?: number | null;
    consistenceTestType?: string | null;
    consistenceMm?: number | null;
    consistenceMinMm?: number | null;
    consistenceMaxMm?: number | null;
    consistenceMmQualifier?: string | null;
    pressureABarMean?: number | null;
    pressureBBarMean?: number | null;
    co2?: number | null;
    rheometryPlasticViscosityPaS?: number | null;
    rheometryStaticYieldStressPa?: number | null;
    rheometryDynamicYieldStressPa?: number | null;
    percentAir?: number | null;
    concreteVolume?: number | null;
    delete_ttl?: number | null;
  } | null> | null;
  nextToken?: string | null;
};

export type GetTruckInformationSnapshotsQuery = {
  __typename: "TruckInformationSnapshotsConnection";
  items?: Array<{
    __typename: "TruckSnapshot";
    imei: string;
    eventType?: string | null;
    rmcProvider?: string | null;
    rmcCustomerId?: string | null;
    rmcCustomerName?: string | null;
    rmcAndCustomerId?: string | null;
    systemDatetimeUtcStr?: string | null;
    truckId?: number | null;
    truckPlate?: string | null;
    truckImei?: string | null;
    datetimeBatch?: string | null;
    slumpCode?: string | null;
    orderCode?: string | null;
    docketId?: string | null;
    docketId1?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    deliveredQuantity?: number | null;
    plantCode?: string | null;
    loadingPoint?: string | null;
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
    siteLocation?: string | null;
    plantLocation?: string | null;
    tripStartTime?: string | null;
    tripEndTime?: string | null;
    pourTime?: string | null;
    pourEvents?: string | null;
    pourLocation?: string | null;
    leftBatchPlant?: string | null;
    arrivedAtSite?: string | null;
    leftSite?: string | null;
    deliveryStartTime?: string | null;
    deliveryEndTime?: string | null;
    consistenceMmAtLoadMix?: number | null;
    consistenceMmAtLoadMixOk?: boolean | null;
    consistenceMmQualifierAtLoadMix?: string | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmAtPlantExitOk?: boolean | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtSiteArrivalOk?: boolean | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    consistenceMmAtPour?: number | null;
    consistenceMmAtPourOk?: boolean | null;
    consistenceMmQualifierAtPour?: string | null;
    siteWaitTimeSeconds?: number | null;
    siteTimeSeconds?: number | null;
    waterAdditions?: string | null;
    gpsLatitudeDecimal?: number | null;
    gpsLongitudeDecimal?: number | null;
    gpsLatitudes?: string | null;
    gpsLongitudes?: string | null;
    pressureABarLowLatency?: number | null;
    pressureBBarLowLatency?: number | null;
    supplyVoltageMean?: number | null;
    drumLowLatencyRpm?: number | null;
    drumVectorRpm?: number | null;
    temperatureModuleSurfaceTemperatureDegc?: number | null;
    temperatureModuleConcreteTemperatureDegc?: number | null;
    consistenceMmUtcStr?: string | null;
    consistenceMm?: number | null;
    consistenceMinMm?: number | null;
    consistenceMaxMm?: number | null;
    consistenceTestType?: string | null;
    pressureABarMean?: number | null;
    pressureBBarMean?: number | null;
    consistenceClass?: string | null;
    consistenceTarget?: number | null;
    consistenceClassMax?: number | null;
    consistenceClassMin?: number | null;
    consistenceLowerLimitSpot?: number | null;
    consistenceStandard?: string | null;
    consistenceUpperLimitSpot?: number | null;
    consistencePredictionType?: string | null;
    consistenceMmQualifier?: string | null;
    plantGeofenceIdMostRecent?: string | null;
    co2?: number | null;
    tempAtLoadMix?: number | null;
    tempAtPlantExit?: number | null;
    tempAtSiteArrival?: number | null;
    tempAtPour?: number | null;
    tz?: string | null;
    batchSpeedPattern?: string | null;
    batchSpeedPatternTime?: string | null;
    speedPatternAtSite?: string | null;
    speedPatternAtSiteTime?: string | null;
    rmcPlantCodeLoadingPoint?: string | null;
    rheometryPredictionType?: string | null;
    rheometryPlasticViscosityPaS?: number | null;
    rheometryStaticYieldStressPa?: number | null;
    rheometryDynamicYieldStressPa?: number | null;
    rheometryStaticYieldStressTargetMinPa?: number | null;
    rheometryStaticYieldStressTargetMaxPa?: number | null;
    rheometryPlasticViscosityTargetMinPas?: number | null;
    rheometryPlasticViscosityTargetMaxPas?: number | null;
    delete_ttl?: number | null;
    extTruckName?: string | null;
    extTruckId?: string | null;
    config?: string | null;
    inBatchPlant?: boolean | null;
    inSite?: boolean | null;
    canTrackGeo?: boolean | null;
    deliveryTags?: Array<string | null> | null;
    allowableWaterToAddLitres?: number | null;
    excessWaterAddedDuringBatchingLitres?: number | null;
    mixDesignCode?: string | null;
    maxWaterCementRatio?: number | null;
    spinUpStatus?: string | null;
    spinUpStatusUpdateTime?: string | null;
    emptyDrumStage?: string | null;
    emptyDrumType?: string | null;
    emptyDrumTime?: string | null;
    additionalWaterDetected?: boolean | null;
    washoutWaterMeasured?: number | null;
    additionalWaterPerM3?: number | null;
    midPourWaterAdded?: number | null;
    prePourWaterAdded?: number | null;
    unclassifiedWaterAdded?: number | null;
    waterAddedAtPlant?: number | null;
    additionalWaterMeasured?: number | null;
    percentAir?: number | null;
    concreteVolume?: number | null;
    concreteVolumeM3AtPlantExit?: number | null;
    concreteVolumeM3AtSiteArrival?: number | null;
    concreteVolumeM3AtPour?: number | null;
    concreteVolumeM3AtSiteExit?: number | null;
    airPercentAtPlantExit?: number | null;
    airPercentAtSiteArrival?: number | null;
    airPercentAtPour?: number | null;
    airPercentAtSiteExit?: number | null;
    airPercentAtLoadMix?: number | null;
    weatherTempDegcAtPlant?: number | null;
    weatherCodeAtPlant?: number | null;
    weatherTempDegcAtSiteArrival?: number | null;
    weatherCodeAtSiteArrival?: number | null;
    deviceHealthStatus?: string | null;
  } | null> | null;
  nextToken?: string | null;
  timestamp?: string | null;
};

export type GetPlantTruckSnapshotsQuery = {
  __typename: "TruckInformationSnapshotsConnection";
  items?: Array<{
    __typename: "TruckSnapshot";
    imei: string;
    eventType?: string | null;
    rmcProvider?: string | null;
    rmcCustomerId?: string | null;
    rmcCustomerName?: string | null;
    rmcAndCustomerId?: string | null;
    systemDatetimeUtcStr?: string | null;
    truckId?: number | null;
    truckPlate?: string | null;
    truckImei?: string | null;
    datetimeBatch?: string | null;
    slumpCode?: string | null;
    orderCode?: string | null;
    docketId?: string | null;
    docketId1?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    deliveredQuantity?: number | null;
    plantCode?: string | null;
    loadingPoint?: string | null;
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
    siteLocation?: string | null;
    plantLocation?: string | null;
    tripStartTime?: string | null;
    tripEndTime?: string | null;
    pourTime?: string | null;
    pourEvents?: string | null;
    pourLocation?: string | null;
    leftBatchPlant?: string | null;
    arrivedAtSite?: string | null;
    leftSite?: string | null;
    deliveryStartTime?: string | null;
    deliveryEndTime?: string | null;
    consistenceMmAtLoadMix?: number | null;
    consistenceMmAtLoadMixOk?: boolean | null;
    consistenceMmQualifierAtLoadMix?: string | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmAtPlantExitOk?: boolean | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtSiteArrivalOk?: boolean | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    consistenceMmAtPour?: number | null;
    consistenceMmAtPourOk?: boolean | null;
    consistenceMmQualifierAtPour?: string | null;
    siteWaitTimeSeconds?: number | null;
    siteTimeSeconds?: number | null;
    waterAdditions?: string | null;
    gpsLatitudeDecimal?: number | null;
    gpsLongitudeDecimal?: number | null;
    gpsLatitudes?: string | null;
    gpsLongitudes?: string | null;
    pressureABarLowLatency?: number | null;
    pressureBBarLowLatency?: number | null;
    supplyVoltageMean?: number | null;
    drumLowLatencyRpm?: number | null;
    drumVectorRpm?: number | null;
    temperatureModuleSurfaceTemperatureDegc?: number | null;
    temperatureModuleConcreteTemperatureDegc?: number | null;
    consistenceMmUtcStr?: string | null;
    consistenceMm?: number | null;
    consistenceMinMm?: number | null;
    consistenceMaxMm?: number | null;
    consistenceTestType?: string | null;
    pressureABarMean?: number | null;
    pressureBBarMean?: number | null;
    consistenceClass?: string | null;
    consistenceTarget?: number | null;
    consistenceClassMax?: number | null;
    consistenceClassMin?: number | null;
    consistenceLowerLimitSpot?: number | null;
    consistenceStandard?: string | null;
    consistenceUpperLimitSpot?: number | null;
    consistencePredictionType?: string | null;
    consistenceMmQualifier?: string | null;
    plantGeofenceIdMostRecent?: string | null;
    co2?: number | null;
    tempAtLoadMix?: number | null;
    tempAtPlantExit?: number | null;
    tempAtSiteArrival?: number | null;
    tempAtPour?: number | null;
    tz?: string | null;
    batchSpeedPattern?: string | null;
    batchSpeedPatternTime?: string | null;
    speedPatternAtSite?: string | null;
    speedPatternAtSiteTime?: string | null;
    rmcPlantCodeLoadingPoint?: string | null;
    rheometryPredictionType?: string | null;
    rheometryPlasticViscosityPaS?: number | null;
    rheometryStaticYieldStressPa?: number | null;
    rheometryDynamicYieldStressPa?: number | null;
    rheometryStaticYieldStressTargetMinPa?: number | null;
    rheometryStaticYieldStressTargetMaxPa?: number | null;
    rheometryPlasticViscosityTargetMinPas?: number | null;
    rheometryPlasticViscosityTargetMaxPas?: number | null;
    delete_ttl?: number | null;
    extTruckName?: string | null;
    extTruckId?: string | null;
    config?: string | null;
    inBatchPlant?: boolean | null;
    inSite?: boolean | null;
    canTrackGeo?: boolean | null;
    deliveryTags?: Array<string | null> | null;
    allowableWaterToAddLitres?: number | null;
    excessWaterAddedDuringBatchingLitres?: number | null;
    mixDesignCode?: string | null;
    maxWaterCementRatio?: number | null;
    spinUpStatus?: string | null;
    spinUpStatusUpdateTime?: string | null;
    emptyDrumStage?: string | null;
    emptyDrumType?: string | null;
    emptyDrumTime?: string | null;
    additionalWaterDetected?: boolean | null;
    washoutWaterMeasured?: number | null;
    additionalWaterPerM3?: number | null;
    midPourWaterAdded?: number | null;
    prePourWaterAdded?: number | null;
    unclassifiedWaterAdded?: number | null;
    waterAddedAtPlant?: number | null;
    additionalWaterMeasured?: number | null;
    percentAir?: number | null;
    concreteVolume?: number | null;
    concreteVolumeM3AtPlantExit?: number | null;
    concreteVolumeM3AtSiteArrival?: number | null;
    concreteVolumeM3AtPour?: number | null;
    concreteVolumeM3AtSiteExit?: number | null;
    airPercentAtPlantExit?: number | null;
    airPercentAtSiteArrival?: number | null;
    airPercentAtPour?: number | null;
    airPercentAtSiteExit?: number | null;
    airPercentAtLoadMix?: number | null;
    weatherTempDegcAtPlant?: number | null;
    weatherCodeAtPlant?: number | null;
    weatherTempDegcAtSiteArrival?: number | null;
    weatherCodeAtSiteArrival?: number | null;
    deviceHealthStatus?: string | null;
  } | null> | null;
  nextToken?: string | null;
  timestamp?: string | null;
};

export type GetJobsiteTruckSnapshotsQuery = {
  __typename: "TruckInformationSnapshotsConnection";
  items?: Array<{
    __typename: "TruckSnapshot";
    imei: string;
    eventType?: string | null;
    rmcProvider?: string | null;
    rmcCustomerId?: string | null;
    rmcCustomerName?: string | null;
    rmcAndCustomerId?: string | null;
    systemDatetimeUtcStr?: string | null;
    truckId?: number | null;
    truckPlate?: string | null;
    truckImei?: string | null;
    datetimeBatch?: string | null;
    slumpCode?: string | null;
    orderCode?: string | null;
    docketId?: string | null;
    docketId1?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    deliveredQuantity?: number | null;
    plantCode?: string | null;
    loadingPoint?: string | null;
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
    siteLocation?: string | null;
    plantLocation?: string | null;
    tripStartTime?: string | null;
    tripEndTime?: string | null;
    pourTime?: string | null;
    pourEvents?: string | null;
    pourLocation?: string | null;
    leftBatchPlant?: string | null;
    arrivedAtSite?: string | null;
    leftSite?: string | null;
    deliveryStartTime?: string | null;
    deliveryEndTime?: string | null;
    consistenceMmAtLoadMix?: number | null;
    consistenceMmAtLoadMixOk?: boolean | null;
    consistenceMmQualifierAtLoadMix?: string | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmAtPlantExitOk?: boolean | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtSiteArrivalOk?: boolean | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    consistenceMmAtPour?: number | null;
    consistenceMmAtPourOk?: boolean | null;
    consistenceMmQualifierAtPour?: string | null;
    siteWaitTimeSeconds?: number | null;
    siteTimeSeconds?: number | null;
    waterAdditions?: string | null;
    gpsLatitudeDecimal?: number | null;
    gpsLongitudeDecimal?: number | null;
    gpsLatitudes?: string | null;
    gpsLongitudes?: string | null;
    pressureABarLowLatency?: number | null;
    pressureBBarLowLatency?: number | null;
    supplyVoltageMean?: number | null;
    drumLowLatencyRpm?: number | null;
    drumVectorRpm?: number | null;
    temperatureModuleSurfaceTemperatureDegc?: number | null;
    temperatureModuleConcreteTemperatureDegc?: number | null;
    consistenceMmUtcStr?: string | null;
    consistenceMm?: number | null;
    consistenceMinMm?: number | null;
    consistenceMaxMm?: number | null;
    consistenceTestType?: string | null;
    pressureABarMean?: number | null;
    pressureBBarMean?: number | null;
    consistenceClass?: string | null;
    consistenceTarget?: number | null;
    consistenceClassMax?: number | null;
    consistenceClassMin?: number | null;
    consistenceLowerLimitSpot?: number | null;
    consistenceStandard?: string | null;
    consistenceUpperLimitSpot?: number | null;
    consistencePredictionType?: string | null;
    consistenceMmQualifier?: string | null;
    plantGeofenceIdMostRecent?: string | null;
    co2?: number | null;
    tempAtLoadMix?: number | null;
    tempAtPlantExit?: number | null;
    tempAtSiteArrival?: number | null;
    tempAtPour?: number | null;
    tz?: string | null;
    batchSpeedPattern?: string | null;
    batchSpeedPatternTime?: string | null;
    speedPatternAtSite?: string | null;
    speedPatternAtSiteTime?: string | null;
    rmcPlantCodeLoadingPoint?: string | null;
    rheometryPredictionType?: string | null;
    rheometryPlasticViscosityPaS?: number | null;
    rheometryStaticYieldStressPa?: number | null;
    rheometryDynamicYieldStressPa?: number | null;
    rheometryStaticYieldStressTargetMinPa?: number | null;
    rheometryStaticYieldStressTargetMaxPa?: number | null;
    rheometryPlasticViscosityTargetMinPas?: number | null;
    rheometryPlasticViscosityTargetMaxPas?: number | null;
    delete_ttl?: number | null;
    extTruckName?: string | null;
    extTruckId?: string | null;
    config?: string | null;
    inBatchPlant?: boolean | null;
    inSite?: boolean | null;
    canTrackGeo?: boolean | null;
    deliveryTags?: Array<string | null> | null;
    allowableWaterToAddLitres?: number | null;
    excessWaterAddedDuringBatchingLitres?: number | null;
    mixDesignCode?: string | null;
    maxWaterCementRatio?: number | null;
    spinUpStatus?: string | null;
    spinUpStatusUpdateTime?: string | null;
    emptyDrumStage?: string | null;
    emptyDrumType?: string | null;
    emptyDrumTime?: string | null;
    additionalWaterDetected?: boolean | null;
    washoutWaterMeasured?: number | null;
    additionalWaterPerM3?: number | null;
    midPourWaterAdded?: number | null;
    prePourWaterAdded?: number | null;
    unclassifiedWaterAdded?: number | null;
    waterAddedAtPlant?: number | null;
    additionalWaterMeasured?: number | null;
    percentAir?: number | null;
    concreteVolume?: number | null;
    concreteVolumeM3AtPlantExit?: number | null;
    concreteVolumeM3AtSiteArrival?: number | null;
    concreteVolumeM3AtPour?: number | null;
    concreteVolumeM3AtSiteExit?: number | null;
    airPercentAtPlantExit?: number | null;
    airPercentAtSiteArrival?: number | null;
    airPercentAtPour?: number | null;
    airPercentAtSiteExit?: number | null;
    airPercentAtLoadMix?: number | null;
    weatherTempDegcAtPlant?: number | null;
    weatherCodeAtPlant?: number | null;
    weatherTempDegcAtSiteArrival?: number | null;
    weatherCodeAtSiteArrival?: number | null;
    deviceHealthStatus?: string | null;
  } | null> | null;
  nextToken?: string | null;
  timestamp?: string | null;
};

export type GetCustomerTruckSnapshotsQuery = {
  __typename: "TruckInformationSnapshotsConnection";
  items?: Array<{
    __typename: "TruckSnapshot";
    imei: string;
    eventType?: string | null;
    rmcProvider?: string | null;
    rmcCustomerId?: string | null;
    rmcCustomerName?: string | null;
    rmcAndCustomerId?: string | null;
    systemDatetimeUtcStr?: string | null;
    truckId?: number | null;
    truckPlate?: string | null;
    truckImei?: string | null;
    datetimeBatch?: string | null;
    slumpCode?: string | null;
    orderCode?: string | null;
    docketId?: string | null;
    docketId1?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    deliveredQuantity?: number | null;
    plantCode?: string | null;
    loadingPoint?: string | null;
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
    siteLocation?: string | null;
    plantLocation?: string | null;
    tripStartTime?: string | null;
    tripEndTime?: string | null;
    pourTime?: string | null;
    pourEvents?: string | null;
    pourLocation?: string | null;
    leftBatchPlant?: string | null;
    arrivedAtSite?: string | null;
    leftSite?: string | null;
    deliveryStartTime?: string | null;
    deliveryEndTime?: string | null;
    consistenceMmAtLoadMix?: number | null;
    consistenceMmAtLoadMixOk?: boolean | null;
    consistenceMmQualifierAtLoadMix?: string | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmAtPlantExitOk?: boolean | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtSiteArrivalOk?: boolean | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    consistenceMmAtPour?: number | null;
    consistenceMmAtPourOk?: boolean | null;
    consistenceMmQualifierAtPour?: string | null;
    siteWaitTimeSeconds?: number | null;
    siteTimeSeconds?: number | null;
    waterAdditions?: string | null;
    gpsLatitudeDecimal?: number | null;
    gpsLongitudeDecimal?: number | null;
    gpsLatitudes?: string | null;
    gpsLongitudes?: string | null;
    pressureABarLowLatency?: number | null;
    pressureBBarLowLatency?: number | null;
    supplyVoltageMean?: number | null;
    drumLowLatencyRpm?: number | null;
    drumVectorRpm?: number | null;
    temperatureModuleSurfaceTemperatureDegc?: number | null;
    temperatureModuleConcreteTemperatureDegc?: number | null;
    consistenceMmUtcStr?: string | null;
    consistenceMm?: number | null;
    consistenceMinMm?: number | null;
    consistenceMaxMm?: number | null;
    consistenceTestType?: string | null;
    pressureABarMean?: number | null;
    pressureBBarMean?: number | null;
    consistenceClass?: string | null;
    consistenceTarget?: number | null;
    consistenceClassMax?: number | null;
    consistenceClassMin?: number | null;
    consistenceLowerLimitSpot?: number | null;
    consistenceStandard?: string | null;
    consistenceUpperLimitSpot?: number | null;
    consistencePredictionType?: string | null;
    consistenceMmQualifier?: string | null;
    plantGeofenceIdMostRecent?: string | null;
    co2?: number | null;
    tempAtLoadMix?: number | null;
    tempAtPlantExit?: number | null;
    tempAtSiteArrival?: number | null;
    tempAtPour?: number | null;
    tz?: string | null;
    batchSpeedPattern?: string | null;
    batchSpeedPatternTime?: string | null;
    speedPatternAtSite?: string | null;
    speedPatternAtSiteTime?: string | null;
    rmcPlantCodeLoadingPoint?: string | null;
    rheometryPredictionType?: string | null;
    rheometryPlasticViscosityPaS?: number | null;
    rheometryStaticYieldStressPa?: number | null;
    rheometryDynamicYieldStressPa?: number | null;
    rheometryStaticYieldStressTargetMinPa?: number | null;
    rheometryStaticYieldStressTargetMaxPa?: number | null;
    rheometryPlasticViscosityTargetMinPas?: number | null;
    rheometryPlasticViscosityTargetMaxPas?: number | null;
    delete_ttl?: number | null;
    extTruckName?: string | null;
    extTruckId?: string | null;
    config?: string | null;
    inBatchPlant?: boolean | null;
    inSite?: boolean | null;
    canTrackGeo?: boolean | null;
    deliveryTags?: Array<string | null> | null;
    allowableWaterToAddLitres?: number | null;
    excessWaterAddedDuringBatchingLitres?: number | null;
    mixDesignCode?: string | null;
    maxWaterCementRatio?: number | null;
    spinUpStatus?: string | null;
    spinUpStatusUpdateTime?: string | null;
    emptyDrumStage?: string | null;
    emptyDrumType?: string | null;
    emptyDrumTime?: string | null;
    additionalWaterDetected?: boolean | null;
    washoutWaterMeasured?: number | null;
    additionalWaterPerM3?: number | null;
    midPourWaterAdded?: number | null;
    prePourWaterAdded?: number | null;
    unclassifiedWaterAdded?: number | null;
    waterAddedAtPlant?: number | null;
    additionalWaterMeasured?: number | null;
    percentAir?: number | null;
    concreteVolume?: number | null;
    concreteVolumeM3AtPlantExit?: number | null;
    concreteVolumeM3AtSiteArrival?: number | null;
    concreteVolumeM3AtPour?: number | null;
    concreteVolumeM3AtSiteExit?: number | null;
    airPercentAtPlantExit?: number | null;
    airPercentAtSiteArrival?: number | null;
    airPercentAtPour?: number | null;
    airPercentAtSiteExit?: number | null;
    airPercentAtLoadMix?: number | null;
    weatherTempDegcAtPlant?: number | null;
    weatherCodeAtPlant?: number | null;
    weatherTempDegcAtSiteArrival?: number | null;
    weatherCodeAtSiteArrival?: number | null;
    deviceHealthStatus?: string | null;
  } | null> | null;
  nextToken?: string | null;
  timestamp?: string | null;
};

export type GetLoadingPointTruckSnapshotsQuery = {
  __typename: "TruckInformationSnapshotsConnection";
  items?: Array<{
    __typename: "TruckSnapshot";
    imei: string;
    eventType?: string | null;
    rmcProvider?: string | null;
    rmcCustomerId?: string | null;
    rmcCustomerName?: string | null;
    rmcAndCustomerId?: string | null;
    systemDatetimeUtcStr?: string | null;
    truckId?: number | null;
    truckPlate?: string | null;
    truckImei?: string | null;
    datetimeBatch?: string | null;
    slumpCode?: string | null;
    orderCode?: string | null;
    docketId?: string | null;
    docketId1?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    deliveredQuantity?: number | null;
    plantCode?: string | null;
    loadingPoint?: string | null;
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
    siteLocation?: string | null;
    plantLocation?: string | null;
    tripStartTime?: string | null;
    tripEndTime?: string | null;
    pourTime?: string | null;
    pourEvents?: string | null;
    pourLocation?: string | null;
    leftBatchPlant?: string | null;
    arrivedAtSite?: string | null;
    leftSite?: string | null;
    deliveryStartTime?: string | null;
    deliveryEndTime?: string | null;
    consistenceMmAtLoadMix?: number | null;
    consistenceMmAtLoadMixOk?: boolean | null;
    consistenceMmQualifierAtLoadMix?: string | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmAtPlantExitOk?: boolean | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtSiteArrivalOk?: boolean | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    consistenceMmAtPour?: number | null;
    consistenceMmAtPourOk?: boolean | null;
    consistenceMmQualifierAtPour?: string | null;
    siteWaitTimeSeconds?: number | null;
    siteTimeSeconds?: number | null;
    waterAdditions?: string | null;
    gpsLatitudeDecimal?: number | null;
    gpsLongitudeDecimal?: number | null;
    gpsLatitudes?: string | null;
    gpsLongitudes?: string | null;
    pressureABarLowLatency?: number | null;
    pressureBBarLowLatency?: number | null;
    supplyVoltageMean?: number | null;
    drumLowLatencyRpm?: number | null;
    drumVectorRpm?: number | null;
    temperatureModuleSurfaceTemperatureDegc?: number | null;
    temperatureModuleConcreteTemperatureDegc?: number | null;
    consistenceMmUtcStr?: string | null;
    consistenceMm?: number | null;
    consistenceMinMm?: number | null;
    consistenceMaxMm?: number | null;
    consistenceTestType?: string | null;
    pressureABarMean?: number | null;
    pressureBBarMean?: number | null;
    consistenceClass?: string | null;
    consistenceTarget?: number | null;
    consistenceClassMax?: number | null;
    consistenceClassMin?: number | null;
    consistenceLowerLimitSpot?: number | null;
    consistenceStandard?: string | null;
    consistenceUpperLimitSpot?: number | null;
    consistencePredictionType?: string | null;
    consistenceMmQualifier?: string | null;
    plantGeofenceIdMostRecent?: string | null;
    co2?: number | null;
    tempAtLoadMix?: number | null;
    tempAtPlantExit?: number | null;
    tempAtSiteArrival?: number | null;
    tempAtPour?: number | null;
    tz?: string | null;
    batchSpeedPattern?: string | null;
    batchSpeedPatternTime?: string | null;
    speedPatternAtSite?: string | null;
    speedPatternAtSiteTime?: string | null;
    rmcPlantCodeLoadingPoint?: string | null;
    rheometryPredictionType?: string | null;
    rheometryPlasticViscosityPaS?: number | null;
    rheometryStaticYieldStressPa?: number | null;
    rheometryDynamicYieldStressPa?: number | null;
    rheometryStaticYieldStressTargetMinPa?: number | null;
    rheometryStaticYieldStressTargetMaxPa?: number | null;
    rheometryPlasticViscosityTargetMinPas?: number | null;
    rheometryPlasticViscosityTargetMaxPas?: number | null;
    delete_ttl?: number | null;
    extTruckName?: string | null;
    extTruckId?: string | null;
    config?: string | null;
    inBatchPlant?: boolean | null;
    inSite?: boolean | null;
    canTrackGeo?: boolean | null;
    deliveryTags?: Array<string | null> | null;
    allowableWaterToAddLitres?: number | null;
    excessWaterAddedDuringBatchingLitres?: number | null;
    mixDesignCode?: string | null;
    maxWaterCementRatio?: number | null;
    spinUpStatus?: string | null;
    spinUpStatusUpdateTime?: string | null;
    emptyDrumStage?: string | null;
    emptyDrumType?: string | null;
    emptyDrumTime?: string | null;
    additionalWaterDetected?: boolean | null;
    washoutWaterMeasured?: number | null;
    additionalWaterPerM3?: number | null;
    midPourWaterAdded?: number | null;
    prePourWaterAdded?: number | null;
    unclassifiedWaterAdded?: number | null;
    waterAddedAtPlant?: number | null;
    additionalWaterMeasured?: number | null;
    percentAir?: number | null;
    concreteVolume?: number | null;
    concreteVolumeM3AtPlantExit?: number | null;
    concreteVolumeM3AtSiteArrival?: number | null;
    concreteVolumeM3AtPour?: number | null;
    concreteVolumeM3AtSiteExit?: number | null;
    airPercentAtPlantExit?: number | null;
    airPercentAtSiteArrival?: number | null;
    airPercentAtPour?: number | null;
    airPercentAtSiteExit?: number | null;
    airPercentAtLoadMix?: number | null;
    weatherTempDegcAtPlant?: number | null;
    weatherCodeAtPlant?: number | null;
    weatherTempDegcAtSiteArrival?: number | null;
    weatherCodeAtSiteArrival?: number | null;
    deviceHealthStatus?: string | null;
  } | null> | null;
  nextToken?: string | null;
  timestamp?: string | null;
};

export type GetTruckSnapshotsByTruckIdQuery = {
  __typename: "TruckInformationSnapshotsConnection";
  items?: Array<{
    __typename: "TruckSnapshot";
    imei: string;
    eventType?: string | null;
    rmcProvider?: string | null;
    rmcCustomerId?: string | null;
    rmcCustomerName?: string | null;
    rmcAndCustomerId?: string | null;
    systemDatetimeUtcStr?: string | null;
    truckId?: number | null;
    truckPlate?: string | null;
    truckImei?: string | null;
    datetimeBatch?: string | null;
    slumpCode?: string | null;
    orderCode?: string | null;
    docketId?: string | null;
    docketId1?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    deliveredQuantity?: number | null;
    plantCode?: string | null;
    loadingPoint?: string | null;
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
    siteLocation?: string | null;
    plantLocation?: string | null;
    tripStartTime?: string | null;
    tripEndTime?: string | null;
    pourTime?: string | null;
    pourEvents?: string | null;
    pourLocation?: string | null;
    leftBatchPlant?: string | null;
    arrivedAtSite?: string | null;
    leftSite?: string | null;
    deliveryStartTime?: string | null;
    deliveryEndTime?: string | null;
    consistenceMmAtLoadMix?: number | null;
    consistenceMmAtLoadMixOk?: boolean | null;
    consistenceMmQualifierAtLoadMix?: string | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmAtPlantExitOk?: boolean | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtSiteArrivalOk?: boolean | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    consistenceMmAtPour?: number | null;
    consistenceMmAtPourOk?: boolean | null;
    consistenceMmQualifierAtPour?: string | null;
    siteWaitTimeSeconds?: number | null;
    siteTimeSeconds?: number | null;
    waterAdditions?: string | null;
    gpsLatitudeDecimal?: number | null;
    gpsLongitudeDecimal?: number | null;
    gpsLatitudes?: string | null;
    gpsLongitudes?: string | null;
    pressureABarLowLatency?: number | null;
    pressureBBarLowLatency?: number | null;
    supplyVoltageMean?: number | null;
    drumLowLatencyRpm?: number | null;
    drumVectorRpm?: number | null;
    temperatureModuleSurfaceTemperatureDegc?: number | null;
    temperatureModuleConcreteTemperatureDegc?: number | null;
    consistenceMmUtcStr?: string | null;
    consistenceMm?: number | null;
    consistenceMinMm?: number | null;
    consistenceMaxMm?: number | null;
    consistenceTestType?: string | null;
    pressureABarMean?: number | null;
    pressureBBarMean?: number | null;
    consistenceClass?: string | null;
    consistenceTarget?: number | null;
    consistenceClassMax?: number | null;
    consistenceClassMin?: number | null;
    consistenceLowerLimitSpot?: number | null;
    consistenceStandard?: string | null;
    consistenceUpperLimitSpot?: number | null;
    consistencePredictionType?: string | null;
    consistenceMmQualifier?: string | null;
    plantGeofenceIdMostRecent?: string | null;
    co2?: number | null;
    tempAtLoadMix?: number | null;
    tempAtPlantExit?: number | null;
    tempAtSiteArrival?: number | null;
    tempAtPour?: number | null;
    tz?: string | null;
    batchSpeedPattern?: string | null;
    batchSpeedPatternTime?: string | null;
    speedPatternAtSite?: string | null;
    speedPatternAtSiteTime?: string | null;
    rmcPlantCodeLoadingPoint?: string | null;
    rheometryPredictionType?: string | null;
    rheometryPlasticViscosityPaS?: number | null;
    rheometryStaticYieldStressPa?: number | null;
    rheometryDynamicYieldStressPa?: number | null;
    rheometryStaticYieldStressTargetMinPa?: number | null;
    rheometryStaticYieldStressTargetMaxPa?: number | null;
    rheometryPlasticViscosityTargetMinPas?: number | null;
    rheometryPlasticViscosityTargetMaxPas?: number | null;
    delete_ttl?: number | null;
    extTruckName?: string | null;
    extTruckId?: string | null;
    config?: string | null;
    inBatchPlant?: boolean | null;
    inSite?: boolean | null;
    canTrackGeo?: boolean | null;
    deliveryTags?: Array<string | null> | null;
    allowableWaterToAddLitres?: number | null;
    excessWaterAddedDuringBatchingLitres?: number | null;
    mixDesignCode?: string | null;
    maxWaterCementRatio?: number | null;
    spinUpStatus?: string | null;
    spinUpStatusUpdateTime?: string | null;
    emptyDrumStage?: string | null;
    emptyDrumType?: string | null;
    emptyDrumTime?: string | null;
    additionalWaterDetected?: boolean | null;
    washoutWaterMeasured?: number | null;
    additionalWaterPerM3?: number | null;
    midPourWaterAdded?: number | null;
    prePourWaterAdded?: number | null;
    unclassifiedWaterAdded?: number | null;
    waterAddedAtPlant?: number | null;
    additionalWaterMeasured?: number | null;
    percentAir?: number | null;
    concreteVolume?: number | null;
    concreteVolumeM3AtPlantExit?: number | null;
    concreteVolumeM3AtSiteArrival?: number | null;
    concreteVolumeM3AtPour?: number | null;
    concreteVolumeM3AtSiteExit?: number | null;
    airPercentAtPlantExit?: number | null;
    airPercentAtSiteArrival?: number | null;
    airPercentAtPour?: number | null;
    airPercentAtSiteExit?: number | null;
    airPercentAtLoadMix?: number | null;
    weatherTempDegcAtPlant?: number | null;
    weatherCodeAtPlant?: number | null;
    weatherTempDegcAtSiteArrival?: number | null;
    weatherCodeAtSiteArrival?: number | null;
    deviceHealthStatus?: string | null;
  } | null> | null;
  nextToken?: string | null;
  timestamp?: string | null;
};

export type TruckServiceGetAllDevicesQuery = {
  __typename: "DeviceRecordList";
  items?: Array<{
    __typename: "DeviceRecordListItem";
    imei: string;
    serialNumber?: string | null;
    hostosVersion?: string | null;
    hardwareVersion?: string | null;
    applicationVersion?: string | null;
    systemUpTimeSeconds?: number | null;
    connectionLastReceived?: number | null;
  } | null> | null;
  lastEvaluatedKey?: string | null;
};

export type TruckServiceRequestAuditUploadQuery = {
  __typename: "AuditResponse";
  item?: string | null;
  items?: Array<string | null> | null;
};

export type TruckServiceListTruckAuditsQuery = {
  __typename: "AuditResponse";
  item?: string | null;
  items?: Array<string | null> | null;
};

export type TruckServiceGetTruckAuditQuery = {
  __typename: "AuditResponse";
  item?: string | null;
  items?: Array<string | null> | null;
};

export type TruckServiceRequestAuditFileLinkQuery = {
  __typename: "AuditResponse";
  item?: string | null;
  items?: Array<string | null> | null;
};

export type TruckServiceGetAllTrucksQuery = {
  __typename: "TruckRecordList";
  items?: Array<{
    __typename: "TruckRecordListItem";
    truckId?: number | null;
    rmcProvider: string;
    registration?: string | null;
    deviceImei?: string | null;
    serialNo?: string | null;
    vin?: string | null;
    project?: string | null;
    permitted_rmcs: Array<string>;
  } | null> | null;
  lastEvaluatedKey?: string | null;
};

export type TruckServiceGetLatestSlosQuery = {
  __typename: "SloRecordList";
  items?: Array<{
    __typename: "SloRecord";
    ts?: number | null;
    imei?: string | null;
    slo_type?: string | null;
    slo_metrics?: {
      __typename: "SloMetrics";
      connection?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      dockets?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      drum_module?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      pressure?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      water_flowmeter?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
    } | null;
    metadata?: {
      __typename: "SloMetadata";
      truck_id?: number | null;
      registration?: string | null;
      rmc_provider: string;
      application_version?: string | null;
      hardware_version?: string | null;
      host_os_version?: string | null;
      imsi?: string | null;
      serial_number?: number | null;
      system_up_time_seconds?: number | null;
    } | null;
    delete_ttl?: number | null;
  } | null> | null;
  lastEvaluatedKey?: string | null;
};

export type TruckServiceListLatestSlosQuery = {
  __typename: "SloRecordList";
  items?: Array<{
    __typename: "SloRecord";
    ts?: number | null;
    imei?: string | null;
    slo_type?: string | null;
    slo_metrics?: {
      __typename: "SloMetrics";
      connection?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      dockets?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      drum_module?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      pressure?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      water_flowmeter?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
    } | null;
    metadata?: {
      __typename: "SloMetadata";
      truck_id?: number | null;
      registration?: string | null;
      rmc_provider: string;
      application_version?: string | null;
      hardware_version?: string | null;
      host_os_version?: string | null;
      imsi?: string | null;
      serial_number?: number | null;
      system_up_time_seconds?: number | null;
    } | null;
    delete_ttl?: number | null;
  } | null> | null;
  lastEvaluatedKey?: string | null;
};

export type TruckServiceSearchLatestSloQuery = {
  __typename: "SloRecord";
  ts?: number | null;
  imei?: string | null;
  slo_type?: string | null;
  slo_metrics?: {
    __typename: "SloMetrics";
    connection?: {
      __typename: "SloMetricDetails";
      slo?: string | null;
      details?: string | null;
      sli_metrics?: Array<{
        __typename: "SliMetric";
        sli_name?: string | null;
        sli_status?: string | null;
        sli_reason?: string | null;
      } | null> | null;
    } | null;
    dockets?: {
      __typename: "SloMetricDetails";
      slo?: string | null;
      details?: string | null;
      sli_metrics?: Array<{
        __typename: "SliMetric";
        sli_name?: string | null;
        sli_status?: string | null;
        sli_reason?: string | null;
      } | null> | null;
    } | null;
    drum_module?: {
      __typename: "SloMetricDetails";
      slo?: string | null;
      details?: string | null;
      sli_metrics?: Array<{
        __typename: "SliMetric";
        sli_name?: string | null;
        sli_status?: string | null;
        sli_reason?: string | null;
      } | null> | null;
    } | null;
    pressure?: {
      __typename: "SloMetricDetails";
      slo?: string | null;
      details?: string | null;
      sli_metrics?: Array<{
        __typename: "SliMetric";
        sli_name?: string | null;
        sli_status?: string | null;
        sli_reason?: string | null;
      } | null> | null;
    } | null;
    water_flowmeter?: {
      __typename: "SloMetricDetails";
      slo?: string | null;
      details?: string | null;
      sli_metrics?: Array<{
        __typename: "SliMetric";
        sli_name?: string | null;
        sli_status?: string | null;
        sli_reason?: string | null;
      } | null> | null;
    } | null;
  } | null;
  metadata?: {
    __typename: "SloMetadata";
    truck_id?: number | null;
    registration?: string | null;
    rmc_provider: string;
    application_version?: string | null;
    hardware_version?: string | null;
    host_os_version?: string | null;
    imsi?: string | null;
    serial_number?: number | null;
    system_up_time_seconds?: number | null;
  } | null;
  delete_ttl?: number | null;
};

export type TruckServiceGetTruckSlosQuery = {
  __typename: "SloRecordList";
  items?: Array<{
    __typename: "SloRecord";
    ts?: number | null;
    imei?: string | null;
    slo_type?: string | null;
    slo_metrics?: {
      __typename: "SloMetrics";
      connection?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      dockets?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      drum_module?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      pressure?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
      water_flowmeter?: {
        __typename: "SloMetricDetails";
        slo?: string | null;
        details?: string | null;
        sli_metrics?: Array<{
          __typename: "SliMetric";
          sli_name?: string | null;
          sli_status?: string | null;
          sli_reason?: string | null;
        } | null> | null;
      } | null;
    } | null;
    metadata?: {
      __typename: "SloMetadata";
      truck_id?: number | null;
      registration?: string | null;
      rmc_provider: string;
      application_version?: string | null;
      hardware_version?: string | null;
      host_os_version?: string | null;
      imsi?: string | null;
      serial_number?: number | null;
      system_up_time_seconds?: number | null;
    } | null;
    delete_ttl?: number | null;
  } | null> | null;
  lastEvaluatedKey?: string | null;
};

export type TruckServiceGetTruckQuery = {
  __typename: "TruckRecord";
  truck_id?: number | null;
  ext_truck_id?: string | null;
  ext_truck_name?: string | null;
  rmc_provider: string;
  registration?: string | null;
  device_imei?: string | null;
  serial_no?: string | null;
  vin?: string | null;
  project?: string | null;
  valid_from?: string | null;
  valid_to?: string | null;
  config?: {
    __typename: "TruckConfig";
    physical?: {
      __typename: "TruckPhysicalConfig";
      gearbox_ratio?: number | null;
      hydraulic_motor_displacement_cc?: number | null;
      drum_volume_m3?: number | null;
      is_charging_clockwise?: boolean | null;
      is_pressure_id1_charging?: boolean | null;
      is_pressure_b_insulated?: boolean | null;
      pressure_sensor_location?: PressureSensorLocation | null;
    } | null;
    operations?: {
      __typename: "TruckOperationsConfig";
      is_fm_enabled?: boolean | null;
      is_pa_enabled?: boolean | null;
      is_pb_enabled?: boolean | null;
      is_smarthatch_enabled?: boolean | null;
      is_dm_temperature_fault?: boolean | null;
      is_dm_fault?: boolean | null;
      is_fm_fault?: boolean | null;
      is_pa_fault?: boolean | null;
      is_pb_fault?: boolean | null;
      is_cb_fault?: boolean | null;
      is_smarthatch_fault?: boolean | null;
      is_dm_fitted?: boolean | null;
      is_fm_fitted?: boolean | null;
      is_pa_fitted?: boolean | null;
      is_pb_fitted?: boolean | null;
      is_smarthatch_fitted?: boolean | null;
      maintenance_status?: string | null;
      cb_mounting_location?: CbMountingLocation | null;
      cb_mounting_direction?: CbMountingDirection | null;
    } | null;
    globalConfig?: {
      __typename: "TruckGlobalConfig";
      is_whitelisted?: boolean | null;
      is_off_the_road?: boolean | null;
      is_virtual?: boolean | null;
      misc?: string | null;
      manufacturer?: string | null;
      model?: string | null;
      no_consistence?: boolean | null;
      no_consistence_description?: string | null;
      rpm_sensor?: RpmSensor | null;
    } | null;
  } | null;
  permitted_rmcs: Array<string>;
};

export type TruckServiceIsRmcPermittedQuery = {
  __typename: "RmcPermittedResult";
  permitted: boolean;
  reason?: string | null;
  truckId: number;
  rmc: string;
  permittedRmcs: Array<string>;
  currentRmc: string;
};

export type TruckServiceGetImeisToForwardQuery = {
  __typename: "ImeisToForwardResponse";
  imeis: Array<string>;
};

export type TruckServiceGetTruckIdsToForwardQuery = {
  __typename: "TruckIdsToForwardResponse";
  truck_ids: Array<number>;
};

export type MediaServiceListMediaQuery = {
  __typename: "MediaDetail";
  truckId: number;
  orderId?: string | null;
  docketId?: string | null;
  targetTimestamp?: string | null;
  createdTimestamp?: string | null;
  comment?: string | null;
  s3Key?: string | null;
  rmcId?: string | null;
  userSubId?: string | null;
  userFirstName?: string | null;
  userLastName?: string | null;
  metadata?: string | null;
};

export type MediaServiceMediaCreateQuery = {
  __typename: "MediaCreateOutput";
  url: string;
};

export type MediaServiceMediaFileLinkQuery = {
  __typename: "MediaFileLinkOutput";
  url: string;
};

export type CubeOrdersGetOrdersForRmcQuery = {
  __typename: "CubeOrdersListOrdersResponse";
  orders?: Array<{
    __typename: "CubeOrdersListOrders";
    rmcId?: string | null;
    orderCode?: string | null;
    slumpCode?: string | null;
    jobsiteDescription?: string | null;
    jobsiteCode?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    aggregateSize?: string | null;
    deliveryQuantity?: number | null;
    consistenceTarget?: number | null;
    consistenceClass?: string | null;
    rmcCustomerName?: string | null;
    deliveries?: number | null;
    volumeDelivered?: number | null;
    firstBatchingTimestamp?: string | null;
    lastBatchingTimestamp?: string | null;
    timezone?: string | null;
  }> | null;
  cursor?: string | null;
};

export type CubeOrdersGetDeliveriesForRmcQuery = {
  __typename: "GetDeliveriesByRmcResponse";
  deliveries?: Array<{
    __typename: "OrderSvcTrip";
    rmcId?: string | null;
    truckPlate?: string | null;
    extTruckName?: string | null;
    truckImei?: string | null;
    tripStartTime?: string | null;
    tripEndTime?: string | null;
    datetimeBatch?: string | null;
    slumpCode?: string | null;
    orderCode?: string | null;
    docketId?: string | null;
    docketId1?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    technicalProductCode?: string | null;
    technicalProductDescription?: string | null;
    deliveredQuantity?: number | null;
    plantCode?: string | null;
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
    pourTime?: string | null;
    pourEvents?: string | null;
    pourLocation?: string | null;
    siteLocation?: string | null;
    plantLocation?: string | null;
    plantName?: string | null;
    loadingPoint?: string | null;
    leftBatchPlant?: string | null;
    arrivedAtSite?: string | null;
    leftSite?: string | null;
    consistenceMmAtLoadMix?: number | null;
    consistenceMmAtLoadMixOk?: boolean | null;
    consistenceMmQualifierAtLoadMix?: string | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmAtPlantExitOk?: boolean | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtSiteArrivalOk?: boolean | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    consistenceMmAtPour?: number | null;
    consistenceMmAtPourOk?: boolean | null;
    consistenceMmQualifierAtPour?: string | null;
    consistenceClass?: string | null;
    consistenceTarget?: number | null;
    consistenceClassMax?: number | null;
    consistenceClassMin?: number | null;
    consistenceLowerLimitSpot?: number | null;
    consistenceStandard?: string | null;
    consistenceTestType?: string | null;
    consistenceUpperLimitSpot?: number | null;
    customerName?: string | null;
    rheometryPlasticViscosityPasAtPlantExit?: number | null;
    rheometryPlasticViscosityPasAtSiteArrival?: number | null;
    rheometryPlasticViscosityPasAtPour?: number | null;
    rheometryPlasticViscosityPasPredictionType?: string | null;
    rheometryYieldStressPaAtPlantExit?: number | null;
    rheometryYieldStressPaAtSiteArrival?: number | null;
    rheometryYieldStressPaAtPour?: number | null;
    rheometryYieldStressPaPredictionType?: string | null;
    rheometryStaticYieldStressTargetMinPa?: number | null;
    rheometryStaticYieldStressTargetMaxPa?: number | null;
    rheometryPlasticViscosityTargetMinPas?: number | null;
    rheometryPlasticViscosityTargetMaxPas?: number | null;
    waterAdditions?: string | null;
    additionalWaterMeasured?: number | null;
    additionalWaterDetected?: boolean | null;
    washoutWaterMeasured?: number | null;
    additionalWaterPerM3?: number | null;
    midPourWaterAdded?: number | null;
    prePourWaterAdded?: number | null;
    unclassifiedWaterAdded?: number | null;
    waterAddedAtPlant?: number | null;
    timezone?: string | null;
    tempAtLoadMix?: number | null;
    tempAtSiteArrival?: number | null;
    tempAtPour?: number | null;
    tempAtPlantExit?: number | null;
    consistenceSpeedPattern?: string | null;
    speedPatternAtSite?: string | null;
    consistencePredictionType?: string | null;
    deliveryTags?: Array<{
      __typename: "OrderSvcTag";
      id: number;
      rmcId: string;
      name: string;
      usageCount?: number | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    }> | null;
    batchToDepartureTimeMinutes?: number | null;
    outboundTransitTimeMinutes?: number | null;
    siteWaitTimeMinutes?: number | null;
    pouringTimeMinutes?: number | null;
    leavingSiteTimeMinutes?: number | null;
    totalSiteTimeMinutes?: number | null;
    inboundTransitTimeMinutes?: number | null;
    totalCycleTimeMinutes?: number | null;
    deliveryManualTests?: Array<{
      __typename: "OrderSvcManualTest";
      id: number;
      docketId: string;
      type: string;
      result: number;
      testResult: number;
      unit: string;
      testTime: string;
      createdBy: string;
      comment?: string | null;
      mediaS3Key?: string | null;
      accepted?: boolean | null;
      acceptanceReason?: string | null;
      reviewedBy?: string | null;
    }> | null;
    allowableWaterToAddLitres?: number | null;
    excessWaterAddedDuringBatchingLitres?: number | null;
    mixDesignCode?: string | null;
    docketTargetWeights?: {
      __typename: "DocketMixDesign";
      maxWaterCementRatio?: number | null;
      aggregate?: Array<{
        __typename: "DocketAggregate";
        name?: string | null;
        type?: string | null;
        maxSizeMM?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      fillers?: Array<{
        __typename: "DocketFiller";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      water?: Array<{
        __typename: "DocketWater";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      binders?: Array<{
        __typename: "DocketBinder";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      admixture?: Array<{
        __typename: "DocketAdmixture";
        name?: string | null;
        value?: number | null;
        units?: string | null;
        type?: string | null;
      } | null> | null;
      reinforcement?: Array<{
        __typename: "DocketReinforcement";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
    } | null;
    docketBatchedWeights?: {
      __typename: "DocketBatchedWeights";
      aggregate?: Array<{
        __typename: "DocketAggregate";
        name?: string | null;
        type?: string | null;
        maxSizeMM?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      fillers?: Array<{
        __typename: "DocketFiller";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      water?: Array<{
        __typename: "DocketWater";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      binders?: Array<{
        __typename: "DocketBinder";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      admixture?: Array<{
        __typename: "DocketAdmixture";
        name?: string | null;
        value?: number | null;
        units?: string | null;
        type?: string | null;
      } | null> | null;
      reinforcement?: Array<{
        __typename: "DocketReinforcement";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
    } | null;
    docketTestResults?: Array<{
      __typename: "DocketTestResult";
      type?: string | null;
      value?: number | null;
      units?: string | null;
      datetimeUTC?: string | null;
    } | null> | null;
    spinUpStatus?: string | null;
    spinUpStatusUpdateTime?: string | null;
    mediaCount?: number | null;
    commentCount?: number | null;
    comments?: Array<string> | null;
    spinUpStatusBeforeFirstNonSamplePour?: string | null;
    spinUpStatusBeforeLastSamplePour?: string | null;
    emptyDrumStage?: string | null;
    emptyDrumType?: string | null;
    emptyDrumTime?: string | null;
    truckConfig?: {
      __typename: "DocketTruckConfig";
      physical?: {
        __typename: "DocketPhysicalTruckConfig";
        gearboxRatio?: number | null;
        hydraulicMotorDisplacementCc?: number | null;
        drumVolumeM3?: number | null;
        isChargingClockwise?: boolean | null;
        isPressureId1Charging?: boolean | null;
        isPressureBInsulated?: boolean | null;
        pressureSensorLocation?: string | null;
      } | null;
      operations?: {
        __typename: "DocketOperationsTruckConfig";
        isDmTemperatureFault?: boolean | null;
        isDmFault?: boolean | null;
        isFmFault?: boolean | null;
        isCbFault?: boolean | null;
        isDmFitted?: boolean | null;
        isFmFitted?: boolean | null;
        maintenanceStatus?: string | null;
        cbMountingLocation?: string | null;
        cbMountingDirection?: string | null;
      } | null;
      globalConfig?: {
        __typename: "DocketGlobalTruckConfig";
        isWhitelisted?: boolean | null;
        isOffTheRoad?: boolean | null;
        isVirtual?: boolean | null;
        rpmSensor?: string | null;
        misc?: string | null;
        manufacturer?: string | null;
        model?: string | null;
        noConsistence?: boolean | null;
        noConsistenceDescription?: string | null;
      } | null;
    } | null;
    concreteVolumeM3AtPlantExit?: number | null;
    concreteVolumeM3AtSiteArrival?: number | null;
    concreteVolumeM3AtPour?: number | null;
    concreteVolumeM3AtSiteExit?: number | null;
    airPercentAtPlantExit?: number | null;
    airPercentAtSiteArrival?: number | null;
    airPercentAtPour?: number | null;
    airPercentAtSiteExit?: number | null;
    airPercentAtLoadMix?: number | null;
    weatherTempDegcAtPlant?: number | null;
    weatherCodeAtPlant?: number | null;
    weatherTempDegcAtSiteArrival?: number | null;
    weatherCodeAtSiteArrival?: number | null;
    deviceHealthStatus?: string | null;
  } | null> | null;
  cursor?: number | null;
};

export type CubeOrdersGetOrderTripsQuery = {
  __typename: "CubeOrdersTrip";
  rmcId?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  tripStartTime?: string | null;
  tripEndTime?: string | null;
  datetimeBatch?: string | null;
  slumpCode?: string | null;
  orderCode?: string | null;
  docketId?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  customerName?: string | null;
  deliveredQuantity?: number | null;
  plantCode?: string | null;
  plantName?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  pourTime?: string | null;
  pourEvents?: string | null;
  pourLocation?: string | null;
  siteLocation?: string | null;
  plantLocation?: string | null;
  loadingPoint?: string | null;
  leftBatchPlant?: string | null;
  arrivedAtSite?: string | null;
  leftSite?: string | null;
  consistenceMmAtLoadMix?: number | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtPour?: number | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  waterAdditions?: string | null;
  additionalWaterMeasured?: number | null;
  timezone?: string | null;
  tempAtLoadMix?: number | null;
  tempAtSiteArrival?: number | null;
  tempAtPour?: number | null;
  tempAtPlantExit?: number | null;
};

export type CubeOrdersGetTruckTripsQuery = {
  __typename: "CubeOrdersTrip";
  rmcId?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  tripStartTime?: string | null;
  tripEndTime?: string | null;
  datetimeBatch?: string | null;
  slumpCode?: string | null;
  orderCode?: string | null;
  docketId?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  customerName?: string | null;
  deliveredQuantity?: number | null;
  plantCode?: string | null;
  plantName?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  pourTime?: string | null;
  pourEvents?: string | null;
  pourLocation?: string | null;
  siteLocation?: string | null;
  plantLocation?: string | null;
  loadingPoint?: string | null;
  leftBatchPlant?: string | null;
  arrivedAtSite?: string | null;
  leftSite?: string | null;
  consistenceMmAtLoadMix?: number | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtPour?: number | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  waterAdditions?: string | null;
  additionalWaterMeasured?: number | null;
  timezone?: string | null;
  tempAtLoadMix?: number | null;
  tempAtSiteArrival?: number | null;
  tempAtPour?: number | null;
  tempAtPlantExit?: number | null;
};

export type CubeOrdersGetOrderDeliveryQuery = {
  __typename: "CubeOrdersTrip";
  rmcId?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  tripStartTime?: string | null;
  tripEndTime?: string | null;
  datetimeBatch?: string | null;
  slumpCode?: string | null;
  orderCode?: string | null;
  docketId?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  customerName?: string | null;
  deliveredQuantity?: number | null;
  plantCode?: string | null;
  plantName?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  pourTime?: string | null;
  pourEvents?: string | null;
  pourLocation?: string | null;
  siteLocation?: string | null;
  plantLocation?: string | null;
  loadingPoint?: string | null;
  leftBatchPlant?: string | null;
  arrivedAtSite?: string | null;
  leftSite?: string | null;
  consistenceMmAtLoadMix?: number | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtPour?: number | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  waterAdditions?: string | null;
  additionalWaterMeasured?: number | null;
  timezone?: string | null;
  tempAtLoadMix?: number | null;
  tempAtSiteArrival?: number | null;
  tempAtPour?: number | null;
  tempAtPlantExit?: number | null;
};

export type CubeOrdersGetOrderDeliveryTimeseriesQuery = {
  __typename: "CubeOrdersDeliveryTimeseries";
  timeseries?: Array<{
    __typename: "Timeseries";
    timestamp?: string | null;
    geo?: string | null;
    rpm?: number | null;
    pressure?: number | null;
    pressureABarMean?: number | null;
    pressureBBarMean?: number | null;
    temp?: number | null;
    consistenceMm?: number | null;
    consistenceMmQualifier?: string | null;
    consistenceMinMm?: number | null;
    consistenceMaxMm?: number | null;
    rheometryPlasticViscosityPas?: number | null;
    rheometryStaticYieldStressPa?: number | null;
    gpsLongitudes?: string | null;
    gpsLatitudes?: string | null;
    percentAir?: number | null;
    concreteVolume?: number | null;
  } | null> | null;
};

export type OrderSvcGetOrdersForRmcQuery = {
  __typename: "OrderSvcListOrdersResponse";
  orders?: Array<{
    __typename: "OrderSvcListOrders";
    rmcId?: string | null;
    orderCode?: string | null;
    slumpCode?: string | null;
    jobsiteDescription?: string | null;
    jobsiteCode?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    aggregateSize?: string | null;
    deliveryQuantity?: number | null;
    consistenceTarget?: number | null;
    consistenceClass?: string | null;
    rmcCustomerName?: string | null;
    deliveries?: number | null;
    volumeDelivered?: number | null;
    firstBatchingTimestamp?: string | null;
    lastBatchingTimestamp?: string | null;
    timezone?: string | null;
  }> | null;
  cursor?: string | null;
};

export type OrderSvcGetDeliveriesForRmcQuery = {
  __typename: "GetDeliveriesByRmcResponse";
  deliveries?: Array<{
    __typename: "OrderSvcTrip";
    rmcId?: string | null;
    truckPlate?: string | null;
    extTruckName?: string | null;
    truckImei?: string | null;
    tripStartTime?: string | null;
    tripEndTime?: string | null;
    datetimeBatch?: string | null;
    slumpCode?: string | null;
    orderCode?: string | null;
    docketId?: string | null;
    docketId1?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    technicalProductCode?: string | null;
    technicalProductDescription?: string | null;
    deliveredQuantity?: number | null;
    plantCode?: string | null;
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
    pourTime?: string | null;
    pourEvents?: string | null;
    pourLocation?: string | null;
    siteLocation?: string | null;
    plantLocation?: string | null;
    plantName?: string | null;
    loadingPoint?: string | null;
    leftBatchPlant?: string | null;
    arrivedAtSite?: string | null;
    leftSite?: string | null;
    consistenceMmAtLoadMix?: number | null;
    consistenceMmAtLoadMixOk?: boolean | null;
    consistenceMmQualifierAtLoadMix?: string | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmAtPlantExitOk?: boolean | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtSiteArrivalOk?: boolean | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    consistenceMmAtPour?: number | null;
    consistenceMmAtPourOk?: boolean | null;
    consistenceMmQualifierAtPour?: string | null;
    consistenceClass?: string | null;
    consistenceTarget?: number | null;
    consistenceClassMax?: number | null;
    consistenceClassMin?: number | null;
    consistenceLowerLimitSpot?: number | null;
    consistenceStandard?: string | null;
    consistenceTestType?: string | null;
    consistenceUpperLimitSpot?: number | null;
    customerName?: string | null;
    rheometryPlasticViscosityPasAtPlantExit?: number | null;
    rheometryPlasticViscosityPasAtSiteArrival?: number | null;
    rheometryPlasticViscosityPasAtPour?: number | null;
    rheometryPlasticViscosityPasPredictionType?: string | null;
    rheometryYieldStressPaAtPlantExit?: number | null;
    rheometryYieldStressPaAtSiteArrival?: number | null;
    rheometryYieldStressPaAtPour?: number | null;
    rheometryYieldStressPaPredictionType?: string | null;
    rheometryStaticYieldStressTargetMinPa?: number | null;
    rheometryStaticYieldStressTargetMaxPa?: number | null;
    rheometryPlasticViscosityTargetMinPas?: number | null;
    rheometryPlasticViscosityTargetMaxPas?: number | null;
    waterAdditions?: string | null;
    additionalWaterMeasured?: number | null;
    additionalWaterDetected?: boolean | null;
    washoutWaterMeasured?: number | null;
    additionalWaterPerM3?: number | null;
    midPourWaterAdded?: number | null;
    prePourWaterAdded?: number | null;
    unclassifiedWaterAdded?: number | null;
    waterAddedAtPlant?: number | null;
    timezone?: string | null;
    tempAtLoadMix?: number | null;
    tempAtSiteArrival?: number | null;
    tempAtPour?: number | null;
    tempAtPlantExit?: number | null;
    consistenceSpeedPattern?: string | null;
    speedPatternAtSite?: string | null;
    consistencePredictionType?: string | null;
    deliveryTags?: Array<{
      __typename: "OrderSvcTag";
      id: number;
      rmcId: string;
      name: string;
      usageCount?: number | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    }> | null;
    batchToDepartureTimeMinutes?: number | null;
    outboundTransitTimeMinutes?: number | null;
    siteWaitTimeMinutes?: number | null;
    pouringTimeMinutes?: number | null;
    leavingSiteTimeMinutes?: number | null;
    totalSiteTimeMinutes?: number | null;
    inboundTransitTimeMinutes?: number | null;
    totalCycleTimeMinutes?: number | null;
    deliveryManualTests?: Array<{
      __typename: "OrderSvcManualTest";
      id: number;
      docketId: string;
      type: string;
      result: number;
      testResult: number;
      unit: string;
      testTime: string;
      createdBy: string;
      comment?: string | null;
      mediaS3Key?: string | null;
      accepted?: boolean | null;
      acceptanceReason?: string | null;
      reviewedBy?: string | null;
    }> | null;
    allowableWaterToAddLitres?: number | null;
    excessWaterAddedDuringBatchingLitres?: number | null;
    mixDesignCode?: string | null;
    docketTargetWeights?: {
      __typename: "DocketMixDesign";
      maxWaterCementRatio?: number | null;
      aggregate?: Array<{
        __typename: "DocketAggregate";
        name?: string | null;
        type?: string | null;
        maxSizeMM?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      fillers?: Array<{
        __typename: "DocketFiller";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      water?: Array<{
        __typename: "DocketWater";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      binders?: Array<{
        __typename: "DocketBinder";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      admixture?: Array<{
        __typename: "DocketAdmixture";
        name?: string | null;
        value?: number | null;
        units?: string | null;
        type?: string | null;
      } | null> | null;
      reinforcement?: Array<{
        __typename: "DocketReinforcement";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
    } | null;
    docketBatchedWeights?: {
      __typename: "DocketBatchedWeights";
      aggregate?: Array<{
        __typename: "DocketAggregate";
        name?: string | null;
        type?: string | null;
        maxSizeMM?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      fillers?: Array<{
        __typename: "DocketFiller";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      water?: Array<{
        __typename: "DocketWater";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      binders?: Array<{
        __typename: "DocketBinder";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      admixture?: Array<{
        __typename: "DocketAdmixture";
        name?: string | null;
        value?: number | null;
        units?: string | null;
        type?: string | null;
      } | null> | null;
      reinforcement?: Array<{
        __typename: "DocketReinforcement";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
    } | null;
    docketTestResults?: Array<{
      __typename: "DocketTestResult";
      type?: string | null;
      value?: number | null;
      units?: string | null;
      datetimeUTC?: string | null;
    } | null> | null;
    spinUpStatus?: string | null;
    spinUpStatusUpdateTime?: string | null;
    mediaCount?: number | null;
    commentCount?: number | null;
    comments?: Array<string> | null;
    spinUpStatusBeforeFirstNonSamplePour?: string | null;
    spinUpStatusBeforeLastSamplePour?: string | null;
    emptyDrumStage?: string | null;
    emptyDrumType?: string | null;
    emptyDrumTime?: string | null;
    truckConfig?: {
      __typename: "DocketTruckConfig";
      physical?: {
        __typename: "DocketPhysicalTruckConfig";
        gearboxRatio?: number | null;
        hydraulicMotorDisplacementCc?: number | null;
        drumVolumeM3?: number | null;
        isChargingClockwise?: boolean | null;
        isPressureId1Charging?: boolean | null;
        isPressureBInsulated?: boolean | null;
        pressureSensorLocation?: string | null;
      } | null;
      operations?: {
        __typename: "DocketOperationsTruckConfig";
        isDmTemperatureFault?: boolean | null;
        isDmFault?: boolean | null;
        isFmFault?: boolean | null;
        isCbFault?: boolean | null;
        isDmFitted?: boolean | null;
        isFmFitted?: boolean | null;
        maintenanceStatus?: string | null;
        cbMountingLocation?: string | null;
        cbMountingDirection?: string | null;
      } | null;
      globalConfig?: {
        __typename: "DocketGlobalTruckConfig";
        isWhitelisted?: boolean | null;
        isOffTheRoad?: boolean | null;
        isVirtual?: boolean | null;
        rpmSensor?: string | null;
        misc?: string | null;
        manufacturer?: string | null;
        model?: string | null;
        noConsistence?: boolean | null;
        noConsistenceDescription?: string | null;
      } | null;
    } | null;
    concreteVolumeM3AtPlantExit?: number | null;
    concreteVolumeM3AtSiteArrival?: number | null;
    concreteVolumeM3AtPour?: number | null;
    concreteVolumeM3AtSiteExit?: number | null;
    airPercentAtPlantExit?: number | null;
    airPercentAtSiteArrival?: number | null;
    airPercentAtPour?: number | null;
    airPercentAtSiteExit?: number | null;
    airPercentAtLoadMix?: number | null;
    weatherTempDegcAtPlant?: number | null;
    weatherCodeAtPlant?: number | null;
    weatherTempDegcAtSiteArrival?: number | null;
    weatherCodeAtSiteArrival?: number | null;
    deviceHealthStatus?: string | null;
  } | null> | null;
  cursor?: number | null;
};

export type OrderSvcDownloadDeliveriesForRmcQuery = {
  __typename: "orderSvcDownloadDeliveriesForRmcResponse";
  jobId?: string | null;
};

export type OrderSvcGetOrderTripsQuery = {
  __typename: "OrderSvcTrip";
  rmcId?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  truckImei?: string | null;
  tripStartTime?: string | null;
  tripEndTime?: string | null;
  datetimeBatch?: string | null;
  slumpCode?: string | null;
  orderCode?: string | null;
  docketId?: string | null;
  docketId1?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  deliveredQuantity?: number | null;
  plantCode?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  pourTime?: string | null;
  pourEvents?: string | null;
  pourLocation?: string | null;
  siteLocation?: string | null;
  plantLocation?: string | null;
  plantName?: string | null;
  loadingPoint?: string | null;
  leftBatchPlant?: string | null;
  arrivedAtSite?: string | null;
  leftSite?: string | null;
  consistenceMmAtLoadMix?: number | null;
  consistenceMmAtLoadMixOk?: boolean | null;
  consistenceMmQualifierAtLoadMix?: string | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmAtPlantExitOk?: boolean | null;
  consistenceMmQualifierAtPlantExit?: string | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtSiteArrivalOk?: boolean | null;
  consistenceMmQualifierAtSiteArrival?: string | null;
  consistenceMmAtPour?: number | null;
  consistenceMmAtPourOk?: boolean | null;
  consistenceMmQualifierAtPour?: string | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  consistenceClassMax?: number | null;
  consistenceClassMin?: number | null;
  consistenceLowerLimitSpot?: number | null;
  consistenceStandard?: string | null;
  consistenceTestType?: string | null;
  consistenceUpperLimitSpot?: number | null;
  customerName?: string | null;
  rheometryPlasticViscosityPasAtPlantExit?: number | null;
  rheometryPlasticViscosityPasAtSiteArrival?: number | null;
  rheometryPlasticViscosityPasAtPour?: number | null;
  rheometryPlasticViscosityPasPredictionType?: string | null;
  rheometryYieldStressPaAtPlantExit?: number | null;
  rheometryYieldStressPaAtSiteArrival?: number | null;
  rheometryYieldStressPaAtPour?: number | null;
  rheometryYieldStressPaPredictionType?: string | null;
  rheometryStaticYieldStressTargetMinPa?: number | null;
  rheometryStaticYieldStressTargetMaxPa?: number | null;
  rheometryPlasticViscosityTargetMinPas?: number | null;
  rheometryPlasticViscosityTargetMaxPas?: number | null;
  waterAdditions?: string | null;
  additionalWaterMeasured?: number | null;
  additionalWaterDetected?: boolean | null;
  washoutWaterMeasured?: number | null;
  additionalWaterPerM3?: number | null;
  midPourWaterAdded?: number | null;
  prePourWaterAdded?: number | null;
  unclassifiedWaterAdded?: number | null;
  waterAddedAtPlant?: number | null;
  timezone?: string | null;
  tempAtLoadMix?: number | null;
  tempAtSiteArrival?: number | null;
  tempAtPour?: number | null;
  tempAtPlantExit?: number | null;
  consistenceSpeedPattern?: string | null;
  speedPatternAtSite?: string | null;
  consistencePredictionType?: string | null;
  deliveryTags?: Array<{
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  }> | null;
  batchToDepartureTimeMinutes?: number | null;
  outboundTransitTimeMinutes?: number | null;
  siteWaitTimeMinutes?: number | null;
  pouringTimeMinutes?: number | null;
  leavingSiteTimeMinutes?: number | null;
  totalSiteTimeMinutes?: number | null;
  inboundTransitTimeMinutes?: number | null;
  totalCycleTimeMinutes?: number | null;
  deliveryManualTests?: Array<{
    __typename: "OrderSvcManualTest";
    id: number;
    docketId: string;
    type: string;
    result: number;
    testResult: number;
    unit: string;
    testTime: string;
    createdBy: string;
    comment?: string | null;
    mediaS3Key?: string | null;
    accepted?: boolean | null;
    acceptanceReason?: string | null;
    reviewedBy?: string | null;
  }> | null;
  allowableWaterToAddLitres?: number | null;
  excessWaterAddedDuringBatchingLitres?: number | null;
  mixDesignCode?: string | null;
  docketTargetWeights?: {
    __typename: "DocketMixDesign";
    maxWaterCementRatio?: number | null;
    aggregate?: Array<{
      __typename: "DocketAggregate";
      name?: string | null;
      type?: string | null;
      maxSizeMM?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    fillers?: Array<{
      __typename: "DocketFiller";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    water?: Array<{
      __typename: "DocketWater";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    binders?: Array<{
      __typename: "DocketBinder";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    admixture?: Array<{
      __typename: "DocketAdmixture";
      name?: string | null;
      value?: number | null;
      units?: string | null;
      type?: string | null;
    } | null> | null;
    reinforcement?: Array<{
      __typename: "DocketReinforcement";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
  } | null;
  docketBatchedWeights?: {
    __typename: "DocketBatchedWeights";
    aggregate?: Array<{
      __typename: "DocketAggregate";
      name?: string | null;
      type?: string | null;
      maxSizeMM?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    fillers?: Array<{
      __typename: "DocketFiller";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    water?: Array<{
      __typename: "DocketWater";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    binders?: Array<{
      __typename: "DocketBinder";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    admixture?: Array<{
      __typename: "DocketAdmixture";
      name?: string | null;
      value?: number | null;
      units?: string | null;
      type?: string | null;
    } | null> | null;
    reinforcement?: Array<{
      __typename: "DocketReinforcement";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
  } | null;
  docketTestResults?: Array<{
    __typename: "DocketTestResult";
    type?: string | null;
    value?: number | null;
    units?: string | null;
    datetimeUTC?: string | null;
  } | null> | null;
  spinUpStatus?: string | null;
  spinUpStatusUpdateTime?: string | null;
  mediaCount?: number | null;
  commentCount?: number | null;
  comments?: Array<string> | null;
  spinUpStatusBeforeFirstNonSamplePour?: string | null;
  spinUpStatusBeforeLastSamplePour?: string | null;
  emptyDrumStage?: string | null;
  emptyDrumType?: string | null;
  emptyDrumTime?: string | null;
  truckConfig?: {
    __typename: "DocketTruckConfig";
    physical?: {
      __typename: "DocketPhysicalTruckConfig";
      gearboxRatio?: number | null;
      hydraulicMotorDisplacementCc?: number | null;
      drumVolumeM3?: number | null;
      isChargingClockwise?: boolean | null;
      isPressureId1Charging?: boolean | null;
      isPressureBInsulated?: boolean | null;
      pressureSensorLocation?: string | null;
    } | null;
    operations?: {
      __typename: "DocketOperationsTruckConfig";
      isDmTemperatureFault?: boolean | null;
      isDmFault?: boolean | null;
      isFmFault?: boolean | null;
      isCbFault?: boolean | null;
      isDmFitted?: boolean | null;
      isFmFitted?: boolean | null;
      maintenanceStatus?: string | null;
      cbMountingLocation?: string | null;
      cbMountingDirection?: string | null;
    } | null;
    globalConfig?: {
      __typename: "DocketGlobalTruckConfig";
      isWhitelisted?: boolean | null;
      isOffTheRoad?: boolean | null;
      isVirtual?: boolean | null;
      rpmSensor?: string | null;
      misc?: string | null;
      manufacturer?: string | null;
      model?: string | null;
      noConsistence?: boolean | null;
      noConsistenceDescription?: string | null;
    } | null;
  } | null;
  concreteVolumeM3AtPlantExit?: number | null;
  concreteVolumeM3AtSiteArrival?: number | null;
  concreteVolumeM3AtPour?: number | null;
  concreteVolumeM3AtSiteExit?: number | null;
  airPercentAtPlantExit?: number | null;
  airPercentAtSiteArrival?: number | null;
  airPercentAtPour?: number | null;
  airPercentAtSiteExit?: number | null;
  airPercentAtLoadMix?: number | null;
  weatherTempDegcAtPlant?: number | null;
  weatherCodeAtPlant?: number | null;
  weatherTempDegcAtSiteArrival?: number | null;
  weatherCodeAtSiteArrival?: number | null;
  deviceHealthStatus?: string | null;
};

export type OrderSvcGetTruckTripsQuery = {
  __typename: "OrderSvcTrip";
  rmcId?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  truckImei?: string | null;
  tripStartTime?: string | null;
  tripEndTime?: string | null;
  datetimeBatch?: string | null;
  slumpCode?: string | null;
  orderCode?: string | null;
  docketId?: string | null;
  docketId1?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  deliveredQuantity?: number | null;
  plantCode?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  pourTime?: string | null;
  pourEvents?: string | null;
  pourLocation?: string | null;
  siteLocation?: string | null;
  plantLocation?: string | null;
  plantName?: string | null;
  loadingPoint?: string | null;
  leftBatchPlant?: string | null;
  arrivedAtSite?: string | null;
  leftSite?: string | null;
  consistenceMmAtLoadMix?: number | null;
  consistenceMmAtLoadMixOk?: boolean | null;
  consistenceMmQualifierAtLoadMix?: string | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmAtPlantExitOk?: boolean | null;
  consistenceMmQualifierAtPlantExit?: string | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtSiteArrivalOk?: boolean | null;
  consistenceMmQualifierAtSiteArrival?: string | null;
  consistenceMmAtPour?: number | null;
  consistenceMmAtPourOk?: boolean | null;
  consistenceMmQualifierAtPour?: string | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  consistenceClassMax?: number | null;
  consistenceClassMin?: number | null;
  consistenceLowerLimitSpot?: number | null;
  consistenceStandard?: string | null;
  consistenceTestType?: string | null;
  consistenceUpperLimitSpot?: number | null;
  customerName?: string | null;
  rheometryPlasticViscosityPasAtPlantExit?: number | null;
  rheometryPlasticViscosityPasAtSiteArrival?: number | null;
  rheometryPlasticViscosityPasAtPour?: number | null;
  rheometryPlasticViscosityPasPredictionType?: string | null;
  rheometryYieldStressPaAtPlantExit?: number | null;
  rheometryYieldStressPaAtSiteArrival?: number | null;
  rheometryYieldStressPaAtPour?: number | null;
  rheometryYieldStressPaPredictionType?: string | null;
  rheometryStaticYieldStressTargetMinPa?: number | null;
  rheometryStaticYieldStressTargetMaxPa?: number | null;
  rheometryPlasticViscosityTargetMinPas?: number | null;
  rheometryPlasticViscosityTargetMaxPas?: number | null;
  waterAdditions?: string | null;
  additionalWaterMeasured?: number | null;
  additionalWaterDetected?: boolean | null;
  washoutWaterMeasured?: number | null;
  additionalWaterPerM3?: number | null;
  midPourWaterAdded?: number | null;
  prePourWaterAdded?: number | null;
  unclassifiedWaterAdded?: number | null;
  waterAddedAtPlant?: number | null;
  timezone?: string | null;
  tempAtLoadMix?: number | null;
  tempAtSiteArrival?: number | null;
  tempAtPour?: number | null;
  tempAtPlantExit?: number | null;
  consistenceSpeedPattern?: string | null;
  speedPatternAtSite?: string | null;
  consistencePredictionType?: string | null;
  deliveryTags?: Array<{
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  }> | null;
  batchToDepartureTimeMinutes?: number | null;
  outboundTransitTimeMinutes?: number | null;
  siteWaitTimeMinutes?: number | null;
  pouringTimeMinutes?: number | null;
  leavingSiteTimeMinutes?: number | null;
  totalSiteTimeMinutes?: number | null;
  inboundTransitTimeMinutes?: number | null;
  totalCycleTimeMinutes?: number | null;
  deliveryManualTests?: Array<{
    __typename: "OrderSvcManualTest";
    id: number;
    docketId: string;
    type: string;
    result: number;
    testResult: number;
    unit: string;
    testTime: string;
    createdBy: string;
    comment?: string | null;
    mediaS3Key?: string | null;
    accepted?: boolean | null;
    acceptanceReason?: string | null;
    reviewedBy?: string | null;
  }> | null;
  allowableWaterToAddLitres?: number | null;
  excessWaterAddedDuringBatchingLitres?: number | null;
  mixDesignCode?: string | null;
  docketTargetWeights?: {
    __typename: "DocketMixDesign";
    maxWaterCementRatio?: number | null;
    aggregate?: Array<{
      __typename: "DocketAggregate";
      name?: string | null;
      type?: string | null;
      maxSizeMM?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    fillers?: Array<{
      __typename: "DocketFiller";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    water?: Array<{
      __typename: "DocketWater";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    binders?: Array<{
      __typename: "DocketBinder";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    admixture?: Array<{
      __typename: "DocketAdmixture";
      name?: string | null;
      value?: number | null;
      units?: string | null;
      type?: string | null;
    } | null> | null;
    reinforcement?: Array<{
      __typename: "DocketReinforcement";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
  } | null;
  docketBatchedWeights?: {
    __typename: "DocketBatchedWeights";
    aggregate?: Array<{
      __typename: "DocketAggregate";
      name?: string | null;
      type?: string | null;
      maxSizeMM?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    fillers?: Array<{
      __typename: "DocketFiller";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    water?: Array<{
      __typename: "DocketWater";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    binders?: Array<{
      __typename: "DocketBinder";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    admixture?: Array<{
      __typename: "DocketAdmixture";
      name?: string | null;
      value?: number | null;
      units?: string | null;
      type?: string | null;
    } | null> | null;
    reinforcement?: Array<{
      __typename: "DocketReinforcement";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
  } | null;
  docketTestResults?: Array<{
    __typename: "DocketTestResult";
    type?: string | null;
    value?: number | null;
    units?: string | null;
    datetimeUTC?: string | null;
  } | null> | null;
  spinUpStatus?: string | null;
  spinUpStatusUpdateTime?: string | null;
  mediaCount?: number | null;
  commentCount?: number | null;
  comments?: Array<string> | null;
  spinUpStatusBeforeFirstNonSamplePour?: string | null;
  spinUpStatusBeforeLastSamplePour?: string | null;
  emptyDrumStage?: string | null;
  emptyDrumType?: string | null;
  emptyDrumTime?: string | null;
  truckConfig?: {
    __typename: "DocketTruckConfig";
    physical?: {
      __typename: "DocketPhysicalTruckConfig";
      gearboxRatio?: number | null;
      hydraulicMotorDisplacementCc?: number | null;
      drumVolumeM3?: number | null;
      isChargingClockwise?: boolean | null;
      isPressureId1Charging?: boolean | null;
      isPressureBInsulated?: boolean | null;
      pressureSensorLocation?: string | null;
    } | null;
    operations?: {
      __typename: "DocketOperationsTruckConfig";
      isDmTemperatureFault?: boolean | null;
      isDmFault?: boolean | null;
      isFmFault?: boolean | null;
      isCbFault?: boolean | null;
      isDmFitted?: boolean | null;
      isFmFitted?: boolean | null;
      maintenanceStatus?: string | null;
      cbMountingLocation?: string | null;
      cbMountingDirection?: string | null;
    } | null;
    globalConfig?: {
      __typename: "DocketGlobalTruckConfig";
      isWhitelisted?: boolean | null;
      isOffTheRoad?: boolean | null;
      isVirtual?: boolean | null;
      rpmSensor?: string | null;
      misc?: string | null;
      manufacturer?: string | null;
      model?: string | null;
      noConsistence?: boolean | null;
      noConsistenceDescription?: string | null;
    } | null;
  } | null;
  concreteVolumeM3AtPlantExit?: number | null;
  concreteVolumeM3AtSiteArrival?: number | null;
  concreteVolumeM3AtPour?: number | null;
  concreteVolumeM3AtSiteExit?: number | null;
  airPercentAtPlantExit?: number | null;
  airPercentAtSiteArrival?: number | null;
  airPercentAtPour?: number | null;
  airPercentAtSiteExit?: number | null;
  airPercentAtLoadMix?: number | null;
  weatherTempDegcAtPlant?: number | null;
  weatherCodeAtPlant?: number | null;
  weatherTempDegcAtSiteArrival?: number | null;
  weatherCodeAtSiteArrival?: number | null;
  deviceHealthStatus?: string | null;
};

export type OrderSvcGetOrderDeliveryQuery = {
  __typename: "OrderSvcTrip";
  rmcId?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  truckImei?: string | null;
  tripStartTime?: string | null;
  tripEndTime?: string | null;
  datetimeBatch?: string | null;
  slumpCode?: string | null;
  orderCode?: string | null;
  docketId?: string | null;
  docketId1?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  deliveredQuantity?: number | null;
  plantCode?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  pourTime?: string | null;
  pourEvents?: string | null;
  pourLocation?: string | null;
  siteLocation?: string | null;
  plantLocation?: string | null;
  plantName?: string | null;
  loadingPoint?: string | null;
  leftBatchPlant?: string | null;
  arrivedAtSite?: string | null;
  leftSite?: string | null;
  consistenceMmAtLoadMix?: number | null;
  consistenceMmAtLoadMixOk?: boolean | null;
  consistenceMmQualifierAtLoadMix?: string | null;
  consistenceMmAtPlantExit?: number | null;
  consistenceMmAtPlantExitOk?: boolean | null;
  consistenceMmQualifierAtPlantExit?: string | null;
  consistenceMmAtSiteArrival?: number | null;
  consistenceMmAtSiteArrivalOk?: boolean | null;
  consistenceMmQualifierAtSiteArrival?: string | null;
  consistenceMmAtPour?: number | null;
  consistenceMmAtPourOk?: boolean | null;
  consistenceMmQualifierAtPour?: string | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  consistenceClassMax?: number | null;
  consistenceClassMin?: number | null;
  consistenceLowerLimitSpot?: number | null;
  consistenceStandard?: string | null;
  consistenceTestType?: string | null;
  consistenceUpperLimitSpot?: number | null;
  customerName?: string | null;
  rheometryPlasticViscosityPasAtPlantExit?: number | null;
  rheometryPlasticViscosityPasAtSiteArrival?: number | null;
  rheometryPlasticViscosityPasAtPour?: number | null;
  rheometryPlasticViscosityPasPredictionType?: string | null;
  rheometryYieldStressPaAtPlantExit?: number | null;
  rheometryYieldStressPaAtSiteArrival?: number | null;
  rheometryYieldStressPaAtPour?: number | null;
  rheometryYieldStressPaPredictionType?: string | null;
  rheometryStaticYieldStressTargetMinPa?: number | null;
  rheometryStaticYieldStressTargetMaxPa?: number | null;
  rheometryPlasticViscosityTargetMinPas?: number | null;
  rheometryPlasticViscosityTargetMaxPas?: number | null;
  waterAdditions?: string | null;
  additionalWaterMeasured?: number | null;
  additionalWaterDetected?: boolean | null;
  washoutWaterMeasured?: number | null;
  additionalWaterPerM3?: number | null;
  midPourWaterAdded?: number | null;
  prePourWaterAdded?: number | null;
  unclassifiedWaterAdded?: number | null;
  waterAddedAtPlant?: number | null;
  timezone?: string | null;
  tempAtLoadMix?: number | null;
  tempAtSiteArrival?: number | null;
  tempAtPour?: number | null;
  tempAtPlantExit?: number | null;
  consistenceSpeedPattern?: string | null;
  speedPatternAtSite?: string | null;
  consistencePredictionType?: string | null;
  deliveryTags?: Array<{
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  }> | null;
  batchToDepartureTimeMinutes?: number | null;
  outboundTransitTimeMinutes?: number | null;
  siteWaitTimeMinutes?: number | null;
  pouringTimeMinutes?: number | null;
  leavingSiteTimeMinutes?: number | null;
  totalSiteTimeMinutes?: number | null;
  inboundTransitTimeMinutes?: number | null;
  totalCycleTimeMinutes?: number | null;
  deliveryManualTests?: Array<{
    __typename: "OrderSvcManualTest";
    id: number;
    docketId: string;
    type: string;
    result: number;
    testResult: number;
    unit: string;
    testTime: string;
    createdBy: string;
    comment?: string | null;
    mediaS3Key?: string | null;
    accepted?: boolean | null;
    acceptanceReason?: string | null;
    reviewedBy?: string | null;
  }> | null;
  allowableWaterToAddLitres?: number | null;
  excessWaterAddedDuringBatchingLitres?: number | null;
  mixDesignCode?: string | null;
  docketTargetWeights?: {
    __typename: "DocketMixDesign";
    maxWaterCementRatio?: number | null;
    aggregate?: Array<{
      __typename: "DocketAggregate";
      name?: string | null;
      type?: string | null;
      maxSizeMM?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    fillers?: Array<{
      __typename: "DocketFiller";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    water?: Array<{
      __typename: "DocketWater";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    binders?: Array<{
      __typename: "DocketBinder";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    admixture?: Array<{
      __typename: "DocketAdmixture";
      name?: string | null;
      value?: number | null;
      units?: string | null;
      type?: string | null;
    } | null> | null;
    reinforcement?: Array<{
      __typename: "DocketReinforcement";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
  } | null;
  docketBatchedWeights?: {
    __typename: "DocketBatchedWeights";
    aggregate?: Array<{
      __typename: "DocketAggregate";
      name?: string | null;
      type?: string | null;
      maxSizeMM?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    fillers?: Array<{
      __typename: "DocketFiller";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    water?: Array<{
      __typename: "DocketWater";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    binders?: Array<{
      __typename: "DocketBinder";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    admixture?: Array<{
      __typename: "DocketAdmixture";
      name?: string | null;
      value?: number | null;
      units?: string | null;
      type?: string | null;
    } | null> | null;
    reinforcement?: Array<{
      __typename: "DocketReinforcement";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
  } | null;
  docketTestResults?: Array<{
    __typename: "DocketTestResult";
    type?: string | null;
    value?: number | null;
    units?: string | null;
    datetimeUTC?: string | null;
  } | null> | null;
  spinUpStatus?: string | null;
  spinUpStatusUpdateTime?: string | null;
  mediaCount?: number | null;
  commentCount?: number | null;
  comments?: Array<string> | null;
  spinUpStatusBeforeFirstNonSamplePour?: string | null;
  spinUpStatusBeforeLastSamplePour?: string | null;
  emptyDrumStage?: string | null;
  emptyDrumType?: string | null;
  emptyDrumTime?: string | null;
  truckConfig?: {
    __typename: "DocketTruckConfig";
    physical?: {
      __typename: "DocketPhysicalTruckConfig";
      gearboxRatio?: number | null;
      hydraulicMotorDisplacementCc?: number | null;
      drumVolumeM3?: number | null;
      isChargingClockwise?: boolean | null;
      isPressureId1Charging?: boolean | null;
      isPressureBInsulated?: boolean | null;
      pressureSensorLocation?: string | null;
    } | null;
    operations?: {
      __typename: "DocketOperationsTruckConfig";
      isDmTemperatureFault?: boolean | null;
      isDmFault?: boolean | null;
      isFmFault?: boolean | null;
      isCbFault?: boolean | null;
      isDmFitted?: boolean | null;
      isFmFitted?: boolean | null;
      maintenanceStatus?: string | null;
      cbMountingLocation?: string | null;
      cbMountingDirection?: string | null;
    } | null;
    globalConfig?: {
      __typename: "DocketGlobalTruckConfig";
      isWhitelisted?: boolean | null;
      isOffTheRoad?: boolean | null;
      isVirtual?: boolean | null;
      rpmSensor?: string | null;
      misc?: string | null;
      manufacturer?: string | null;
      model?: string | null;
      noConsistence?: boolean | null;
      noConsistenceDescription?: string | null;
    } | null;
  } | null;
  concreteVolumeM3AtPlantExit?: number | null;
  concreteVolumeM3AtSiteArrival?: number | null;
  concreteVolumeM3AtPour?: number | null;
  concreteVolumeM3AtSiteExit?: number | null;
  airPercentAtPlantExit?: number | null;
  airPercentAtSiteArrival?: number | null;
  airPercentAtPour?: number | null;
  airPercentAtSiteExit?: number | null;
  airPercentAtLoadMix?: number | null;
  weatherTempDegcAtPlant?: number | null;
  weatherCodeAtPlant?: number | null;
  weatherTempDegcAtSiteArrival?: number | null;
  weatherCodeAtSiteArrival?: number | null;
  deviceHealthStatus?: string | null;
};

export type OrderSvcGetOrderDeliveryTimeseriesQuery = {
  __typename: "OrderSvcDeliveryTimeseries";
  timeseries?: Array<{
    __typename: "Timeseries";
    timestamp?: string | null;
    geo?: string | null;
    rpm?: number | null;
    pressure?: number | null;
    pressureABarMean?: number | null;
    pressureBBarMean?: number | null;
    temp?: number | null;
    consistenceMm?: number | null;
    consistenceMmQualifier?: string | null;
    consistenceMinMm?: number | null;
    consistenceMaxMm?: number | null;
    rheometryPlasticViscosityPas?: number | null;
    rheometryStaticYieldStressPa?: number | null;
    gpsLongitudes?: string | null;
    gpsLatitudes?: string | null;
    percentAir?: number | null;
    concreteVolume?: number | null;
  } | null> | null;
};

export type OrderSvcGetDocketQuery = {
  __typename: "OrderSvcDocket";
  id?: string | null;
  rmcId?: string | null;
  status?: DocketStatus | null;
  docketId?: string | null;
  docketId1?: string | null;
  orderCode?: string | null;
  slumpCode?: string | null;
  slumpDescription?: string | null;
  truckPlate?: string | null;
  extTruckName?: string | null;
  truckId?: number | null;
  truckImei?: string | null;
  truckReg?: string | null;
  jobsiteCode?: string | null;
  jobsiteDescription?: string | null;
  jobsiteLongitude?: number | null;
  jobsiteLatitude?: number | null;
  plantCode?: string | null;
  plantLongitude?: number | null;
  plantLatitude?: number | null;
  rmcCustomerId?: string | null;
  rmcCustomerName?: string | null;
  datetimeBatchLocal?: string | null;
  datetimeBatch?: string | null;
  aggregateSizeCode?: string | null;
  aggregateSizeDescription?: string | null;
  deliveredQuantity?: number | null;
  technicalProductCode?: string | null;
  technicalProductDescription?: string | null;
  commercialProductCode?: string | null;
  commercialProductDescription?: string | null;
  unitDescription?: string | null;
  unitCode?: string | null;
  consistenceClass?: string | null;
  consistenceTarget?: number | null;
  consistenceClassMax?: number | null;
  consistenceClassMin?: number | null;
  consistenceStandard?: string | null;
  consistenceTestType?: string | null;
  consistenceLowerLimitSpot?: number | null;
  consistenceUpperLimitSpot?: number | null;
  allowableWaterToAddLitres?: number | null;
  excessWaterAddedDuringBatchingLitres?: number | null;
  mixDesignCode?: string | null;
  targetWeights?: {
    __typename: "DocketMixDesign";
    maxWaterCementRatio?: number | null;
    aggregate?: Array<{
      __typename: "DocketAggregate";
      name?: string | null;
      type?: string | null;
      maxSizeMM?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    fillers?: Array<{
      __typename: "DocketFiller";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    water?: Array<{
      __typename: "DocketWater";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    binders?: Array<{
      __typename: "DocketBinder";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    admixture?: Array<{
      __typename: "DocketAdmixture";
      name?: string | null;
      value?: number | null;
      units?: string | null;
      type?: string | null;
    } | null> | null;
    reinforcement?: Array<{
      __typename: "DocketReinforcement";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
  } | null;
  batchedWeights?: {
    __typename: "DocketBatchedWeights";
    aggregate?: Array<{
      __typename: "DocketAggregate";
      name?: string | null;
      type?: string | null;
      maxSizeMM?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    fillers?: Array<{
      __typename: "DocketFiller";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    water?: Array<{
      __typename: "DocketWater";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    binders?: Array<{
      __typename: "DocketBinder";
      type?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
    admixture?: Array<{
      __typename: "DocketAdmixture";
      name?: string | null;
      value?: number | null;
      units?: string | null;
      type?: string | null;
    } | null> | null;
    reinforcement?: Array<{
      __typename: "DocketReinforcement";
      name?: string | null;
      value?: number | null;
      units?: string | null;
    } | null> | null;
  } | null;
  testResults?: Array<{
    __typename: "DocketTestResult";
    type?: string | null;
    value?: number | null;
    units?: string | null;
    datetimeUTC?: string | null;
  } | null> | null;
  truckConfig?: {
    __typename: "DocketTruckConfig";
    physical?: {
      __typename: "DocketPhysicalTruckConfig";
      gearboxRatio?: number | null;
      hydraulicMotorDisplacementCc?: number | null;
      drumVolumeM3?: number | null;
      isChargingClockwise?: boolean | null;
      isPressureId1Charging?: boolean | null;
      isPressureBInsulated?: boolean | null;
      pressureSensorLocation?: string | null;
    } | null;
    operations?: {
      __typename: "DocketOperationsTruckConfig";
      isDmTemperatureFault?: boolean | null;
      isDmFault?: boolean | null;
      isFmFault?: boolean | null;
      isCbFault?: boolean | null;
      isDmFitted?: boolean | null;
      isFmFitted?: boolean | null;
      maintenanceStatus?: string | null;
      cbMountingLocation?: string | null;
      cbMountingDirection?: string | null;
    } | null;
    globalConfig?: {
      __typename: "DocketGlobalTruckConfig";
      isWhitelisted?: boolean | null;
      isOffTheRoad?: boolean | null;
      isVirtual?: boolean | null;
      rpmSensor?: string | null;
      misc?: string | null;
      manufacturer?: string | null;
      model?: string | null;
      noConsistence?: boolean | null;
      noConsistenceDescription?: string | null;
    } | null;
  } | null;
  timezone?: string | null;
  weatherTempDegcAtPlant?: number | null;
  weatherCodeAtPlant?: number | null;
};

export type OrderSvcGetJobsitePourLocationsQuery = {
  __typename: "OrderSvcPourLocation";
  docketId?: string | null;
  pourLocation?: string | null;
  pourTime?: string | null;
};

export type OrderSvcGetDeliveryHealthQuery = {
  __typename: "OrderSvcDeliveryHealth";
  checks?: string | null;
};

export type OrderSvcSearchTagsQuery = {
  __typename: "OrderSvcTags";
  tags: Array<{
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null>;
  nextToken?: string | null;
};

export type OrderSvcGetTagsByRmcQuery = {
  __typename: "OrderSvcTags";
  tags: Array<{
    __typename: "OrderSvcTag";
    id: number;
    rmcId: string;
    name: string;
    usageCount?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null>;
  nextToken?: string | null;
};

export type OrderSvcGetJobsitesForRmcQuery = {
  __typename: "OrderSvcListJobsitesResponse";
  jobsites?: Array<{
    __typename: "OrderSvcJobsite";
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
  }> | null;
  cursor?: string | null;
};

export type OrderSvcGetCustomersForRmcQuery = {
  __typename: "OrderSvcListCustomersResponse";
  customers?: Array<{
    __typename: "OrderSvcCustomer";
    customerId: string;
    customerName: string;
  }> | null;
  cursor?: string | null;
};

export type OrderSvcGetManualTestMediaFileLinkQuery = {
  __typename: "OrderSvcGetManualTestMediaFileLinkResponse";
  mediaFileLink?: string | null;
};

export type OrderSvcListPendingManualTestsQuery = {
  __typename: "OrderSvcListPendingManualTestsResponse";
  manualTests: Array<{
    __typename: "OrderSvcManualTest";
    id: number;
    docketId: string;
    type: string;
    result: number;
    testResult: number;
    unit: string;
    testTime: string;
    createdBy: string;
    comment?: string | null;
    mediaS3Key?: string | null;
    accepted?: boolean | null;
    acceptanceReason?: string | null;
    reviewedBy?: string | null;
  }>;
  cursor?: string | null;
};

export type OrderSvcSearchOrderSvcTripQuery = {
  __typename: "SearchOrderSvcTripResponse";
  deliveries?: Array<{
    __typename: "OrderSvcTrip";
    rmcId?: string | null;
    truckPlate?: string | null;
    extTruckName?: string | null;
    truckImei?: string | null;
    tripStartTime?: string | null;
    tripEndTime?: string | null;
    datetimeBatch?: string | null;
    slumpCode?: string | null;
    orderCode?: string | null;
    docketId?: string | null;
    docketId1?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    technicalProductCode?: string | null;
    technicalProductDescription?: string | null;
    deliveredQuantity?: number | null;
    plantCode?: string | null;
    jobsiteCode?: string | null;
    jobsiteDescription?: string | null;
    pourTime?: string | null;
    pourEvents?: string | null;
    pourLocation?: string | null;
    siteLocation?: string | null;
    plantLocation?: string | null;
    plantName?: string | null;
    loadingPoint?: string | null;
    leftBatchPlant?: string | null;
    arrivedAtSite?: string | null;
    leftSite?: string | null;
    consistenceMmAtLoadMix?: number | null;
    consistenceMmAtLoadMixOk?: boolean | null;
    consistenceMmQualifierAtLoadMix?: string | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmAtPlantExitOk?: boolean | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtSiteArrivalOk?: boolean | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    consistenceMmAtPour?: number | null;
    consistenceMmAtPourOk?: boolean | null;
    consistenceMmQualifierAtPour?: string | null;
    consistenceClass?: string | null;
    consistenceTarget?: number | null;
    consistenceClassMax?: number | null;
    consistenceClassMin?: number | null;
    consistenceLowerLimitSpot?: number | null;
    consistenceStandard?: string | null;
    consistenceTestType?: string | null;
    consistenceUpperLimitSpot?: number | null;
    customerName?: string | null;
    rheometryPlasticViscosityPasAtPlantExit?: number | null;
    rheometryPlasticViscosityPasAtSiteArrival?: number | null;
    rheometryPlasticViscosityPasAtPour?: number | null;
    rheometryPlasticViscosityPasPredictionType?: string | null;
    rheometryYieldStressPaAtPlantExit?: number | null;
    rheometryYieldStressPaAtSiteArrival?: number | null;
    rheometryYieldStressPaAtPour?: number | null;
    rheometryYieldStressPaPredictionType?: string | null;
    rheometryStaticYieldStressTargetMinPa?: number | null;
    rheometryStaticYieldStressTargetMaxPa?: number | null;
    rheometryPlasticViscosityTargetMinPas?: number | null;
    rheometryPlasticViscosityTargetMaxPas?: number | null;
    waterAdditions?: string | null;
    additionalWaterMeasured?: number | null;
    additionalWaterDetected?: boolean | null;
    washoutWaterMeasured?: number | null;
    additionalWaterPerM3?: number | null;
    midPourWaterAdded?: number | null;
    prePourWaterAdded?: number | null;
    unclassifiedWaterAdded?: number | null;
    waterAddedAtPlant?: number | null;
    timezone?: string | null;
    tempAtLoadMix?: number | null;
    tempAtSiteArrival?: number | null;
    tempAtPour?: number | null;
    tempAtPlantExit?: number | null;
    consistenceSpeedPattern?: string | null;
    speedPatternAtSite?: string | null;
    consistencePredictionType?: string | null;
    deliveryTags?: Array<{
      __typename: "OrderSvcTag";
      id: number;
      rmcId: string;
      name: string;
      usageCount?: number | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    }> | null;
    batchToDepartureTimeMinutes?: number | null;
    outboundTransitTimeMinutes?: number | null;
    siteWaitTimeMinutes?: number | null;
    pouringTimeMinutes?: number | null;
    leavingSiteTimeMinutes?: number | null;
    totalSiteTimeMinutes?: number | null;
    inboundTransitTimeMinutes?: number | null;
    totalCycleTimeMinutes?: number | null;
    deliveryManualTests?: Array<{
      __typename: "OrderSvcManualTest";
      id: number;
      docketId: string;
      type: string;
      result: number;
      testResult: number;
      unit: string;
      testTime: string;
      createdBy: string;
      comment?: string | null;
      mediaS3Key?: string | null;
      accepted?: boolean | null;
      acceptanceReason?: string | null;
      reviewedBy?: string | null;
    }> | null;
    allowableWaterToAddLitres?: number | null;
    excessWaterAddedDuringBatchingLitres?: number | null;
    mixDesignCode?: string | null;
    docketTargetWeights?: {
      __typename: "DocketMixDesign";
      maxWaterCementRatio?: number | null;
      aggregate?: Array<{
        __typename: "DocketAggregate";
        name?: string | null;
        type?: string | null;
        maxSizeMM?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      fillers?: Array<{
        __typename: "DocketFiller";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      water?: Array<{
        __typename: "DocketWater";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      binders?: Array<{
        __typename: "DocketBinder";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      admixture?: Array<{
        __typename: "DocketAdmixture";
        name?: string | null;
        value?: number | null;
        units?: string | null;
        type?: string | null;
      } | null> | null;
      reinforcement?: Array<{
        __typename: "DocketReinforcement";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
    } | null;
    docketBatchedWeights?: {
      __typename: "DocketBatchedWeights";
      aggregate?: Array<{
        __typename: "DocketAggregate";
        name?: string | null;
        type?: string | null;
        maxSizeMM?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      fillers?: Array<{
        __typename: "DocketFiller";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      water?: Array<{
        __typename: "DocketWater";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      binders?: Array<{
        __typename: "DocketBinder";
        type?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
      admixture?: Array<{
        __typename: "DocketAdmixture";
        name?: string | null;
        value?: number | null;
        units?: string | null;
        type?: string | null;
      } | null> | null;
      reinforcement?: Array<{
        __typename: "DocketReinforcement";
        name?: string | null;
        value?: number | null;
        units?: string | null;
      } | null> | null;
    } | null;
    docketTestResults?: Array<{
      __typename: "DocketTestResult";
      type?: string | null;
      value?: number | null;
      units?: string | null;
      datetimeUTC?: string | null;
    } | null> | null;
    spinUpStatus?: string | null;
    spinUpStatusUpdateTime?: string | null;
    mediaCount?: number | null;
    commentCount?: number | null;
    comments?: Array<string> | null;
    spinUpStatusBeforeFirstNonSamplePour?: string | null;
    spinUpStatusBeforeLastSamplePour?: string | null;
    emptyDrumStage?: string | null;
    emptyDrumType?: string | null;
    emptyDrumTime?: string | null;
    truckConfig?: {
      __typename: "DocketTruckConfig";
      physical?: {
        __typename: "DocketPhysicalTruckConfig";
        gearboxRatio?: number | null;
        hydraulicMotorDisplacementCc?: number | null;
        drumVolumeM3?: number | null;
        isChargingClockwise?: boolean | null;
        isPressureId1Charging?: boolean | null;
        isPressureBInsulated?: boolean | null;
        pressureSensorLocation?: string | null;
      } | null;
      operations?: {
        __typename: "DocketOperationsTruckConfig";
        isDmTemperatureFault?: boolean | null;
        isDmFault?: boolean | null;
        isFmFault?: boolean | null;
        isCbFault?: boolean | null;
        isDmFitted?: boolean | null;
        isFmFitted?: boolean | null;
        maintenanceStatus?: string | null;
        cbMountingLocation?: string | null;
        cbMountingDirection?: string | null;
      } | null;
      globalConfig?: {
        __typename: "DocketGlobalTruckConfig";
        isWhitelisted?: boolean | null;
        isOffTheRoad?: boolean | null;
        isVirtual?: boolean | null;
        rpmSensor?: string | null;
        misc?: string | null;
        manufacturer?: string | null;
        model?: string | null;
        noConsistence?: boolean | null;
        noConsistenceDescription?: string | null;
      } | null;
    } | null;
    concreteVolumeM3AtPlantExit?: number | null;
    concreteVolumeM3AtSiteArrival?: number | null;
    concreteVolumeM3AtPour?: number | null;
    concreteVolumeM3AtSiteExit?: number | null;
    airPercentAtPlantExit?: number | null;
    airPercentAtSiteArrival?: number | null;
    airPercentAtPour?: number | null;
    airPercentAtSiteExit?: number | null;
    airPercentAtLoadMix?: number | null;
    weatherTempDegcAtPlant?: number | null;
    weatherCodeAtPlant?: number | null;
    weatherTempDegcAtSiteArrival?: number | null;
    weatherCodeAtSiteArrival?: number | null;
    deviceHealthStatus?: string | null;
  }> | null;
  cursor?: number | null;
  errors?: Array<string> | null;
};

export type OrderSvcGetUserQueryQuery = {
  __typename: "OrderSvcUserQuery";
  id: number;
  name: string;
  type: OrderSvcUserQueryType;
  description?: string | null;
  usageCount: number;
  queryPayload: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
};

export type OrderSvcListUserQueriesQuery = {
  __typename: "OrderSvcListUserQueriesResponse";
  queries: Array<{
    __typename: "OrderSvcUserQuery";
    id: number;
    name: string;
    type: OrderSvcUserQueryType;
    description?: string | null;
    usageCount: number;
    queryPayload: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  }>;
  cursor?: string | null;
};

export type OrderSvcSearchOrderSvcOrderQuery = {
  __typename: "SearchOrderSvcOrderResponse";
  orders?: Array<{
    __typename: "OrderSvcListOrders";
    rmcId?: string | null;
    orderCode?: string | null;
    slumpCode?: string | null;
    jobsiteDescription?: string | null;
    jobsiteCode?: string | null;
    commercialProductCode?: string | null;
    commercialProductDescription?: string | null;
    aggregateSize?: string | null;
    deliveryQuantity?: number | null;
    consistenceTarget?: number | null;
    consistenceClass?: string | null;
    rmcCustomerName?: string | null;
    deliveries?: number | null;
    volumeDelivered?: number | null;
    firstBatchingTimestamp?: string | null;
    lastBatchingTimestamp?: string | null;
    timezone?: string | null;
  }> | null;
  cursor?: string | null;
  errors?: Array<string> | null;
};

export type UserServiceRequestReportUploadQuery = {
  __typename: "ReportsResponse";
  success: boolean;
  item?: string | null;
  items?: Array<string> | null;
};

export type UserServiceListReportsQuery = {
  __typename: "ReportsResponse";
  success: boolean;
  item?: string | null;
  items?: Array<string> | null;
};

export type UserServiceRequestReportFileLinkQuery = {
  __typename: "ReportsResponse";
  success: boolean;
  item?: string | null;
  items?: Array<string> | null;
};

export type UserServiceDeleteReportQuery = {
  __typename: "ReportsResponse";
  success: boolean;
  item?: string | null;
  items?: Array<string> | null;
};

export type UserSvcListRmcUsersQuery = {
  __typename: "ListCognitoUsersOutput";
  items: Array<{
    __typename: "CognitoUserDetail";
    username: string;
    email: string;
    phoneNumber: string;
    givenName?: string | null;
    familyName?: string | null;
    jobTitle?: string | null;
    status?: string | null;
    enabled?: boolean | null;
    groups?: Array<string> | null;
    created?: string | null;
    lastModified?: string | null;
  }>;
};

export type UserSvcGetUserQuery = {
  __typename: "GetCognitoUserOutput";
  user: {
    __typename: "CognitoUserDetail";
    username: string;
    email: string;
    phoneNumber: string;
    givenName?: string | null;
    familyName?: string | null;
    jobTitle?: string | null;
    status?: string | null;
    enabled?: boolean | null;
    groups?: Array<string> | null;
    created?: string | null;
    lastModified?: string | null;
  };
};

export type UserSvcRbacGetUserQuery = {
  __typename: "User";
  subId: string;
  tenant: string;
  firstName?: string | null;
  lastName?: string | null;
  groups: Array<{
    __typename: "Group";
    id: string;
    parentId?: string | null;
    tenant: string;
    name: string;
    description?: string | null;
    roles: Array<{
      __typename: "Role";
      id: string;
      name: string;
      description?: string | null;
      abilities: Array<{
        __typename: "Ability";
        id: string;
        action: string;
        subject: string;
        fields?: Array<string> | null;
        conditions?: string | null;
        inverted: boolean;
        description?: string | null;
        readonly: boolean;
      }>;
      readonly: boolean;
    }>;
  }>;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
};

export type UserSvcRbacListUsersQuery = {
  __typename: "UserConnection";
  items: Array<{
    __typename: "User";
    subId: string;
    tenant: string;
    firstName?: string | null;
    lastName?: string | null;
    groups: Array<{
      __typename: "Group";
      id: string;
      parentId?: string | null;
      tenant: string;
      name: string;
      description?: string | null;
      roles: Array<{
        __typename: "Role";
        id: string;
        name: string;
        description?: string | null;
        abilities: Array<{
          __typename: "Ability";
          id: string;
          action: string;
          subject: string;
          fields?: Array<string> | null;
          conditions?: string | null;
          inverted: boolean;
          description?: string | null;
          readonly: boolean;
        }>;
        readonly: boolean;
      }>;
    }>;
    roles: Array<{
      __typename: "Role";
      id: string;
      name: string;
      description?: string | null;
      abilities: Array<{
        __typename: "Ability";
        id: string;
        action: string;
        subject: string;
        fields?: Array<string> | null;
        conditions?: string | null;
        inverted: boolean;
        description?: string | null;
        readonly: boolean;
      }>;
      readonly: boolean;
    }>;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
  }>;
  nextToken?: string | null;
};

export type UserSvcRbacGetGroupQuery = {
  __typename: "Group";
  id: string;
  parentId?: string | null;
  tenant: string;
  name: string;
  description?: string | null;
  roles: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
};

export type UserSvcRbacListGroupsQuery = {
  __typename: "GroupConnection";
  items: Array<{
    __typename: "Group";
    id: string;
    parentId?: string | null;
    tenant: string;
    name: string;
    description?: string | null;
    roles: Array<{
      __typename: "Role";
      id: string;
      name: string;
      description?: string | null;
      abilities: Array<{
        __typename: "Ability";
        id: string;
        action: string;
        subject: string;
        fields?: Array<string> | null;
        conditions?: string | null;
        inverted: boolean;
        description?: string | null;
        readonly: boolean;
      }>;
      readonly: boolean;
    }>;
  }>;
  nextToken?: string | null;
};

export type UserSvcRbacGetRoleQuery = {
  __typename: "Role";
  id: string;
  name: string;
  description?: string | null;
  abilities: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
  readonly: boolean;
};

export type UserSvcRbacListRolesQuery = {
  __typename: "RoleConnection";
  items: Array<{
    __typename: "Role";
    id: string;
    name: string;
    description?: string | null;
    abilities: Array<{
      __typename: "Ability";
      id: string;
      action: string;
      subject: string;
      fields?: Array<string> | null;
      conditions?: string | null;
      inverted: boolean;
      description?: string | null;
      readonly: boolean;
    }>;
    readonly: boolean;
  }>;
  nextToken?: string | null;
};

export type UserSvcRbacGetAbilityQuery = {
  __typename: "Ability";
  id: string;
  action: string;
  subject: string;
  fields?: Array<string> | null;
  conditions?: string | null;
  inverted: boolean;
  description?: string | null;
  readonly: boolean;
};

export type UserSvcRbacListAbilitiesQuery = {
  __typename: "AbilityConnection";
  items: Array<{
    __typename: "Ability";
    id: string;
    action: string;
    subject: string;
    fields?: Array<string> | null;
    conditions?: string | null;
    inverted: boolean;
    description?: string | null;
    readonly: boolean;
  }>;
  nextToken?: string | null;
};

export type LocationSvcGetHierarchyQuery = {
  __typename: "TaxonomyHierarchyRecord";
  id: string;
  parentId?: string | null;
  rmc?: string | null;
  groupName?: string | null;
  groupType?: string | null;
  groupDescription?: string | null;
  batchPlantIds: Array<string>;
};

export type WeatherSvcGetWeatherDataQuery = {
  __typename: "WeatherSvcWeatherData";
  weatherTemp: number;
  weatherCode: number;
  weatherDesc: string;
};

export type LocationSvcGetLocationsForRMCProviderQuery = {
  __typename: "LocationSvcGetLocationsForRMCProviderResponse";
  items?: Array<{
    __typename: "Geolocation";
    Owner: string;
    OwnerId: string;
    ParentId?: string | null;
    Name?: string | null;
    Type?: string | null;
    Lng?: string | null;
    Lat?: string | null;
    Polygon?: string | null;
    Status?: string | null;
    Timezone?: string | null;
    TimezoneDate?: string | null;
    LoadingPoints?: string | null;
    LastDeliveryTimestamp?: number | null;
  } | null> | null;
  nextToken?: string | null;
};

export type LocationSvcGetLatestDeliveryLocationsQuery = {
  __typename: "LocationSvcGetLocationsForRMCProviderResponse";
  items?: Array<{
    __typename: "Geolocation";
    Owner: string;
    OwnerId: string;
    ParentId?: string | null;
    Name?: string | null;
    Type?: string | null;
    Lng?: string | null;
    Lat?: string | null;
    Polygon?: string | null;
    Status?: string | null;
    Timezone?: string | null;
    TimezoneDate?: string | null;
    LoadingPoints?: string | null;
    LastDeliveryTimestamp?: number | null;
  } | null> | null;
  nextToken?: string | null;
};

export type BfdSvcListImeisQuery = {
  __typename: "BFDSvcImeiList";
  items: Array<{
    __typename: "BFDSvcImei";
    imei: string;
  }>;
  nextToken?: string | null;
};

export type BfdSvcGetImeiQuery = {
  __typename: "BFDSvcImei";
  imei: string;
};

export type DashboardSvcGetBatchingPerformanceDashboardQuery = {
  __typename: "BatchingPerformanceDashboardResponse";
  deliveries: Array<{
    __typename: "BatchingPerformanceDashboardDelivery";
    rmcId: string;
    docketId: string;
    plantCode: string;
    plantName?: string | null;
    siteName?: string | null;
    consistenceClass?: string | null;
    consistenceMmAtSiteArrival?: number | null;
    consistenceMmAtPlantExit?: number | null;
    consistenceMmQualifierAtPlantExit?: string | null;
    consistenceMmQualifierAtSiteArrival?: string | null;
    statusAtPlantExit?: PlantStatusAtDeliveryStage | null;
    statusAtSiteArrival?: PlantStatusAtDeliveryStage | null;
  }>;
  metadata: {
    __typename: "BatchingPerformanceDashboardMetadata";
    granularity: Granularity;
    period: string;
    periodLabel: string;
    plantCodes: Array<string>;
    generatedAt: string;
    consistenceClassHistogramRange: Array<{
      __typename: "DashboardMetadataConsistenceClassRangeEntry";
      consistenceClass: string;
      consistenceClassRange: {
        __typename: "DashboardMetadataConsistenceRangeEntry";
        min_mm: number;
        max_mm: number;
      };
    }>;
    consistenceTestTypeRange: {
      __typename: "DashboardMetadataConsistenceTestTypeRange";
      slumpTest: {
        __typename: "DashboardMetadataConsistenceRangeEntry";
        min_mm: number;
        max_mm: number;
      };
      flowTest: {
        __typename: "DashboardMetadataConsistenceRangeEntry";
        min_mm: number;
        max_mm: number;
      };
      slumpflowTest: {
        __typename: "DashboardMetadataConsistenceRangeEntry";
        min_mm: number;
        max_mm: number;
      };
    };
  };
  thresholds: {
    __typename: "DashboardMetadataThresholds";
    plantPerformance: {
      __typename: "DashboardMetadataThresholdEntry";
      metric: string;
      bands: Array<{
        __typename: "DashboardMetadataThresholdMetricEntry";
        status?: string | null;
        min: number;
        max: number;
      }>;
    };
    percentMixedAtPlant: {
      __typename: "DashboardMetadataThresholdEntry";
      metric: string;
      bands: Array<{
        __typename: "DashboardMetadataThresholdMetricEntry";
        status?: string | null;
        min: number;
        max: number;
      }>;
    };
    periodOverPeriodChange: {
      __typename: "DashboardMetadataThresholdEntry";
      metric: string;
      bands: Array<{
        __typename: "DashboardMetadataThresholdMetricEntry";
        status?: string | null;
        min: number;
        max: number;
      }>;
    };
  };
  plantLeaderboard?: {
    __typename: "DashboardPlantLeaderboard";
    maxScore: number;
    rankings: Array<{
      __typename: "DashboardPlantLeaderboardEntry";
      rank: number;
      plantCode: string;
      plantName?: string | null;
      score?: number | null;
    }>;
  } | null;
  plantPerformance?: {
    __typename: "DashboardPlantPerformance";
    unit: string;
    siteArrival: Array<{
      __typename: "DashboardPlantPerformanceEntry";
      plantCode: string;
      plantName?: string | null;
      value: number;
      deliveriesWithDigitalConsistence: number;
    }>;
    plantExit: Array<{
      __typename: "DashboardPlantPerformanceEntry";
      plantCode: string;
      plantName?: string | null;
      value: number;
      deliveriesWithDigitalConsistence: number;
    }>;
  } | null;
  plantPerformanceOverTime?: {
    __typename: "DashboardPlantPerformanceOverTime";
    unit: string;
    siteArrival: {
      __typename: "DashboardPerformanceOverTime";
      last6Weeks: {
        __typename: "DashboardPerformanceOverTimeForPlant";
        all: Array<{
          __typename: "DashboardPerformanceOverTimeSeries";
          key: string;
          label: string;
          points: Array<{
            __typename: "DashboardPerformanceOverTimePoint";
            bucket: string;
            bucketLabel: string;
            value: number;
            deliveriesWithDigitalConsistence: number;
          }>;
        }>;
        byPlant: Array<{
          __typename: "DashboardPerformanceOverTimePlantEntry";
          plantCode: string;
          series: Array<{
            __typename: "DashboardPerformanceOverTimeSeries";
            key: string;
            label: string;
            points: Array<{
              __typename: "DashboardPerformanceOverTimePoint";
              bucket: string;
              bucketLabel: string;
              value: number;
              deliveriesWithDigitalConsistence: number;
            }>;
          }>;
        }>;
      };
      last6Months: {
        __typename: "DashboardPerformanceOverTimeForPlant";
        all: Array<{
          __typename: "DashboardPerformanceOverTimeSeries";
          key: string;
          label: string;
          points: Array<{
            __typename: "DashboardPerformanceOverTimePoint";
            bucket: string;
            bucketLabel: string;
            value: number;
            deliveriesWithDigitalConsistence: number;
          }>;
        }>;
        byPlant: Array<{
          __typename: "DashboardPerformanceOverTimePlantEntry";
          plantCode: string;
          series: Array<{
            __typename: "DashboardPerformanceOverTimeSeries";
            key: string;
            label: string;
            points: Array<{
              __typename: "DashboardPerformanceOverTimePoint";
              bucket: string;
              bucketLabel: string;
              value: number;
              deliveriesWithDigitalConsistence: number;
            }>;
          }>;
        }>;
      };
    };
    plantExit: {
      __typename: "DashboardPerformanceOverTime";
      last6Weeks: {
        __typename: "DashboardPerformanceOverTimeForPlant";
        all: Array<{
          __typename: "DashboardPerformanceOverTimeSeries";
          key: string;
          label: string;
          points: Array<{
            __typename: "DashboardPerformanceOverTimePoint";
            bucket: string;
            bucketLabel: string;
            value: number;
            deliveriesWithDigitalConsistence: number;
          }>;
        }>;
        byPlant: Array<{
          __typename: "DashboardPerformanceOverTimePlantEntry";
          plantCode: string;
          series: Array<{
            __typename: "DashboardPerformanceOverTimeSeries";
            key: string;
            label: string;
            points: Array<{
              __typename: "DashboardPerformanceOverTimePoint";
              bucket: string;
              bucketLabel: string;
              value: number;
              deliveriesWithDigitalConsistence: number;
            }>;
          }>;
        }>;
      };
      last6Months: {
        __typename: "DashboardPerformanceOverTimeForPlant";
        all: Array<{
          __typename: "DashboardPerformanceOverTimeSeries";
          key: string;
          label: string;
          points: Array<{
            __typename: "DashboardPerformanceOverTimePoint";
            bucket: string;
            bucketLabel: string;
            value: number;
            deliveriesWithDigitalConsistence: number;
          }>;
        }>;
        byPlant: Array<{
          __typename: "DashboardPerformanceOverTimePlantEntry";
          plantCode: string;
          series: Array<{
            __typename: "DashboardPerformanceOverTimeSeries";
            key: string;
            label: string;
            points: Array<{
              __typename: "DashboardPerformanceOverTimePoint";
              bucket: string;
              bucketLabel: string;
              value: number;
              deliveriesWithDigitalConsistence: number;
            }>;
          }>;
        }>;
      };
    };
  } | null;
  periodOverPeriodChange?: {
    __typename: "DashboardPeriodOverPeriodChange";
    unit: string;
    comparison: {
      __typename: "DashboardPeriodOverPeriodComparison";
      granularity: Granularity;
      currentPeriod: {
        __typename: "PeriodInfo";
        key: string;
        label: string;
      };
      previousPeriod: {
        __typename: "PeriodInfo";
        key: string;
        label: string;
      };
    };
    siteArrival: Array<{
      __typename: "DashboardPeriodOverPeriodChangeEntry";
      plantCode: string;
      plantName?: string | null;
      value: number;
      currentValue: number;
      previousValue: number;
      deliveriesWithDigitalConsistence: number;
    }>;
    plantExit: Array<{
      __typename: "DashboardPeriodOverPeriodChangeEntry";
      plantCode: string;
      plantName?: string | null;
      value: number;
      currentValue: number;
      previousValue: number;
      deliveriesWithDigitalConsistence: number;
    }>;
  } | null;
  percentMixedAtPlant?: {
    __typename: "DashboardPercentMixedAtPlant";
    unit: string;
    values: Array<{
      __typename: "DashboardPlantPerformanceEntry";
      plantCode: string;
      plantName?: string | null;
      value: number;
      deliveriesWithDigitalConsistence: number;
    }>;
  } | null;
};

export type SubscribeLoadingPointSpeedPatternSubscription = {
  __typename: "LoadingPointSpeedPatternUpdate";
  imei: string;
  eventType?: string | null;
  rmcProvider: string;
  plantCode: string;
  loadingPoint: string;
  truckPlate?: string | null;
  datetimeBatch?: string | null;
  leftBatchPlant?: string | null;
  systemDatetimeUtcStr?: string | null;
  batchSpeedPattern?: string | null;
  batchSpeedPatternTime?: string | null;
  drumVectorRpm?: number | null;
};

export type LocationSvcOnLocationUpdateSubscription = {
  __typename: "GeolocationItem";
  owner: string;
  owner_id: string;
  parent_id?: string | null;
  name?: string | null;
  type?: string | null;
  lng?: string | null;
  lat?: string | null;
  polygon?: string | null;
  status?: string | null;
  timezone?: string | null;
  timezone_date?: string | null;
  loading_points?: string | null;
  last_delivery_timestamp?: number | null;
};

export type OnOrderSvcDownloadFileCompleteSubscription = {
  __typename: "OrderSvcDownloadFileCompleteNotification";
  jobId: string;
  status: string;
  csvFileLink?: string | null;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  public client: Client;
  constructor() {
    this.client = generateClient();
  }
  async PutTruck(
    IMEI: string,
    RMCProviderName: string,
    Truck?: TruckInput
  ): Promise<PutTruckMutation> {
    const statement = `mutation PutTruck($IMEI: String!, $RMCProviderName: String!, $Truck: TruckInput) {
        putTruck(IMEI: $IMEI, RMCProviderName: $RMCProviderName, Truck: $Truck) {
          __typename
          RMCProviderName
          IMEI
          Date
          Location {
            __typename
            lat
            lng
          }
          Registration
          DrumStatus
          DrumDirection
          DrumAverageRpm
          TruckStatus
          SlumpDescription
          RunId
          DateBatchLocal
          PredictionTripPosixTimestampStart
          SystemDatetimeUtcStr
          SystemDatetimePosixUtcSeconds
        }
      }`;
    const gqlAPIServiceArguments: any = {
      IMEI,
      RMCProviderName
    };
    if (Truck) {
      gqlAPIServiceArguments.Truck = Truck;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <PutTruckMutation>response.data.putTruck;
  }
  async UpdateLocation(
    IMEI: string,
    RMCProviderName: string,
    Location: LocationInput
  ): Promise<UpdateLocationMutation> {
    const statement = `mutation UpdateLocation($IMEI: String!, $RMCProviderName: String!, $Location: LocationInput!) {
        updateLocation(
          IMEI: $IMEI
          RMCProviderName: $RMCProviderName
          Location: $Location
        ) {
          __typename
          RMCProviderName
          IMEI
          Date
          Location {
            __typename
            lat
            lng
          }
          Registration
          DrumStatus
          DrumDirection
          DrumAverageRpm
          TruckStatus
          SlumpDescription
          RunId
          DateBatchLocal
          PredictionTripPosixTimestampStart
          SystemDatetimeUtcStr
          SystemDatetimePosixUtcSeconds
        }
      }`;
    const gqlAPIServiceArguments: any = {
      IMEI,
      RMCProviderName,
      Location
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UpdateLocationMutation>response.data.updateLocation;
  }
  async UpdateTruck(
    IMEI: string,
    RMCProviderName: string,
    Truck?: UpdateTruckInput
  ): Promise<UpdateTruckMutation> {
    const statement = `mutation UpdateTruck($IMEI: String!, $RMCProviderName: String!, $Truck: UpdateTruckInput) {
        updateTruck(IMEI: $IMEI, RMCProviderName: $RMCProviderName, Truck: $Truck) {
          __typename
          RMCProviderName
          IMEI
          Date
          Location {
            __typename
            lat
            lng
          }
          Registration
          DrumStatus
          DrumDirection
          DrumAverageRpm
          TruckStatus
          SlumpDescription
          RunId
          DateBatchLocal
          PredictionTripPosixTimestampStart
          SystemDatetimeUtcStr
          SystemDatetimePosixUtcSeconds
        }
      }`;
    const gqlAPIServiceArguments: any = {
      IMEI,
      RMCProviderName
    };
    if (Truck) {
      gqlAPIServiceArguments.Truck = Truck;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UpdateTruckMutation>response.data.updateTruck;
  }
  async PublishLoadingPointSpeedPattern(
    item: LoadingPointSpeedPatternUpdateInput
  ): Promise<PublishLoadingPointSpeedPatternMutation> {
    const statement = `mutation PublishLoadingPointSpeedPattern($item: LoadingPointSpeedPatternUpdateInput!) {
        publishLoadingPointSpeedPattern(item: $item) {
          __typename
          imei
          eventType
          rmcProvider
          plantCode
          loadingPoint
          truckPlate
          datetimeBatch
          leftBatchPlant
          systemDatetimeUtcStr
          batchSpeedPattern
          batchSpeedPatternTime
          drumVectorRpm
        }
      }`;
    const gqlAPIServiceArguments: any = {
      item
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <PublishLoadingPointSpeedPatternMutation>(
      response.data.publishLoadingPointSpeedPattern
    );
  }
  async PutTruckTimeseries(
    item: TruckTimeseriesInput
  ): Promise<PutTruckTimeseriesMutation> {
    const statement = `mutation PutTruckTimeseries($item: TruckTimeseriesInput!) {
        putTruckTimeseries(item: $item) {
          __typename
          imei
          systemDatetimeUtcStr
          gpsLatitudeDecimal
          gpsLongitudeDecimal
          gpsLatitudes
          gpsLongitudes
          pressureABarLowLatency
          pressureBBarLowLatency
          supplyVoltageMean
          drumVectorRpm
          temperatureModuleSurfaceTemperatureDegc
          temperatureModuleConcreteTemperatureDegc
          consistenceTestType
          consistenceMm
          consistenceMinMm
          consistenceMaxMm
          consistenceMmQualifier
          pressureABarMean
          pressureBBarMean
          co2
          rheometryPlasticViscosityPaS
          rheometryStaticYieldStressPa
          rheometryDynamicYieldStressPa
          percentAir
          concreteVolume
          delete_ttl
        }
      }`;
    const gqlAPIServiceArguments: any = {
      item
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <PutTruckTimeseriesMutation>response.data.putTruckTimeseries;
  }
  async RecordLocationUpdate(
    item: GeolocationInput
  ): Promise<RecordLocationUpdateMutation> {
    const statement = `mutation RecordLocationUpdate($item: GeolocationInput!) {
        recordLocationUpdate(item: $item) {
          __typename
          owner
          owner_id
          parent_id
          name
          type
          lng
          lat
          polygon
          status
          timezone
          timezone_date
          loading_points
          last_delivery_timestamp
        }
      }`;
    const gqlAPIServiceArguments: any = {
      item
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <RecordLocationUpdateMutation>response.data.recordLocationUpdate;
  }
  async TruckServiceRegisterDeviceFitting(
    IMEI: string,
    RMCProviderName: string,
    Registration: string,
    ExternalTruckId?: string,
    ExternalTruckName?: string,
    TruckId?: number
  ): Promise<boolean | null> {
    const statement = `mutation TruckServiceRegisterDeviceFitting($IMEI: String!, $RMCProviderName: String!, $Registration: String!, $ExternalTruckId: String, $ExternalTruckName: String, $TruckId: Int) {
        truckServiceRegisterDeviceFitting(
          IMEI: $IMEI
          RMCProviderName: $RMCProviderName
          Registration: $Registration
          ExternalTruckId: $ExternalTruckId
          ExternalTruckName: $ExternalTruckName
          TruckId: $TruckId
        )
      }`;
    const gqlAPIServiceArguments: any = {
      IMEI,
      RMCProviderName,
      Registration
    };
    if (ExternalTruckId) {
      gqlAPIServiceArguments.ExternalTruckId = ExternalTruckId;
    }
    if (ExternalTruckName) {
      gqlAPIServiceArguments.ExternalTruckName = ExternalTruckName;
    }
    if (TruckId) {
      gqlAPIServiceArguments.TruckId = TruckId;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <boolean | null>response.data.truckServiceRegisterDeviceFitting;
  }
  async TruckServiceDeregisterDevice(IMEI: string): Promise<boolean | null> {
    const statement = `mutation TruckServiceDeregisterDevice($IMEI: String!) {
        truckServiceDeregisterDevice(IMEI: $IMEI)
      }`;
    const gqlAPIServiceArguments: any = {
      IMEI
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <boolean | null>response.data.truckServiceDeregisterDevice;
  }
  async TruckServiceDeviceCreate(
    IMEI: string,
    SerialNumber: string,
    IMSI?: string
  ): Promise<boolean | null> {
    const statement = `mutation TruckServiceDeviceCreate($IMEI: String!, $SerialNumber: String!, $IMSI: String) {
        truckServiceDeviceCreate(IMEI: $IMEI, SerialNumber: $SerialNumber, IMSI: $IMSI)
      }`;
    const gqlAPIServiceArguments: any = {
      IMEI,
      SerialNumber
    };
    if (IMSI) {
      gqlAPIServiceArguments.IMSI = IMSI;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <boolean | null>response.data.truckServiceDeviceCreate;
  }
  async TruckServiceFakeEvent(
    Type: EventType,
    IMEI: string
  ): Promise<boolean | null> {
    const statement = `mutation TruckServiceFakeEvent($Type: EventType!, $IMEI: String!) {
        truckServiceFakeEvent(Type: $Type, IMEI: $IMEI)
      }`;
    const gqlAPIServiceArguments: any = {
      Type,
      IMEI
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <boolean | null>response.data.truckServiceFakeEvent;
  }
  async TruckServiceUpdateTruck(
    truckRecord?: TruckRecordInput
  ): Promise<TruckServiceUpdateTruckMutation> {
    const statement = `mutation TruckServiceUpdateTruck($truckRecord: TruckRecordInput) {
        truckServiceUpdateTruck(truckRecord: $truckRecord) {
          __typename
          truck_id
          ext_truck_id
          ext_truck_name
          rmc_provider
          registration
          device_imei
          serial_no
          vin
          project
          valid_from
          valid_to
          config {
            __typename
            physical {
              __typename
              gearbox_ratio
              hydraulic_motor_displacement_cc
              drum_volume_m3
              is_charging_clockwise
              is_pressure_id1_charging
              is_pressure_b_insulated
              pressure_sensor_location
            }
            operations {
              __typename
              is_fm_enabled
              is_pa_enabled
              is_pb_enabled
              is_smarthatch_enabled
              is_dm_temperature_fault
              is_dm_fault
              is_fm_fault
              is_pa_fault
              is_pb_fault
              is_cb_fault
              is_smarthatch_fault
              is_dm_fitted
              is_fm_fitted
              is_pa_fitted
              is_pb_fitted
              is_smarthatch_fitted
              maintenance_status
              cb_mounting_location
              cb_mounting_direction
            }
            globalConfig {
              __typename
              is_whitelisted
              is_off_the_road
              is_virtual
              misc
              manufacturer
              model
              no_consistence
              no_consistence_description
              rpm_sensor
            }
          }
          permitted_rmcs
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (truckRecord) {
      gqlAPIServiceArguments.truckRecord = truckRecord;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceUpdateTruckMutation>(
      response.data.truckServiceUpdateTruck
    );
  }
  async TruckServiceSetRmc(
    truckId: number,
    rmc: string
  ): Promise<TruckServiceSetRmcMutation> {
    const statement = `mutation TruckServiceSetRmc($truckId: Int!, $rmc: String!) {
        truckServiceSetRmc(truckId: $truckId, rmc: $rmc) {
          __typename
          truck_id
          ext_truck_id
          ext_truck_name
          rmc_provider
          registration
          device_imei
          serial_no
          vin
          project
          valid_from
          valid_to
          config {
            __typename
            physical {
              __typename
              gearbox_ratio
              hydraulic_motor_displacement_cc
              drum_volume_m3
              is_charging_clockwise
              is_pressure_id1_charging
              is_pressure_b_insulated
              pressure_sensor_location
            }
            operations {
              __typename
              is_fm_enabled
              is_pa_enabled
              is_pb_enabled
              is_smarthatch_enabled
              is_dm_temperature_fault
              is_dm_fault
              is_fm_fault
              is_pa_fault
              is_pb_fault
              is_cb_fault
              is_smarthatch_fault
              is_dm_fitted
              is_fm_fitted
              is_pa_fitted
              is_pb_fitted
              is_smarthatch_fitted
              maintenance_status
              cb_mounting_location
              cb_mounting_direction
            }
            globalConfig {
              __typename
              is_whitelisted
              is_off_the_road
              is_virtual
              misc
              manufacturer
              model
              no_consistence
              no_consistence_description
              rpm_sensor
            }
          }
          permitted_rmcs
        }
      }`;
    const gqlAPIServiceArguments: any = {
      truckId,
      rmc
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceSetRmcMutation>response.data.truckServiceSetRmc;
  }
  async TruckServiceSetImeisToForward(
    imeis: Array<string>
  ): Promise<TruckServiceSetImeisToForwardMutation> {
    const statement = `mutation TruckServiceSetImeisToForward($imeis: [String!]!) {
        truckServiceSetImeisToForward(imeis: $imeis) {
          __typename
          imeis
        }
      }`;
    const gqlAPIServiceArguments: any = {
      imeis
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceSetImeisToForwardMutation>(
      response.data.truckServiceSetImeisToForward
    );
  }
  async TruckServiceSetTruckIdsToForward(
    truckIds: Array<number>
  ): Promise<TruckServiceSetTruckIdsToForwardMutation> {
    const statement = `mutation TruckServiceSetTruckIdsToForward($truckIds: [Int!]!) {
        truckServiceSetTruckIdsToForward(truckIds: $truckIds) {
          __typename
          truck_ids
        }
      }`;
    const gqlAPIServiceArguments: any = {
      truckIds
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceSetTruckIdsToForwardMutation>(
      response.data.truckServiceSetTruckIdsToForward
    );
  }
  async MediaSvcUploadSupplierFile(
    filename: string
  ): Promise<MediaSvcUploadSupplierFileMutation> {
    const statement = `mutation MediaSvcUploadSupplierFile($filename: String!) {
        mediaSvcUploadSupplierFile(filename: $filename) {
          __typename
          success
          uploadUrl
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      filename
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <MediaSvcUploadSupplierFileMutation>(
      response.data.mediaSvcUploadSupplierFile
    );
  }
  async MediaSvcGetSupplierFileUrl(
    filename: string
  ): Promise<MediaSvcGetSupplierFileUrlMutation> {
    const statement = `mutation MediaSvcGetSupplierFileUrl($filename: String!) {
        mediaSvcGetSupplierFileUrl(filename: $filename) {
          __typename
          success
          downloadUrl
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      filename
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <MediaSvcGetSupplierFileUrlMutation>(
      response.data.mediaSvcGetSupplierFileUrl
    );
  }
  async MediaSvcListSupplierFiles(
    prefix?: string
  ): Promise<MediaSvcListSupplierFilesMutation> {
    const statement = `mutation MediaSvcListSupplierFiles($prefix: String) {
        mediaSvcListSupplierFiles(prefix: $prefix) {
          __typename
          success
          files
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (prefix) {
      gqlAPIServiceArguments.prefix = prefix;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <MediaSvcListSupplierFilesMutation>(
      response.data.mediaSvcListSupplierFiles
    );
  }
  async OrderSvcReplayDelivery(
    docketId?: string
  ): Promise<OrderSvcReplayDeliveryMutation> {
    const statement = `mutation OrderSvcReplayDelivery($docketId: String) {
        orderSvcReplayDelivery(docketId: $docketId) {
          __typename
          message
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (docketId) {
      gqlAPIServiceArguments.docketId = docketId;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcReplayDeliveryMutation>response.data.orderSvcReplayDelivery;
  }
  async TriggerLoadTest(
    rmcId: string,
    startDateTime: string,
    endDateTime: string
  ): Promise<TriggerLoadTestMutation> {
    const statement = `mutation TriggerLoadTest($rmcId: String!, $startDateTime: String!, $endDateTime: String!) {
        triggerLoadTest(
          rmcId: $rmcId
          startDateTime: $startDateTime
          endDateTime: $endDateTime
        ) {
          __typename
          message
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      startDateTime,
      endDateTime
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TriggerLoadTestMutation>response.data.triggerLoadTest;
  }
  async OrderSvcNotifyDownloadFileComplete(
    jobId: string,
    status: string,
    csvFileLink: string
  ): Promise<OrderSvcNotifyDownloadFileCompleteMutation> {
    const statement = `mutation OrderSvcNotifyDownloadFileComplete($jobId: String!, $status: String!, $csvFileLink: String!) {
        orderSvcNotifyDownloadFileComplete(
          jobId: $jobId
          status: $status
          csvFileLink: $csvFileLink
        ) {
          __typename
          jobId
          status
          csvFileLink
        }
      }`;
    const gqlAPIServiceArguments: any = {
      jobId,
      status,
      csvFileLink
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcNotifyDownloadFileCompleteMutation>(
      response.data.orderSvcNotifyDownloadFileComplete
    );
  }
  async CreateOrderSvcTag(
    rmcId: string,
    name: string
  ): Promise<CreateOrderSvcTagMutation> {
    const statement = `mutation CreateOrderSvcTag($rmcId: String!, $name: String!) {
        createOrderSvcTag(rmcId: $rmcId, name: $name) {
          __typename
          success
          tag {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      name
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <CreateOrderSvcTagMutation>response.data.createOrderSvcTag;
  }
  async UpdateOrderSvcTag(
    rmcId: string,
    id: number,
    name: string
  ): Promise<UpdateOrderSvcTagMutation> {
    const statement = `mutation UpdateOrderSvcTag($rmcId: String!, $id: Int!, $name: String!) {
        updateOrderSvcTag(rmcId: $rmcId, id: $id, name: $name) {
          __typename
          success
          tag {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      id,
      name
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UpdateOrderSvcTagMutation>response.data.updateOrderSvcTag;
  }
  async DeleteOrderSvcTag(
    rmcId: string,
    id: number
  ): Promise<DeleteOrderSvcTagMutation> {
    const statement = `mutation DeleteOrderSvcTag($rmcId: String!, $id: Int!) {
        deleteOrderSvcTag(rmcId: $rmcId, id: $id) {
          __typename
          success
          tag {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <DeleteOrderSvcTagMutation>response.data.deleteOrderSvcTag;
  }
  async AddTagToOrderSvcDelivery(
    rmcId: string,
    docketId: string,
    tagId: number
  ): Promise<AddTagToOrderSvcDeliveryMutation> {
    const statement = `mutation AddTagToOrderSvcDelivery($rmcId: String!, $docketId: String!, $tagId: Int!) {
        addTagToOrderSvcDelivery(rmcId: $rmcId, docketId: $docketId, tagId: $tagId) {
          __typename
          success
          tag {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      docketId,
      tagId
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <AddTagToOrderSvcDeliveryMutation>(
      response.data.addTagToOrderSvcDelivery
    );
  }
  async RemoveTagFromOrderSvcDelivery(
    rmcId: string,
    docketId: string,
    tagId: number
  ): Promise<RemoveTagFromOrderSvcDeliveryMutation> {
    const statement = `mutation RemoveTagFromOrderSvcDelivery($rmcId: String!, $docketId: String!, $tagId: Int!) {
        removeTagFromOrderSvcDelivery(rmcId: $rmcId, docketId: $docketId, tagId: $tagId) {
          __typename
          success
          tag {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      docketId,
      tagId
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <RemoveTagFromOrderSvcDeliveryMutation>(
      response.data.removeTagFromOrderSvcDelivery
    );
  }
  async OrderSvcCreateManualTest(
    rmcId: string,
    docketId: string,
    type: string,
    result: number,
    unit: string,
    testTime: string,
    comment?: string,
    fileName?: string,
    accepted?: boolean,
    acceptanceReason?: string
  ): Promise<OrderSvcCreateManualTestMutation> {
    const statement = `mutation OrderSvcCreateManualTest($rmcId: String!, $docketId: String!, $type: String!, $result: Float!, $unit: String!, $testTime: String!, $comment: String, $fileName: String, $accepted: Boolean, $acceptanceReason: String) {
        orderSvcCreateManualTest(
          rmcId: $rmcId
          docketId: $docketId
          type: $type
          result: $result
          unit: $unit
          testTime: $testTime
          comment: $comment
          fileName: $fileName
          accepted: $accepted
          acceptanceReason: $acceptanceReason
        ) {
          __typename
          success
          manualTest {
            __typename
            id
            docketId
            type
            result
            testResult
            unit
            testTime
            createdBy
            comment
            mediaS3Key
            accepted
            acceptanceReason
            reviewedBy
          }
          uploadUrl
          uploadFields
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      docketId,
      type,
      result,
      unit,
      testTime
    };
    if (comment) {
      gqlAPIServiceArguments.comment = comment;
    }
    if (fileName) {
      gqlAPIServiceArguments.fileName = fileName;
    }
    if (accepted) {
      gqlAPIServiceArguments.accepted = accepted;
    }
    if (acceptanceReason) {
      gqlAPIServiceArguments.acceptanceReason = acceptanceReason;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcCreateManualTestMutation>(
      response.data.orderSvcCreateManualTest
    );
  }
  async OrderSvcUpdateManualTest(
    id: number,
    rmcId: string,
    type?: string,
    result?: number,
    unit?: string,
    testTime?: string,
    comment?: string,
    accepted?: boolean,
    acceptanceReason?: string
  ): Promise<OrderSvcUpdateManualTestMutation> {
    const statement = `mutation OrderSvcUpdateManualTest($id: Int!, $rmcId: String!, $type: String, $result: Float, $unit: String, $testTime: String, $comment: String, $accepted: Boolean, $acceptanceReason: String) {
        orderSvcUpdateManualTest(
          id: $id
          rmcId: $rmcId
          type: $type
          result: $result
          unit: $unit
          testTime: $testTime
          comment: $comment
          accepted: $accepted
          acceptanceReason: $acceptanceReason
        ) {
          __typename
          success
          manualTest {
            __typename
            id
            docketId
            type
            result
            testResult
            unit
            testTime
            createdBy
            comment
            mediaS3Key
            accepted
            acceptanceReason
            reviewedBy
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
      rmcId
    };
    if (type) {
      gqlAPIServiceArguments.type = type;
    }
    if (result) {
      gqlAPIServiceArguments.result = result;
    }
    if (unit) {
      gqlAPIServiceArguments.unit = unit;
    }
    if (testTime) {
      gqlAPIServiceArguments.testTime = testTime;
    }
    if (comment) {
      gqlAPIServiceArguments.comment = comment;
    }
    if (accepted) {
      gqlAPIServiceArguments.accepted = accepted;
    }
    if (acceptanceReason) {
      gqlAPIServiceArguments.acceptanceReason = acceptanceReason;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcUpdateManualTestMutation>(
      response.data.orderSvcUpdateManualTest
    );
  }
  async OrderSvcEndDelivery(
    rmcId: string,
    docketId: string
  ): Promise<OrderSvcEndDeliveryMutation> {
    const statement = `mutation OrderSvcEndDelivery($rmcId: String!, $docketId: String!) {
        orderSvcEndDelivery(rmcId: $rmcId, docketId: $docketId) {
          __typename
          success
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      docketId
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcEndDeliveryMutation>response.data.orderSvcEndDelivery;
  }
  async OrderSvcCreateUserQuery(
    name: string,
    type: OrderSvcUserQueryType,
    queryPayload: string,
    description?: string
  ): Promise<OrderSvcCreateUserQueryMutation> {
    const statement = `mutation OrderSvcCreateUserQuery($name: String!, $type: OrderSvcUserQueryType!, $queryPayload: AWSJSON!, $description: String) {
        orderSvcCreateUserQuery(
          name: $name
          type: $type
          queryPayload: $queryPayload
          description: $description
        ) {
          __typename
          success
          query {
            __typename
            id
            name
            type
            description
            usageCount
            queryPayload
            createdBy
            createdAt
            updatedAt
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      name,
      type,
      queryPayload
    };
    if (description) {
      gqlAPIServiceArguments.description = description;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcCreateUserQueryMutation>(
      response.data.orderSvcCreateUserQuery
    );
  }
  async OrderSvcUpdateUserQuery(
    id: number,
    name?: string,
    queryPayload?: string,
    description?: string
  ): Promise<OrderSvcUpdateUserQueryMutation> {
    const statement = `mutation OrderSvcUpdateUserQuery($id: Int!, $name: String, $queryPayload: AWSJSON, $description: String) {
        orderSvcUpdateUserQuery(
          id: $id
          name: $name
          queryPayload: $queryPayload
          description: $description
        ) {
          __typename
          success
          query {
            __typename
            id
            name
            type
            description
            usageCount
            queryPayload
            createdBy
            createdAt
            updatedAt
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    if (name) {
      gqlAPIServiceArguments.name = name;
    }
    if (queryPayload) {
      gqlAPIServiceArguments.queryPayload = queryPayload;
    }
    if (description) {
      gqlAPIServiceArguments.description = description;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcUpdateUserQueryMutation>(
      response.data.orderSvcUpdateUserQuery
    );
  }
  async OrderSvcDeleteUserQuery(
    id: number
  ): Promise<OrderSvcDeleteUserQueryMutation> {
    const statement = `mutation OrderSvcDeleteUserQuery($id: Int!) {
        orderSvcDeleteUserQuery(id: $id) {
          __typename
          success
          query {
            __typename
            id
            name
            type
            description
            usageCount
            queryPayload
            createdBy
            createdAt
            updatedAt
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcDeleteUserQueryMutation>(
      response.data.orderSvcDeleteUserQuery
    );
  }
  async UserSvcUpdateUser(
    user: UpdateCognitoUserInput
  ): Promise<UserSvcUpdateUserMutation> {
    const statement = `mutation UserSvcUpdateUser($user: UpdateCognitoUserInput!) {
        userSvcUpdateUser(user: $user) {
          __typename
          success
          statusCode
        }
      }`;
    const gqlAPIServiceArguments: any = {
      user
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcUpdateUserMutation>response.data.userSvcUpdateUser;
  }
  async UserSvcCreateUser(
    user: CreateCognitoUserInput,
    groups: Array<string>
  ): Promise<UserSvcCreateUserMutation> {
    const statement = `mutation UserSvcCreateUser($user: CreateCognitoUserInput!, $groups: [String!]!) {
        userSvcCreateUser(user: $user, groups: $groups) {
          __typename
          success
          user {
            __typename
            username
            email
            phoneNumber
            givenName
            familyName
            jobTitle
            status
            enabled
            groups
            created
            lastModified
          }
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      user,
      groups
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcCreateUserMutation>response.data.userSvcCreateUser;
  }
  async UserSvcDeleteUser(
    username: string
  ): Promise<UserSvcDeleteUserMutation> {
    const statement = `mutation UserSvcDeleteUser($username: String!) {
        userSvcDeleteUser(username: $username) {
          __typename
          success
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      username
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcDeleteUserMutation>response.data.userSvcDeleteUser;
  }
  async UserSvcAddUserToGroup(
    username: string,
    groupname: string
  ): Promise<UserSvcAddUserToGroupMutation> {
    const statement = `mutation UserSvcAddUserToGroup($username: String!, $groupname: String!) {
        userSvcAddUserToGroup(username: $username, groupname: $groupname) {
          __typename
          success
        }
      }`;
    const gqlAPIServiceArguments: any = {
      username,
      groupname
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcAddUserToGroupMutation>response.data.userSvcAddUserToGroup;
  }
  async UserSvcRemoveUserFromGroup(
    username: string,
    groupname: string
  ): Promise<UserSvcRemoveUserFromGroupMutation> {
    const statement = `mutation UserSvcRemoveUserFromGroup($username: String!, $groupname: String!) {
        userSvcRemoveUserFromGroup(username: $username, groupname: $groupname) {
          __typename
          success
        }
      }`;
    const gqlAPIServiceArguments: any = {
      username,
      groupname
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRemoveUserFromGroupMutation>(
      response.data.userSvcRemoveUserFromGroup
    );
  }
  async UserSvcResetUserPassword(
    input: ResetUserPasswordInput
  ): Promise<UserSvcResetUserPasswordMutation> {
    const statement = `mutation UserSvcResetUserPassword($input: ResetUserPasswordInput!) {
        userSvcResetUserPassword(input: $input) {
          __typename
          success
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcResetUserPasswordMutation>(
      response.data.userSvcResetUserPassword
    );
  }
  async UserSvcResendInvite(
    username: string
  ): Promise<UserSvcResendInviteMutation> {
    const statement = `mutation UserSvcResendInvite($username: String!) {
        userSvcResendInvite(username: $username) {
          __typename
          success
          error
        }
      }`;
    const gqlAPIServiceArguments: any = {
      username
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcResendInviteMutation>response.data.userSvcResendInvite;
  }
  async UserSvcRbacCreateUser(
    input: CreateUserInput
  ): Promise<UserSvcRbacCreateUserMutation> {
    const statement = `mutation UserSvcRbacCreateUser($input: CreateUserInput!) {
        userSvcRbacCreateUser(input: $input) {
          __typename
          subId
          tenant
          firstName
          lastName
          groups {
            __typename
            id
            parentId
            tenant
            name
            description
            roles {
              __typename
              id
              name
              description
              abilities {
                __typename
                id
                action
                subject
                fields
                conditions
                inverted
                description
                readonly
              }
              readonly
            }
          }
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacCreateUserMutation>response.data.userSvcRbacCreateUser;
  }
  async UserSvcRbacUpdateUser(
    subId: string,
    input: UpdateUserInput
  ): Promise<UserSvcRbacUpdateUserMutation> {
    const statement = `mutation UserSvcRbacUpdateUser($subId: ID!, $input: UpdateUserInput!) {
        userSvcRbacUpdateUser(subId: $subId, input: $input) {
          __typename
          subId
          tenant
          firstName
          lastName
          groups {
            __typename
            id
            parentId
            tenant
            name
            description
            roles {
              __typename
              id
              name
              description
              abilities {
                __typename
                id
                action
                subject
                fields
                conditions
                inverted
                description
                readonly
              }
              readonly
            }
          }
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      subId,
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacUpdateUserMutation>response.data.userSvcRbacUpdateUser;
  }
  async UserSvcRbacDeleteUser(
    subId: string
  ): Promise<UserSvcRbacDeleteUserMutation> {
    const statement = `mutation UserSvcRbacDeleteUser($subId: ID!) {
        userSvcRbacDeleteUser(subId: $subId) {
          __typename
          subId
          tenant
          firstName
          lastName
          groups {
            __typename
            id
            parentId
            tenant
            name
            description
            roles {
              __typename
              id
              name
              description
              abilities {
                __typename
                id
                action
                subject
                fields
                conditions
                inverted
                description
                readonly
              }
              readonly
            }
          }
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      subId
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacDeleteUserMutation>response.data.userSvcRbacDeleteUser;
  }
  async UserSvcRbacCreateGroup(
    input: CreateGroupInput
  ): Promise<UserSvcRbacCreateGroupMutation> {
    const statement = `mutation UserSvcRbacCreateGroup($input: CreateGroupInput!) {
        userSvcRbacCreateGroup(input: $input) {
          __typename
          id
          parentId
          tenant
          name
          description
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacCreateGroupMutation>response.data.userSvcRbacCreateGroup;
  }
  async UserSvcRbacUpdateGroup(
    id: string,
    input: UpdateGroupInput
  ): Promise<UserSvcRbacUpdateGroupMutation> {
    const statement = `mutation UserSvcRbacUpdateGroup($id: ID!, $input: UpdateGroupInput!) {
        userSvcRbacUpdateGroup(id: $id, input: $input) {
          __typename
          id
          parentId
          tenant
          name
          description
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacUpdateGroupMutation>response.data.userSvcRbacUpdateGroup;
  }
  async UserSvcRbacDeleteGroup(
    id: string
  ): Promise<UserSvcRbacDeleteGroupMutation> {
    const statement = `mutation UserSvcRbacDeleteGroup($id: ID!) {
        userSvcRbacDeleteGroup(id: $id) {
          __typename
          id
          parentId
          tenant
          name
          description
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacDeleteGroupMutation>response.data.userSvcRbacDeleteGroup;
  }
  async UserSvcRbacCreateRole(
    input: CreateRoleInput
  ): Promise<UserSvcRbacCreateRoleMutation> {
    const statement = `mutation UserSvcRbacCreateRole($input: CreateRoleInput!) {
        userSvcRbacCreateRole(input: $input) {
          __typename
          id
          name
          description
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacCreateRoleMutation>response.data.userSvcRbacCreateRole;
  }
  async UserSvcRbacUpdateRole(
    id: string,
    input: UpdateRoleInput
  ): Promise<UserSvcRbacUpdateRoleMutation> {
    const statement = `mutation UserSvcRbacUpdateRole($id: ID!, $input: UpdateRoleInput!) {
        userSvcRbacUpdateRole(id: $id, input: $input) {
          __typename
          id
          name
          description
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacUpdateRoleMutation>response.data.userSvcRbacUpdateRole;
  }
  async UserSvcRbacDeleteRole(
    id: string
  ): Promise<UserSvcRbacDeleteRoleMutation> {
    const statement = `mutation UserSvcRbacDeleteRole($id: ID!) {
        userSvcRbacDeleteRole(id: $id) {
          __typename
          id
          name
          description
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacDeleteRoleMutation>response.data.userSvcRbacDeleteRole;
  }
  async UserSvcRbacCreateAbility(
    input: CreateAbilityInput
  ): Promise<UserSvcRbacCreateAbilityMutation> {
    const statement = `mutation UserSvcRbacCreateAbility($input: CreateAbilityInput!) {
        userSvcRbacCreateAbility(input: $input) {
          __typename
          id
          action
          subject
          fields
          conditions
          inverted
          description
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacCreateAbilityMutation>(
      response.data.userSvcRbacCreateAbility
    );
  }
  async UserSvcRbacUpdateAbility(
    id: string,
    input: UpdateAbilityInput
  ): Promise<UserSvcRbacUpdateAbilityMutation> {
    const statement = `mutation UserSvcRbacUpdateAbility($id: ID!, $input: UpdateAbilityInput!) {
        userSvcRbacUpdateAbility(id: $id, input: $input) {
          __typename
          id
          action
          subject
          fields
          conditions
          inverted
          description
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
      input
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacUpdateAbilityMutation>(
      response.data.userSvcRbacUpdateAbility
    );
  }
  async UserSvcRbacDeleteAbility(
    id: string
  ): Promise<UserSvcRbacDeleteAbilityMutation> {
    const statement = `mutation UserSvcRbacDeleteAbility($id: ID!) {
        userSvcRbacDeleteAbility(id: $id) {
          __typename
          id
          action
          subject
          fields
          conditions
          inverted
          description
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacDeleteAbilityMutation>(
      response.data.userSvcRbacDeleteAbility
    );
  }
  async UserSvcRbacAssignAbilitiesToRole(
    roleId: string,
    abilityIds: Array<string>
  ): Promise<UserSvcRbacAssignAbilitiesToRoleMutation> {
    const statement = `mutation UserSvcRbacAssignAbilitiesToRole($roleId: ID!, $abilityIds: [ID!]!) {
        userSvcRbacAssignAbilitiesToRole(roleId: $roleId, abilityIds: $abilityIds) {
          __typename
          id
          name
          description
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      roleId,
      abilityIds
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacAssignAbilitiesToRoleMutation>(
      response.data.userSvcRbacAssignAbilitiesToRole
    );
  }
  async UserSvcRbacRemoveAbilitiesFromRole(
    roleId: string,
    abilityIds: Array<string>
  ): Promise<UserSvcRbacRemoveAbilitiesFromRoleMutation> {
    const statement = `mutation UserSvcRbacRemoveAbilitiesFromRole($roleId: ID!, $abilityIds: [ID!]!) {
        userSvcRbacRemoveAbilitiesFromRole(roleId: $roleId, abilityIds: $abilityIds) {
          __typename
          id
          name
          description
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      roleId,
      abilityIds
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacRemoveAbilitiesFromRoleMutation>(
      response.data.userSvcRbacRemoveAbilitiesFromRole
    );
  }
  async UserSvcRbacAssignAbilitiesToUser(
    subId: string,
    abilityIds: Array<string>
  ): Promise<UserSvcRbacAssignAbilitiesToUserMutation> {
    const statement = `mutation UserSvcRbacAssignAbilitiesToUser($subId: ID!, $abilityIds: [ID!]!) {
        userSvcRbacAssignAbilitiesToUser(subId: $subId, abilityIds: $abilityIds) {
          __typename
          subId
          tenant
          firstName
          lastName
          groups {
            __typename
            id
            parentId
            tenant
            name
            description
            roles {
              __typename
              id
              name
              description
              abilities {
                __typename
                id
                action
                subject
                fields
                conditions
                inverted
                description
                readonly
              }
              readonly
            }
          }
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      subId,
      abilityIds
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacAssignAbilitiesToUserMutation>(
      response.data.userSvcRbacAssignAbilitiesToUser
    );
  }
  async UserSvcRbacRemoveAbilitiesFromUser(
    subId: string,
    abilityIds: Array<string>
  ): Promise<UserSvcRbacRemoveAbilitiesFromUserMutation> {
    const statement = `mutation UserSvcRbacRemoveAbilitiesFromUser($subId: ID!, $abilityIds: [ID!]!) {
        userSvcRbacRemoveAbilitiesFromUser(subId: $subId, abilityIds: $abilityIds) {
          __typename
          subId
          tenant
          firstName
          lastName
          groups {
            __typename
            id
            parentId
            tenant
            name
            description
            roles {
              __typename
              id
              name
              description
              abilities {
                __typename
                id
                action
                subject
                fields
                conditions
                inverted
                description
                readonly
              }
              readonly
            }
          }
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      subId,
      abilityIds
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacRemoveAbilitiesFromUserMutation>(
      response.data.userSvcRbacRemoveAbilitiesFromUser
    );
  }
  async UserSvcRbacBatchCreateUsers(
    users: Array<CreateUserInput>
  ): Promise<Array<UserSvcRbacBatchCreateUsersMutation>> {
    const statement = `mutation UserSvcRbacBatchCreateUsers($users: [CreateUserInput!]!) {
        userSvcRbacBatchCreateUsers(users: $users) {
          __typename
          subId
          tenant
          firstName
          lastName
          groups {
            __typename
            id
            parentId
            tenant
            name
            description
            roles {
              __typename
              id
              name
              description
              abilities {
                __typename
                id
                action
                subject
                fields
                conditions
                inverted
                description
                readonly
              }
              readonly
            }
          }
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      users
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <Array<UserSvcRbacBatchCreateUsersMutation>>(
      response.data.userSvcRbacBatchCreateUsers
    );
  }
  async UserSvcRbacBatchAssignRoles(
    assignments: Array<RoleAssignmentInput>
  ): Promise<UserSvcRbacBatchAssignRolesMutation> {
    const statement = `mutation UserSvcRbacBatchAssignRoles($assignments: [RoleAssignmentInput!]!) {
        userSvcRbacBatchAssignRoles(assignments: $assignments) {
          __typename
          success
          errors {
            __typename
            code
            message
            field
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      assignments
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacBatchAssignRolesMutation>(
      response.data.userSvcRbacBatchAssignRoles
    );
  }
  async UserSvcSendTrackingEvent(
    event: UserTrackingEventInput
  ): Promise<UserSvcSendTrackingEventMutation> {
    const statement = `mutation UserSvcSendTrackingEvent($event: UserTrackingEventInput!) {
        userSvcSendTrackingEvent(event: $event) {
          __typename
          success
          errors {
            __typename
            code
            message
            field
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      event
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcSendTrackingEventMutation>(
      response.data.userSvcSendTrackingEvent
    );
  }
  async LocationSvcPutBatchPlants(
    rmc: string,
    taxonomyId: string,
    batchPlants: BatchPlantsInput
  ): Promise<boolean | null> {
    const statement = `mutation LocationSvcPutBatchPlants($rmc: String!, $taxonomyId: String!, $batchPlants: BatchPlantsInput!) {
        locationSvcPutBatchPlants(
          rmc: $rmc
          taxonomyId: $taxonomyId
          batchPlants: $batchPlants
        )
      }`;
    const gqlAPIServiceArguments: any = {
      rmc,
      taxonomyId,
      batchPlants
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <boolean | null>response.data.locationSvcPutBatchPlants;
  }
  async LocationSvcPutTaxonomyRecord(
    rmc: string,
    groupName: string,
    groupType: string,
    groupDescription: string,
    id?: string,
    parentId?: string
  ): Promise<LocationSvcPutTaxonomyRecordMutation> {
    const statement = `mutation LocationSvcPutTaxonomyRecord($id: String, $parentId: String, $rmc: String!, $groupName: String!, $groupType: String!, $groupDescription: String!) {
        locationSvcPutTaxonomyRecord(
          id: $id
          parentId: $parentId
          rmc: $rmc
          groupName: $groupName
          groupType: $groupType
          groupDescription: $groupDescription
        ) {
          __typename
          id
          parentId
          rmc
          groupName
          groupType
          groupDescription
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmc,
      groupName,
      groupType,
      groupDescription
    };
    if (id) {
      gqlAPIServiceArguments.id = id;
    }
    if (parentId) {
      gqlAPIServiceArguments.parentId = parentId;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <LocationSvcPutTaxonomyRecordMutation>(
      response.data.locationSvcPutTaxonomyRecord
    );
  }
  async LocationSvcDeleteTaxonomyRecord(
    id: string,
    rmc: string
  ): Promise<boolean | null> {
    const statement = `mutation LocationSvcDeleteTaxonomyRecord($id: String!, $rmc: String!) {
        locationSvcDeleteTaxonomyRecord(id: $id, rmc: $rmc)
      }`;
    const gqlAPIServiceArguments: any = {
      id,
      rmc
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <boolean | null>response.data.locationSvcDeleteTaxonomyRecord;
  }
  async LocationSvcUpdateLocation(
    Owner: string,
    OwnerId: string,
    Polygon: string,
    Lat?: number,
    Lng?: number
  ): Promise<LocationSvcUpdateLocationMutation> {
    const statement = `mutation LocationSvcUpdateLocation($Owner: String!, $OwnerId: String!, $Polygon: String!, $Lat: Float, $Lng: Float) {
        locationSvcUpdateLocation(
          Owner: $Owner
          OwnerId: $OwnerId
          Polygon: $Polygon
          Lat: $Lat
          Lng: $Lng
        ) {
          __typename
          success
          location {
            __typename
            Owner
            OwnerId
            ParentId
            Name
            Type
            Lng
            Lat
            Polygon
            Status
            Timezone
            TimezoneDate
            LoadingPoints
            LastDeliveryTimestamp
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      Owner,
      OwnerId,
      Polygon
    };
    if (Lat) {
      gqlAPIServiceArguments.Lat = Lat;
    }
    if (Lng) {
      gqlAPIServiceArguments.Lng = Lng;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <LocationSvcUpdateLocationMutation>(
      response.data.locationSvcUpdateLocation
    );
  }
  async LocationSvcUpdateLocationStatus(
    Owner: string,
    OwnerId: string,
    Status?: string
  ): Promise<LocationSvcUpdateLocationStatusMutation> {
    const statement = `mutation LocationSvcUpdateLocationStatus($Owner: String!, $OwnerId: String!, $Status: String) {
        locationSvcUpdateLocationStatus(
          Owner: $Owner
          OwnerId: $OwnerId
          Status: $Status
        ) {
          __typename
          success
          location {
            __typename
            Owner
            OwnerId
            ParentId
            Name
            Type
            Lng
            Lat
            Polygon
            Status
            Timezone
            TimezoneDate
            LoadingPoints
            LastDeliveryTimestamp
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      Owner,
      OwnerId
    };
    if (Status) {
      gqlAPIServiceArguments.Status = Status;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <LocationSvcUpdateLocationStatusMutation>(
      response.data.locationSvcUpdateLocationStatus
    );
  }
  async LocationSvcSaveLocation(
    location: GeolocationInput
  ): Promise<LocationSvcSaveLocationMutation> {
    const statement = `mutation LocationSvcSaveLocation($location: GeolocationInput!) {
        locationSvcSaveLocation(location: $location) {
          __typename
          success
          location {
            __typename
            owner
            owner_id
            parent_id
            name
            type
            lng
            lat
            polygon
            status
            timezone
            timezone_date
            loading_points
            last_delivery_timestamp
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      location
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <LocationSvcSaveLocationMutation>(
      response.data.locationSvcSaveLocation
    );
  }
  async LocationSvcRecordLocationUpdate(
    item: GeolocationInput
  ): Promise<LocationSvcRecordLocationUpdateMutation> {
    const statement = `mutation LocationSvcRecordLocationUpdate($item: GeolocationInput!) {
        locationSvcRecordLocationUpdate(item: $item) {
          __typename
          owner
          owner_id
          parent_id
          name
          type
          lng
          lat
          polygon
          status
          timezone
          timezone_date
          loading_points
          last_delivery_timestamp
        }
      }`;
    const gqlAPIServiceArguments: any = {
      item
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <LocationSvcRecordLocationUpdateMutation>(
      response.data.locationSvcRecordLocationUpdate
    );
  }
  async DocketSvcPostDocket(
    rmcProviderName: string,
    docket: string
  ): Promise<DocketSvcPostDocketMutation> {
    const statement = `mutation DocketSvcPostDocket($rmcProviderName: String!, $docket: String!) {
        docketSvcPostDocket(rmcProviderName: $rmcProviderName, docket: $docket) {
          __typename
          success
          message
          docketId
          ticketId
          errors
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcProviderName,
      docket
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <DocketSvcPostDocketMutation>response.data.docketSvcPostDocket;
  }
  async BfdSvcPutImei(imei: string): Promise<BfdSvcPutImeiMutation> {
    const statement = `mutation BfdSvcPutImei($imei: String!) {
        bfdSvcPutImei(imei: $imei) {
          __typename
          success
          message
          imei
          errorCode
        }
      }`;
    const gqlAPIServiceArguments: any = {
      imei
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <BfdSvcPutImeiMutation>response.data.bfdSvcPutImei;
  }
  async BfdSvcDeleteImei(imei: string): Promise<BfdSvcDeleteImeiMutation> {
    const statement = `mutation BfdSvcDeleteImei($imei: String!) {
        bfdSvcDeleteImei(imei: $imei) {
          __typename
          success
          message
          imei
          errorCode
        }
      }`;
    const gqlAPIServiceArguments: any = {
      imei
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <BfdSvcDeleteImeiMutation>response.data.bfdSvcDeleteImei;
  }
  async GetTruckTimeseries(
    imei: string,
    rmcId: string,
    startDatetime: string,
    endDatetime: string,
    customerId?: string,
    nextToken?: string
  ): Promise<GetTruckTimeseriesQuery> {
    const statement = `query GetTruckTimeseries($imei: String!, $rmcId: String!, $startDatetime: String!, $endDatetime: String!, $customerId: String, $nextToken: String) {
        getTruckTimeseries(
          imei: $imei
          rmcId: $rmcId
          startDatetime: $startDatetime
          endDatetime: $endDatetime
          customerId: $customerId
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            imei
            systemDatetimeUtcStr
            gpsLatitudeDecimal
            gpsLongitudeDecimal
            gpsLatitudes
            gpsLongitudes
            pressureABarLowLatency
            pressureBBarLowLatency
            supplyVoltageMean
            drumVectorRpm
            temperatureModuleSurfaceTemperatureDegc
            temperatureModuleConcreteTemperatureDegc
            consistenceTestType
            consistenceMm
            consistenceMinMm
            consistenceMaxMm
            consistenceMmQualifier
            pressureABarMean
            pressureBBarMean
            co2
            rheometryPlasticViscosityPaS
            rheometryStaticYieldStressPa
            rheometryDynamicYieldStressPa
            percentAir
            concreteVolume
            delete_ttl
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      imei,
      rmcId,
      startDatetime,
      endDatetime
    };
    if (customerId) {
      gqlAPIServiceArguments.customerId = customerId;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetTruckTimeseriesQuery>response.data.getTruckTimeseries;
  }
  async GetTruckInformationSnapshots(
    rmcId: string,
    customerId?: string,
    imeiList?: string,
    plantCodeList?: string,
    nextToken?: string
  ): Promise<GetTruckInformationSnapshotsQuery> {
    const statement = `query GetTruckInformationSnapshots($rmcId: String!, $customerId: String, $imeiList: String, $plantCodeList: String, $nextToken: String) {
        getTruckInformationSnapshots(
          rmcId: $rmcId
          customerId: $customerId
          imeiList: $imeiList
          plantCodeList: $plantCodeList
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            imei
            eventType
            rmcProvider
            rmcCustomerId
            rmcCustomerName
            rmcAndCustomerId
            systemDatetimeUtcStr
            truckId
            truckPlate
            truckImei
            datetimeBatch
            slumpCode
            orderCode
            docketId
            docketId1
            commercialProductCode
            commercialProductDescription
            deliveredQuantity
            plantCode
            loadingPoint
            jobsiteCode
            jobsiteDescription
            siteLocation
            plantLocation
            tripStartTime
            tripEndTime
            pourTime
            pourEvents
            pourLocation
            leftBatchPlant
            arrivedAtSite
            leftSite
            deliveryStartTime
            deliveryEndTime
            consistenceMmAtLoadMix
            consistenceMmAtLoadMixOk
            consistenceMmQualifierAtLoadMix
            consistenceMmAtPlantExit
            consistenceMmAtPlantExitOk
            consistenceMmQualifierAtPlantExit
            consistenceMmAtSiteArrival
            consistenceMmAtSiteArrivalOk
            consistenceMmQualifierAtSiteArrival
            consistenceMmAtPour
            consistenceMmAtPourOk
            consistenceMmQualifierAtPour
            siteWaitTimeSeconds
            siteTimeSeconds
            waterAdditions
            gpsLatitudeDecimal
            gpsLongitudeDecimal
            gpsLatitudes
            gpsLongitudes
            pressureABarLowLatency
            pressureBBarLowLatency
            supplyVoltageMean
            drumLowLatencyRpm
            drumVectorRpm
            temperatureModuleSurfaceTemperatureDegc
            temperatureModuleConcreteTemperatureDegc
            consistenceMmUtcStr
            consistenceMm
            consistenceMinMm
            consistenceMaxMm
            consistenceTestType
            pressureABarMean
            pressureBBarMean
            consistenceClass
            consistenceTarget
            consistenceClassMax
            consistenceClassMin
            consistenceLowerLimitSpot
            consistenceStandard
            consistenceUpperLimitSpot
            consistencePredictionType
            consistenceMmQualifier
            plantGeofenceIdMostRecent
            co2
            tempAtLoadMix
            tempAtPlantExit
            tempAtSiteArrival
            tempAtPour
            tz
            batchSpeedPattern
            batchSpeedPatternTime
            speedPatternAtSite
            speedPatternAtSiteTime
            rmcPlantCodeLoadingPoint
            rheometryPredictionType
            rheometryPlasticViscosityPaS
            rheometryStaticYieldStressPa
            rheometryDynamicYieldStressPa
            rheometryStaticYieldStressTargetMinPa
            rheometryStaticYieldStressTargetMaxPa
            rheometryPlasticViscosityTargetMinPas
            rheometryPlasticViscosityTargetMaxPas
            delete_ttl
            extTruckName
            extTruckId
            config
            inBatchPlant
            inSite
            canTrackGeo
            deliveryTags
            allowableWaterToAddLitres
            excessWaterAddedDuringBatchingLitres
            mixDesignCode
            maxWaterCementRatio
            spinUpStatus
            spinUpStatusUpdateTime
            emptyDrumStage
            emptyDrumType
            emptyDrumTime
            additionalWaterDetected
            washoutWaterMeasured
            additionalWaterPerM3
            midPourWaterAdded
            prePourWaterAdded
            unclassifiedWaterAdded
            waterAddedAtPlant
            additionalWaterMeasured
            percentAir
            concreteVolume
            concreteVolumeM3AtPlantExit
            concreteVolumeM3AtSiteArrival
            concreteVolumeM3AtPour
            concreteVolumeM3AtSiteExit
            airPercentAtPlantExit
            airPercentAtSiteArrival
            airPercentAtPour
            airPercentAtSiteExit
            airPercentAtLoadMix
            weatherTempDegcAtPlant
            weatherCodeAtPlant
            weatherTempDegcAtSiteArrival
            weatherCodeAtSiteArrival
            deviceHealthStatus
          }
          nextToken
          timestamp
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId
    };
    if (customerId) {
      gqlAPIServiceArguments.customerId = customerId;
    }
    if (imeiList) {
      gqlAPIServiceArguments.imeiList = imeiList;
    }
    if (plantCodeList) {
      gqlAPIServiceArguments.plantCodeList = plantCodeList;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetTruckInformationSnapshotsQuery>(
      response.data.getTruckInformationSnapshots
    );
  }
  async GetPlantTruckSnapshots(
    rmcId: string,
    plantCode: string,
    nextToken?: string
  ): Promise<GetPlantTruckSnapshotsQuery> {
    const statement = `query GetPlantTruckSnapshots($rmcId: String!, $plantCode: String!, $nextToken: String) {
        getPlantTruckSnapshots(
          rmcId: $rmcId
          plantCode: $plantCode
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            imei
            eventType
            rmcProvider
            rmcCustomerId
            rmcCustomerName
            rmcAndCustomerId
            systemDatetimeUtcStr
            truckId
            truckPlate
            truckImei
            datetimeBatch
            slumpCode
            orderCode
            docketId
            docketId1
            commercialProductCode
            commercialProductDescription
            deliveredQuantity
            plantCode
            loadingPoint
            jobsiteCode
            jobsiteDescription
            siteLocation
            plantLocation
            tripStartTime
            tripEndTime
            pourTime
            pourEvents
            pourLocation
            leftBatchPlant
            arrivedAtSite
            leftSite
            deliveryStartTime
            deliveryEndTime
            consistenceMmAtLoadMix
            consistenceMmAtLoadMixOk
            consistenceMmQualifierAtLoadMix
            consistenceMmAtPlantExit
            consistenceMmAtPlantExitOk
            consistenceMmQualifierAtPlantExit
            consistenceMmAtSiteArrival
            consistenceMmAtSiteArrivalOk
            consistenceMmQualifierAtSiteArrival
            consistenceMmAtPour
            consistenceMmAtPourOk
            consistenceMmQualifierAtPour
            siteWaitTimeSeconds
            siteTimeSeconds
            waterAdditions
            gpsLatitudeDecimal
            gpsLongitudeDecimal
            gpsLatitudes
            gpsLongitudes
            pressureABarLowLatency
            pressureBBarLowLatency
            supplyVoltageMean
            drumLowLatencyRpm
            drumVectorRpm
            temperatureModuleSurfaceTemperatureDegc
            temperatureModuleConcreteTemperatureDegc
            consistenceMmUtcStr
            consistenceMm
            consistenceMinMm
            consistenceMaxMm
            consistenceTestType
            pressureABarMean
            pressureBBarMean
            consistenceClass
            consistenceTarget
            consistenceClassMax
            consistenceClassMin
            consistenceLowerLimitSpot
            consistenceStandard
            consistenceUpperLimitSpot
            consistencePredictionType
            consistenceMmQualifier
            plantGeofenceIdMostRecent
            co2
            tempAtLoadMix
            tempAtPlantExit
            tempAtSiteArrival
            tempAtPour
            tz
            batchSpeedPattern
            batchSpeedPatternTime
            speedPatternAtSite
            speedPatternAtSiteTime
            rmcPlantCodeLoadingPoint
            rheometryPredictionType
            rheometryPlasticViscosityPaS
            rheometryStaticYieldStressPa
            rheometryDynamicYieldStressPa
            rheometryStaticYieldStressTargetMinPa
            rheometryStaticYieldStressTargetMaxPa
            rheometryPlasticViscosityTargetMinPas
            rheometryPlasticViscosityTargetMaxPas
            delete_ttl
            extTruckName
            extTruckId
            config
            inBatchPlant
            inSite
            canTrackGeo
            deliveryTags
            allowableWaterToAddLitres
            excessWaterAddedDuringBatchingLitres
            mixDesignCode
            maxWaterCementRatio
            spinUpStatus
            spinUpStatusUpdateTime
            emptyDrumStage
            emptyDrumType
            emptyDrumTime
            additionalWaterDetected
            washoutWaterMeasured
            additionalWaterPerM3
            midPourWaterAdded
            prePourWaterAdded
            unclassifiedWaterAdded
            waterAddedAtPlant
            additionalWaterMeasured
            percentAir
            concreteVolume
            concreteVolumeM3AtPlantExit
            concreteVolumeM3AtSiteArrival
            concreteVolumeM3AtPour
            concreteVolumeM3AtSiteExit
            airPercentAtPlantExit
            airPercentAtSiteArrival
            airPercentAtPour
            airPercentAtSiteExit
            airPercentAtLoadMix
            weatherTempDegcAtPlant
            weatherCodeAtPlant
            weatherTempDegcAtSiteArrival
            weatherCodeAtSiteArrival
            deviceHealthStatus
          }
          nextToken
          timestamp
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      plantCode
    };
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetPlantTruckSnapshotsQuery>response.data.getPlantTruckSnapshots;
  }
  async GetJobsiteTruckSnapshots(
    rmcId: string,
    jobsiteCode: string,
    nextToken?: string
  ): Promise<GetJobsiteTruckSnapshotsQuery> {
    const statement = `query GetJobsiteTruckSnapshots($rmcId: String!, $jobsiteCode: String!, $nextToken: String) {
        getJobsiteTruckSnapshots(
          rmcId: $rmcId
          jobsiteCode: $jobsiteCode
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            imei
            eventType
            rmcProvider
            rmcCustomerId
            rmcCustomerName
            rmcAndCustomerId
            systemDatetimeUtcStr
            truckId
            truckPlate
            truckImei
            datetimeBatch
            slumpCode
            orderCode
            docketId
            docketId1
            commercialProductCode
            commercialProductDescription
            deliveredQuantity
            plantCode
            loadingPoint
            jobsiteCode
            jobsiteDescription
            siteLocation
            plantLocation
            tripStartTime
            tripEndTime
            pourTime
            pourEvents
            pourLocation
            leftBatchPlant
            arrivedAtSite
            leftSite
            deliveryStartTime
            deliveryEndTime
            consistenceMmAtLoadMix
            consistenceMmAtLoadMixOk
            consistenceMmQualifierAtLoadMix
            consistenceMmAtPlantExit
            consistenceMmAtPlantExitOk
            consistenceMmQualifierAtPlantExit
            consistenceMmAtSiteArrival
            consistenceMmAtSiteArrivalOk
            consistenceMmQualifierAtSiteArrival
            consistenceMmAtPour
            consistenceMmAtPourOk
            consistenceMmQualifierAtPour
            siteWaitTimeSeconds
            siteTimeSeconds
            waterAdditions
            gpsLatitudeDecimal
            gpsLongitudeDecimal
            gpsLatitudes
            gpsLongitudes
            pressureABarLowLatency
            pressureBBarLowLatency
            supplyVoltageMean
            drumLowLatencyRpm
            drumVectorRpm
            temperatureModuleSurfaceTemperatureDegc
            temperatureModuleConcreteTemperatureDegc
            consistenceMmUtcStr
            consistenceMm
            consistenceMinMm
            consistenceMaxMm
            consistenceTestType
            pressureABarMean
            pressureBBarMean
            consistenceClass
            consistenceTarget
            consistenceClassMax
            consistenceClassMin
            consistenceLowerLimitSpot
            consistenceStandard
            consistenceUpperLimitSpot
            consistencePredictionType
            consistenceMmQualifier
            plantGeofenceIdMostRecent
            co2
            tempAtLoadMix
            tempAtPlantExit
            tempAtSiteArrival
            tempAtPour
            tz
            batchSpeedPattern
            batchSpeedPatternTime
            speedPatternAtSite
            speedPatternAtSiteTime
            rmcPlantCodeLoadingPoint
            rheometryPredictionType
            rheometryPlasticViscosityPaS
            rheometryStaticYieldStressPa
            rheometryDynamicYieldStressPa
            rheometryStaticYieldStressTargetMinPa
            rheometryStaticYieldStressTargetMaxPa
            rheometryPlasticViscosityTargetMinPas
            rheometryPlasticViscosityTargetMaxPas
            delete_ttl
            extTruckName
            extTruckId
            config
            inBatchPlant
            inSite
            canTrackGeo
            deliveryTags
            allowableWaterToAddLitres
            excessWaterAddedDuringBatchingLitres
            mixDesignCode
            maxWaterCementRatio
            spinUpStatus
            spinUpStatusUpdateTime
            emptyDrumStage
            emptyDrumType
            emptyDrumTime
            additionalWaterDetected
            washoutWaterMeasured
            additionalWaterPerM3
            midPourWaterAdded
            prePourWaterAdded
            unclassifiedWaterAdded
            waterAddedAtPlant
            additionalWaterMeasured
            percentAir
            concreteVolume
            concreteVolumeM3AtPlantExit
            concreteVolumeM3AtSiteArrival
            concreteVolumeM3AtPour
            concreteVolumeM3AtSiteExit
            airPercentAtPlantExit
            airPercentAtSiteArrival
            airPercentAtPour
            airPercentAtSiteExit
            airPercentAtLoadMix
            weatherTempDegcAtPlant
            weatherCodeAtPlant
            weatherTempDegcAtSiteArrival
            weatherCodeAtSiteArrival
            deviceHealthStatus
          }
          nextToken
          timestamp
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      jobsiteCode
    };
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetJobsiteTruckSnapshotsQuery>(
      response.data.getJobsiteTruckSnapshots
    );
  }
  async GetCustomerTruckSnapshots(
    rmcId: string,
    customerId: string,
    nextToken?: string
  ): Promise<GetCustomerTruckSnapshotsQuery> {
    const statement = `query GetCustomerTruckSnapshots($rmcId: String!, $customerId: String!, $nextToken: String) {
        getCustomerTruckSnapshots(
          rmcId: $rmcId
          customerId: $customerId
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            imei
            eventType
            rmcProvider
            rmcCustomerId
            rmcCustomerName
            rmcAndCustomerId
            systemDatetimeUtcStr
            truckId
            truckPlate
            truckImei
            datetimeBatch
            slumpCode
            orderCode
            docketId
            docketId1
            commercialProductCode
            commercialProductDescription
            deliveredQuantity
            plantCode
            loadingPoint
            jobsiteCode
            jobsiteDescription
            siteLocation
            plantLocation
            tripStartTime
            tripEndTime
            pourTime
            pourEvents
            pourLocation
            leftBatchPlant
            arrivedAtSite
            leftSite
            deliveryStartTime
            deliveryEndTime
            consistenceMmAtLoadMix
            consistenceMmAtLoadMixOk
            consistenceMmQualifierAtLoadMix
            consistenceMmAtPlantExit
            consistenceMmAtPlantExitOk
            consistenceMmQualifierAtPlantExit
            consistenceMmAtSiteArrival
            consistenceMmAtSiteArrivalOk
            consistenceMmQualifierAtSiteArrival
            consistenceMmAtPour
            consistenceMmAtPourOk
            consistenceMmQualifierAtPour
            siteWaitTimeSeconds
            siteTimeSeconds
            waterAdditions
            gpsLatitudeDecimal
            gpsLongitudeDecimal
            gpsLatitudes
            gpsLongitudes
            pressureABarLowLatency
            pressureBBarLowLatency
            supplyVoltageMean
            drumLowLatencyRpm
            drumVectorRpm
            temperatureModuleSurfaceTemperatureDegc
            temperatureModuleConcreteTemperatureDegc
            consistenceMmUtcStr
            consistenceMm
            consistenceMinMm
            consistenceMaxMm
            consistenceTestType
            pressureABarMean
            pressureBBarMean
            consistenceClass
            consistenceTarget
            consistenceClassMax
            consistenceClassMin
            consistenceLowerLimitSpot
            consistenceStandard
            consistenceUpperLimitSpot
            consistencePredictionType
            consistenceMmQualifier
            plantGeofenceIdMostRecent
            co2
            tempAtLoadMix
            tempAtPlantExit
            tempAtSiteArrival
            tempAtPour
            tz
            batchSpeedPattern
            batchSpeedPatternTime
            speedPatternAtSite
            speedPatternAtSiteTime
            rmcPlantCodeLoadingPoint
            rheometryPredictionType
            rheometryPlasticViscosityPaS
            rheometryStaticYieldStressPa
            rheometryDynamicYieldStressPa
            rheometryStaticYieldStressTargetMinPa
            rheometryStaticYieldStressTargetMaxPa
            rheometryPlasticViscosityTargetMinPas
            rheometryPlasticViscosityTargetMaxPas
            delete_ttl
            extTruckName
            extTruckId
            config
            inBatchPlant
            inSite
            canTrackGeo
            deliveryTags
            allowableWaterToAddLitres
            excessWaterAddedDuringBatchingLitres
            mixDesignCode
            maxWaterCementRatio
            spinUpStatus
            spinUpStatusUpdateTime
            emptyDrumStage
            emptyDrumType
            emptyDrumTime
            additionalWaterDetected
            washoutWaterMeasured
            additionalWaterPerM3
            midPourWaterAdded
            prePourWaterAdded
            unclassifiedWaterAdded
            waterAddedAtPlant
            additionalWaterMeasured
            percentAir
            concreteVolume
            concreteVolumeM3AtPlantExit
            concreteVolumeM3AtSiteArrival
            concreteVolumeM3AtPour
            concreteVolumeM3AtSiteExit
            airPercentAtPlantExit
            airPercentAtSiteArrival
            airPercentAtPour
            airPercentAtSiteExit
            airPercentAtLoadMix
            weatherTempDegcAtPlant
            weatherCodeAtPlant
            weatherTempDegcAtSiteArrival
            weatherCodeAtSiteArrival
            deviceHealthStatus
          }
          nextToken
          timestamp
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      customerId
    };
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetCustomerTruckSnapshotsQuery>(
      response.data.getCustomerTruckSnapshots
    );
  }
  async GetLoadingPointTruckSnapshots(
    rmcId: string,
    plantCode: string,
    loadingPoint: string
  ): Promise<GetLoadingPointTruckSnapshotsQuery> {
    const statement = `query GetLoadingPointTruckSnapshots($rmcId: String!, $plantCode: String!, $loadingPoint: String!) {
        getLoadingPointTruckSnapshots(
          rmcId: $rmcId
          plantCode: $plantCode
          loadingPoint: $loadingPoint
        ) {
          __typename
          items {
            __typename
            imei
            eventType
            rmcProvider
            rmcCustomerId
            rmcCustomerName
            rmcAndCustomerId
            systemDatetimeUtcStr
            truckId
            truckPlate
            truckImei
            datetimeBatch
            slumpCode
            orderCode
            docketId
            docketId1
            commercialProductCode
            commercialProductDescription
            deliveredQuantity
            plantCode
            loadingPoint
            jobsiteCode
            jobsiteDescription
            siteLocation
            plantLocation
            tripStartTime
            tripEndTime
            pourTime
            pourEvents
            pourLocation
            leftBatchPlant
            arrivedAtSite
            leftSite
            deliveryStartTime
            deliveryEndTime
            consistenceMmAtLoadMix
            consistenceMmAtLoadMixOk
            consistenceMmQualifierAtLoadMix
            consistenceMmAtPlantExit
            consistenceMmAtPlantExitOk
            consistenceMmQualifierAtPlantExit
            consistenceMmAtSiteArrival
            consistenceMmAtSiteArrivalOk
            consistenceMmQualifierAtSiteArrival
            consistenceMmAtPour
            consistenceMmAtPourOk
            consistenceMmQualifierAtPour
            siteWaitTimeSeconds
            siteTimeSeconds
            waterAdditions
            gpsLatitudeDecimal
            gpsLongitudeDecimal
            gpsLatitudes
            gpsLongitudes
            pressureABarLowLatency
            pressureBBarLowLatency
            supplyVoltageMean
            drumLowLatencyRpm
            drumVectorRpm
            temperatureModuleSurfaceTemperatureDegc
            temperatureModuleConcreteTemperatureDegc
            consistenceMmUtcStr
            consistenceMm
            consistenceMinMm
            consistenceMaxMm
            consistenceTestType
            pressureABarMean
            pressureBBarMean
            consistenceClass
            consistenceTarget
            consistenceClassMax
            consistenceClassMin
            consistenceLowerLimitSpot
            consistenceStandard
            consistenceUpperLimitSpot
            consistencePredictionType
            consistenceMmQualifier
            plantGeofenceIdMostRecent
            co2
            tempAtLoadMix
            tempAtPlantExit
            tempAtSiteArrival
            tempAtPour
            tz
            batchSpeedPattern
            batchSpeedPatternTime
            speedPatternAtSite
            speedPatternAtSiteTime
            rmcPlantCodeLoadingPoint
            rheometryPredictionType
            rheometryPlasticViscosityPaS
            rheometryStaticYieldStressPa
            rheometryDynamicYieldStressPa
            rheometryStaticYieldStressTargetMinPa
            rheometryStaticYieldStressTargetMaxPa
            rheometryPlasticViscosityTargetMinPas
            rheometryPlasticViscosityTargetMaxPas
            delete_ttl
            extTruckName
            extTruckId
            config
            inBatchPlant
            inSite
            canTrackGeo
            deliveryTags
            allowableWaterToAddLitres
            excessWaterAddedDuringBatchingLitres
            mixDesignCode
            maxWaterCementRatio
            spinUpStatus
            spinUpStatusUpdateTime
            emptyDrumStage
            emptyDrumType
            emptyDrumTime
            additionalWaterDetected
            washoutWaterMeasured
            additionalWaterPerM3
            midPourWaterAdded
            prePourWaterAdded
            unclassifiedWaterAdded
            waterAddedAtPlant
            additionalWaterMeasured
            percentAir
            concreteVolume
            concreteVolumeM3AtPlantExit
            concreteVolumeM3AtSiteArrival
            concreteVolumeM3AtPour
            concreteVolumeM3AtSiteExit
            airPercentAtPlantExit
            airPercentAtSiteArrival
            airPercentAtPour
            airPercentAtSiteExit
            airPercentAtLoadMix
            weatherTempDegcAtPlant
            weatherCodeAtPlant
            weatherTempDegcAtSiteArrival
            weatherCodeAtSiteArrival
            deviceHealthStatus
          }
          nextToken
          timestamp
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      plantCode,
      loadingPoint
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetLoadingPointTruckSnapshotsQuery>(
      response.data.getLoadingPointTruckSnapshots
    );
  }
  async GetTruckSnapshotsByTruckId(
    rmcId: string,
    truckId: number
  ): Promise<GetTruckSnapshotsByTruckIdQuery> {
    const statement = `query GetTruckSnapshotsByTruckId($rmcId: String!, $truckId: Int!) {
        getTruckSnapshotsByTruckId(rmcId: $rmcId, truckId: $truckId) {
          __typename
          items {
            __typename
            imei
            eventType
            rmcProvider
            rmcCustomerId
            rmcCustomerName
            rmcAndCustomerId
            systemDatetimeUtcStr
            truckId
            truckPlate
            truckImei
            datetimeBatch
            slumpCode
            orderCode
            docketId
            docketId1
            commercialProductCode
            commercialProductDescription
            deliveredQuantity
            plantCode
            loadingPoint
            jobsiteCode
            jobsiteDescription
            siteLocation
            plantLocation
            tripStartTime
            tripEndTime
            pourTime
            pourEvents
            pourLocation
            leftBatchPlant
            arrivedAtSite
            leftSite
            deliveryStartTime
            deliveryEndTime
            consistenceMmAtLoadMix
            consistenceMmAtLoadMixOk
            consistenceMmQualifierAtLoadMix
            consistenceMmAtPlantExit
            consistenceMmAtPlantExitOk
            consistenceMmQualifierAtPlantExit
            consistenceMmAtSiteArrival
            consistenceMmAtSiteArrivalOk
            consistenceMmQualifierAtSiteArrival
            consistenceMmAtPour
            consistenceMmAtPourOk
            consistenceMmQualifierAtPour
            siteWaitTimeSeconds
            siteTimeSeconds
            waterAdditions
            gpsLatitudeDecimal
            gpsLongitudeDecimal
            gpsLatitudes
            gpsLongitudes
            pressureABarLowLatency
            pressureBBarLowLatency
            supplyVoltageMean
            drumLowLatencyRpm
            drumVectorRpm
            temperatureModuleSurfaceTemperatureDegc
            temperatureModuleConcreteTemperatureDegc
            consistenceMmUtcStr
            consistenceMm
            consistenceMinMm
            consistenceMaxMm
            consistenceTestType
            pressureABarMean
            pressureBBarMean
            consistenceClass
            consistenceTarget
            consistenceClassMax
            consistenceClassMin
            consistenceLowerLimitSpot
            consistenceStandard
            consistenceUpperLimitSpot
            consistencePredictionType
            consistenceMmQualifier
            plantGeofenceIdMostRecent
            co2
            tempAtLoadMix
            tempAtPlantExit
            tempAtSiteArrival
            tempAtPour
            tz
            batchSpeedPattern
            batchSpeedPatternTime
            speedPatternAtSite
            speedPatternAtSiteTime
            rmcPlantCodeLoadingPoint
            rheometryPredictionType
            rheometryPlasticViscosityPaS
            rheometryStaticYieldStressPa
            rheometryDynamicYieldStressPa
            rheometryStaticYieldStressTargetMinPa
            rheometryStaticYieldStressTargetMaxPa
            rheometryPlasticViscosityTargetMinPas
            rheometryPlasticViscosityTargetMaxPas
            delete_ttl
            extTruckName
            extTruckId
            config
            inBatchPlant
            inSite
            canTrackGeo
            deliveryTags
            allowableWaterToAddLitres
            excessWaterAddedDuringBatchingLitres
            mixDesignCode
            maxWaterCementRatio
            spinUpStatus
            spinUpStatusUpdateTime
            emptyDrumStage
            emptyDrumType
            emptyDrumTime
            additionalWaterDetected
            washoutWaterMeasured
            additionalWaterPerM3
            midPourWaterAdded
            prePourWaterAdded
            unclassifiedWaterAdded
            waterAddedAtPlant
            additionalWaterMeasured
            percentAir
            concreteVolume
            concreteVolumeM3AtPlantExit
            concreteVolumeM3AtSiteArrival
            concreteVolumeM3AtPour
            concreteVolumeM3AtSiteExit
            airPercentAtPlantExit
            airPercentAtSiteArrival
            airPercentAtPour
            airPercentAtSiteExit
            airPercentAtLoadMix
            weatherTempDegcAtPlant
            weatherCodeAtPlant
            weatherTempDegcAtSiteArrival
            weatherCodeAtSiteArrival
            deviceHealthStatus
          }
          nextToken
          timestamp
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      truckId
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <GetTruckSnapshotsByTruckIdQuery>(
      response.data.getTruckSnapshotsByTruckId
    );
  }
  async TruckServiceGetAllDevices(
    searchField?: string,
    searchValue?: string,
    limit?: number,
    nextToken?: string
  ): Promise<TruckServiceGetAllDevicesQuery> {
    const statement = `query TruckServiceGetAllDevices($searchField: String, $searchValue: String, $limit: Int, $nextToken: String) {
        truckServiceGetAllDevices(
          searchField: $searchField
          searchValue: $searchValue
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            imei
            serialNumber
            hostosVersion
            hardwareVersion
            applicationVersion
            systemUpTimeSeconds
            connectionLastReceived
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (searchField) {
      gqlAPIServiceArguments.searchField = searchField;
    }
    if (searchValue) {
      gqlAPIServiceArguments.searchValue = searchValue;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceGetAllDevicesQuery>(
      response.data.truckServiceGetAllDevices
    );
  }
  async TruckServiceRequestAuditUpload(
    Registration: string,
    FileName: string
  ): Promise<TruckServiceRequestAuditUploadQuery> {
    const statement = `query TruckServiceRequestAuditUpload($Registration: String!, $FileName: String!) {
        truckServiceRequestAuditUpload(Registration: $Registration, FileName: $FileName) {
          __typename
          item
          items
        }
      }`;
    const gqlAPIServiceArguments: any = {
      Registration,
      FileName
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceRequestAuditUploadQuery>(
      response.data.truckServiceRequestAuditUpload
    );
  }
  async TruckServiceListTruckAudits(
    Registration: string
  ): Promise<TruckServiceListTruckAuditsQuery> {
    const statement = `query TruckServiceListTruckAudits($Registration: String!) {
        truckServiceListTruckAudits(Registration: $Registration) {
          __typename
          item
          items
        }
      }`;
    const gqlAPIServiceArguments: any = {
      Registration
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceListTruckAuditsQuery>(
      response.data.truckServiceListTruckAudits
    );
  }
  async TruckServiceGetTruckAudit(
    Registration: string
  ): Promise<TruckServiceGetTruckAuditQuery> {
    const statement = `query TruckServiceGetTruckAudit($Registration: String!) {
        truckServiceGetTruckAudit(Registration: $Registration) {
          __typename
          item
          items
        }
      }`;
    const gqlAPIServiceArguments: any = {
      Registration
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceGetTruckAuditQuery>(
      response.data.truckServiceGetTruckAudit
    );
  }
  async TruckServiceRequestAuditFileLink(
    UploadKey: string
  ): Promise<TruckServiceRequestAuditFileLinkQuery> {
    const statement = `query TruckServiceRequestAuditFileLink($UploadKey: String!) {
        truckServiceRequestAuditFileLink(UploadKey: $UploadKey) {
          __typename
          item
          items
        }
      }`;
    const gqlAPIServiceArguments: any = {
      UploadKey
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceRequestAuditFileLinkQuery>(
      response.data.truckServiceRequestAuditFileLink
    );
  }
  async TruckServiceGetAllTrucks(
    searchField?: string,
    searchValue?: string,
    limit?: number,
    nextToken?: string,
    viewType?: string
  ): Promise<TruckServiceGetAllTrucksQuery> {
    const statement = `query TruckServiceGetAllTrucks($searchField: String, $searchValue: String, $limit: Int, $nextToken: String, $viewType: String) {
        truckServiceGetAllTrucks(
          searchField: $searchField
          searchValue: $searchValue
          limit: $limit
          nextToken: $nextToken
          viewType: $viewType
        ) {
          __typename
          items {
            __typename
            truckId
            rmcProvider
            registration
            deviceImei
            serialNo
            vin
            project
            permitted_rmcs
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (searchField) {
      gqlAPIServiceArguments.searchField = searchField;
    }
    if (searchValue) {
      gqlAPIServiceArguments.searchValue = searchValue;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (viewType) {
      gqlAPIServiceArguments.viewType = viewType;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceGetAllTrucksQuery>(
      response.data.truckServiceGetAllTrucks
    );
  }
  async TruckServiceGetLatestSlos(
    imeis: Array<string | null>,
    limit?: number,
    nextToken?: string
  ): Promise<TruckServiceGetLatestSlosQuery> {
    const statement = `query TruckServiceGetLatestSlos($imeis: [String]!, $limit: Int, $nextToken: String) {
        truckServiceGetLatestSlos(imeis: $imeis, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            ts
            imei
            slo_type
            slo_metrics {
              __typename
              connection {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              dockets {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              drum_module {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              pressure {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              water_flowmeter {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
            }
            metadata {
              __typename
              truck_id
              registration
              rmc_provider
              application_version
              hardware_version
              host_os_version
              imsi
              serial_number
              system_up_time_seconds
            }
            delete_ttl
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {
      imeis
    };
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceGetLatestSlosQuery>(
      response.data.truckServiceGetLatestSlos
    );
  }
  async TruckServiceListLatestSlos(
    status?: ListLatestSlosStatus,
    sloStatus?: ListLatestSlosStatusFilter,
    limit?: number,
    nextToken?: string
  ): Promise<TruckServiceListLatestSlosQuery> {
    const statement = `query TruckServiceListLatestSlos($status: ListLatestSlosStatus, $sloStatus: ListLatestSlosStatusFilter, $limit: Int, $nextToken: String) {
        truckServiceListLatestSlos(
          status: $status
          sloStatus: $sloStatus
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            ts
            imei
            slo_type
            slo_metrics {
              __typename
              connection {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              dockets {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              drum_module {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              pressure {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              water_flowmeter {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
            }
            metadata {
              __typename
              truck_id
              registration
              rmc_provider
              application_version
              hardware_version
              host_os_version
              imsi
              serial_number
              system_up_time_seconds
            }
            delete_ttl
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (status) {
      gqlAPIServiceArguments.status = status;
    }
    if (sloStatus) {
      gqlAPIServiceArguments.sloStatus = sloStatus;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceListLatestSlosQuery>(
      response.data.truckServiceListLatestSlos
    );
  }
  async TruckServiceSearchLatestSlo(
    searchField: string,
    searchValue: string
  ): Promise<TruckServiceSearchLatestSloQuery> {
    const statement = `query TruckServiceSearchLatestSlo($searchField: String!, $searchValue: String!) {
        truckServiceSearchLatestSlo(
          searchField: $searchField
          searchValue: $searchValue
        ) {
          __typename
          ts
          imei
          slo_type
          slo_metrics {
            __typename
            connection {
              __typename
              slo
              details
              sli_metrics {
                __typename
                sli_name
                sli_status
                sli_reason
              }
            }
            dockets {
              __typename
              slo
              details
              sli_metrics {
                __typename
                sli_name
                sli_status
                sli_reason
              }
            }
            drum_module {
              __typename
              slo
              details
              sli_metrics {
                __typename
                sli_name
                sli_status
                sli_reason
              }
            }
            pressure {
              __typename
              slo
              details
              sli_metrics {
                __typename
                sli_name
                sli_status
                sli_reason
              }
            }
            water_flowmeter {
              __typename
              slo
              details
              sli_metrics {
                __typename
                sli_name
                sli_status
                sli_reason
              }
            }
          }
          metadata {
            __typename
            truck_id
            registration
            rmc_provider
            application_version
            hardware_version
            host_os_version
            imsi
            serial_number
            system_up_time_seconds
          }
          delete_ttl
        }
      }`;
    const gqlAPIServiceArguments: any = {
      searchField,
      searchValue
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceSearchLatestSloQuery>(
      response.data.truckServiceSearchLatestSlo
    );
  }
  async TruckServiceGetTruckSlos(
    imei: string,
    limit?: number,
    nextToken?: string
  ): Promise<TruckServiceGetTruckSlosQuery> {
    const statement = `query TruckServiceGetTruckSlos($imei: String!, $limit: Int, $nextToken: String) {
        truckServiceGetTruckSlos(imei: $imei, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            ts
            imei
            slo_type
            slo_metrics {
              __typename
              connection {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              dockets {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              drum_module {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              pressure {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
              water_flowmeter {
                __typename
                slo
                details
                sli_metrics {
                  __typename
                  sli_name
                  sli_status
                  sli_reason
                }
              }
            }
            metadata {
              __typename
              truck_id
              registration
              rmc_provider
              application_version
              hardware_version
              host_os_version
              imsi
              serial_number
              system_up_time_seconds
            }
            delete_ttl
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {
      imei
    };
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceGetTruckSlosQuery>(
      response.data.truckServiceGetTruckSlos
    );
  }
  async TruckServiceGetTruck(
    truckKeysType: TruckKeysTypes,
    keyValue: string,
    validFrom?: string
  ): Promise<TruckServiceGetTruckQuery> {
    const statement = `query TruckServiceGetTruck($truckKeysType: TruckKeysTypes!, $keyValue: String!, $validFrom: String) {
        truckServiceGetTruck(
          truckKeysType: $truckKeysType
          keyValue: $keyValue
          validFrom: $validFrom
        ) {
          __typename
          truck_id
          ext_truck_id
          ext_truck_name
          rmc_provider
          registration
          device_imei
          serial_no
          vin
          project
          valid_from
          valid_to
          config {
            __typename
            physical {
              __typename
              gearbox_ratio
              hydraulic_motor_displacement_cc
              drum_volume_m3
              is_charging_clockwise
              is_pressure_id1_charging
              is_pressure_b_insulated
              pressure_sensor_location
            }
            operations {
              __typename
              is_fm_enabled
              is_pa_enabled
              is_pb_enabled
              is_smarthatch_enabled
              is_dm_temperature_fault
              is_dm_fault
              is_fm_fault
              is_pa_fault
              is_pb_fault
              is_cb_fault
              is_smarthatch_fault
              is_dm_fitted
              is_fm_fitted
              is_pa_fitted
              is_pb_fitted
              is_smarthatch_fitted
              maintenance_status
              cb_mounting_location
              cb_mounting_direction
            }
            globalConfig {
              __typename
              is_whitelisted
              is_off_the_road
              is_virtual
              misc
              manufacturer
              model
              no_consistence
              no_consistence_description
              rpm_sensor
            }
          }
          permitted_rmcs
        }
      }`;
    const gqlAPIServiceArguments: any = {
      truckKeysType,
      keyValue
    };
    if (validFrom) {
      gqlAPIServiceArguments.validFrom = validFrom;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceGetTruckQuery>response.data.truckServiceGetTruck;
  }
  async TruckServiceIsRmcPermitted(
    truckId: number,
    rmc: string
  ): Promise<TruckServiceIsRmcPermittedQuery> {
    const statement = `query TruckServiceIsRmcPermitted($truckId: Int!, $rmc: String!) {
        truckServiceIsRmcPermitted(truckId: $truckId, rmc: $rmc) {
          __typename
          permitted
          reason
          truckId
          rmc
          permittedRmcs
          currentRmc
        }
      }`;
    const gqlAPIServiceArguments: any = {
      truckId,
      rmc
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <TruckServiceIsRmcPermittedQuery>(
      response.data.truckServiceIsRmcPermitted
    );
  }
  async TruckServiceGetImeisToForward(): Promise<
    TruckServiceGetImeisToForwardQuery
  > {
    const statement = `query TruckServiceGetImeisToForward {
        truckServiceGetImeisToForward {
          __typename
          imeis
        }
      }`;
    const response = (await this.client.graphql({ query: statement })) as any;
    return <TruckServiceGetImeisToForwardQuery>(
      response.data.truckServiceGetImeisToForward
    );
  }
  async TruckServiceGetTruckIdsToForward(): Promise<
    TruckServiceGetTruckIdsToForwardQuery
  > {
    const statement = `query TruckServiceGetTruckIdsToForward {
        truckServiceGetTruckIdsToForward {
          __typename
          truck_ids
        }
      }`;
    const response = (await this.client.graphql({ query: statement })) as any;
    return <TruckServiceGetTruckIdsToForwardQuery>(
      response.data.truckServiceGetTruckIdsToForward
    );
  }
  async MediaServiceListMedia(
    truckId?: number,
    orderId?: string,
    docketId?: string,
    timestampStart?: string,
    timestampEnd?: string
  ): Promise<Array<MediaServiceListMediaQuery>> {
    const statement = `query MediaServiceListMedia($truckId: Int, $orderId: String, $docketId: String, $timestampStart: String, $timestampEnd: String) {
        mediaServiceListMedia(
          truckId: $truckId
          orderId: $orderId
          docketId: $docketId
          timestampStart: $timestampStart
          timestampEnd: $timestampEnd
        ) {
          __typename
          truckId
          orderId
          docketId
          targetTimestamp
          createdTimestamp
          comment
          s3Key
          rmcId
          userSubId
          userFirstName
          userLastName
          metadata
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (truckId) {
      gqlAPIServiceArguments.truckId = truckId;
    }
    if (orderId) {
      gqlAPIServiceArguments.orderId = orderId;
    }
    if (docketId) {
      gqlAPIServiceArguments.docketId = docketId;
    }
    if (timestampStart) {
      gqlAPIServiceArguments.timestampStart = timestampStart;
    }
    if (timestampEnd) {
      gqlAPIServiceArguments.timestampEnd = timestampEnd;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <Array<MediaServiceListMediaQuery>>(
      response.data.mediaServiceListMedia
    );
  }
  async MediaServiceMediaCreate(
    truckId: number,
    orderId?: string,
    rmcId?: string,
    docketId?: string,
    targetTimestamp?: string,
    createdTimestamp?: string,
    comment?: string,
    fileName?: string,
    userSubId?: string,
    userFirstName?: string,
    userLastName?: string,
    metadata?: string
  ): Promise<MediaServiceMediaCreateQuery> {
    const statement = `query MediaServiceMediaCreate($truckId: Int!, $orderId: String, $rmcId: String, $docketId: String, $targetTimestamp: String, $createdTimestamp: String, $comment: String, $fileName: String, $userSubId: String, $userFirstName: String, $userLastName: String, $metadata: String) {
        mediaServiceMediaCreate(
          truckId: $truckId
          orderId: $orderId
          rmcId: $rmcId
          docketId: $docketId
          targetTimestamp: $targetTimestamp
          createdTimestamp: $createdTimestamp
          comment: $comment
          fileName: $fileName
          userSubId: $userSubId
          userFirstName: $userFirstName
          userLastName: $userLastName
          metadata: $metadata
        ) {
          __typename
          url
        }
      }`;
    const gqlAPIServiceArguments: any = {
      truckId
    };
    if (orderId) {
      gqlAPIServiceArguments.orderId = orderId;
    }
    if (rmcId) {
      gqlAPIServiceArguments.rmcId = rmcId;
    }
    if (docketId) {
      gqlAPIServiceArguments.docketId = docketId;
    }
    if (targetTimestamp) {
      gqlAPIServiceArguments.targetTimestamp = targetTimestamp;
    }
    if (createdTimestamp) {
      gqlAPIServiceArguments.createdTimestamp = createdTimestamp;
    }
    if (comment) {
      gqlAPIServiceArguments.comment = comment;
    }
    if (fileName) {
      gqlAPIServiceArguments.fileName = fileName;
    }
    if (userSubId) {
      gqlAPIServiceArguments.userSubId = userSubId;
    }
    if (userFirstName) {
      gqlAPIServiceArguments.userFirstName = userFirstName;
    }
    if (userLastName) {
      gqlAPIServiceArguments.userLastName = userLastName;
    }
    if (metadata) {
      gqlAPIServiceArguments.metadata = metadata;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <MediaServiceMediaCreateQuery>response.data.mediaServiceMediaCreate;
  }
  async MediaServiceMediaFileLink(
    uploadKey: string
  ): Promise<MediaServiceMediaFileLinkQuery> {
    const statement = `query MediaServiceMediaFileLink($uploadKey: String!) {
        mediaServiceMediaFileLink(uploadKey: $uploadKey) {
          __typename
          url
        }
      }`;
    const gqlAPIServiceArguments: any = {
      uploadKey
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <MediaServiceMediaFileLinkQuery>(
      response.data.mediaServiceMediaFileLink
    );
  }
  async CubeOrdersGetOrdersForRmc(
    rmcId: string,
    take: number,
    startDatetime?: string,
    endDatetime?: string,
    plantCodes?: Array<string>,
    cursor?: string
  ): Promise<CubeOrdersGetOrdersForRmcQuery> {
    const statement = `query CubeOrdersGetOrdersForRmc($rmcId: String!, $startDatetime: String, $endDatetime: String, $plantCodes: [String!], $cursor: String, $take: Int!) {
        cubeOrdersGetOrdersForRmc(
          rmcId: $rmcId
          startDatetime: $startDatetime
          endDatetime: $endDatetime
          plantCodes: $plantCodes
          cursor: $cursor
          take: $take
        ) {
          __typename
          orders {
            __typename
            rmcId
            orderCode
            slumpCode
            jobsiteDescription
            jobsiteCode
            commercialProductCode
            commercialProductDescription
            aggregateSize
            deliveryQuantity
            consistenceTarget
            consistenceClass
            rmcCustomerName
            deliveries
            volumeDelivered
            firstBatchingTimestamp
            lastBatchingTimestamp
            timezone
          }
          cursor
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      take
    };
    if (startDatetime) {
      gqlAPIServiceArguments.startDatetime = startDatetime;
    }
    if (endDatetime) {
      gqlAPIServiceArguments.endDatetime = endDatetime;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <CubeOrdersGetOrdersForRmcQuery>(
      response.data.cubeOrdersGetOrdersForRmc
    );
  }
  async CubeOrdersGetDeliveriesForRmc(
    rmcId: string,
    take: number,
    startDatetime?: string,
    endDatetime?: string,
    plantCodes?: Array<string>,
    cursor?: number
  ): Promise<CubeOrdersGetDeliveriesForRmcQuery> {
    const statement = `query CubeOrdersGetDeliveriesForRmc($rmcId: String!, $startDatetime: String, $endDatetime: String, $plantCodes: [String!], $take: Int!, $cursor: Int) {
        cubeOrdersGetDeliveriesForRmc(
          rmcId: $rmcId
          startDatetime: $startDatetime
          endDatetime: $endDatetime
          plantCodes: $plantCodes
          take: $take
          cursor: $cursor
        ) {
          __typename
          deliveries {
            __typename
            rmcId
            truckPlate
            extTruckName
            truckImei
            tripStartTime
            tripEndTime
            datetimeBatch
            slumpCode
            orderCode
            docketId
            docketId1
            commercialProductCode
            commercialProductDescription
            technicalProductCode
            technicalProductDescription
            deliveredQuantity
            plantCode
            jobsiteCode
            jobsiteDescription
            pourTime
            pourEvents
            pourLocation
            siteLocation
            plantLocation
            plantName
            loadingPoint
            leftBatchPlant
            arrivedAtSite
            leftSite
            consistenceMmAtLoadMix
            consistenceMmAtLoadMixOk
            consistenceMmQualifierAtLoadMix
            consistenceMmAtPlantExit
            consistenceMmAtPlantExitOk
            consistenceMmQualifierAtPlantExit
            consistenceMmAtSiteArrival
            consistenceMmAtSiteArrivalOk
            consistenceMmQualifierAtSiteArrival
            consistenceMmAtPour
            consistenceMmAtPourOk
            consistenceMmQualifierAtPour
            consistenceClass
            consistenceTarget
            consistenceClassMax
            consistenceClassMin
            consistenceLowerLimitSpot
            consistenceStandard
            consistenceTestType
            consistenceUpperLimitSpot
            customerName
            rheometryPlasticViscosityPasAtPlantExit
            rheometryPlasticViscosityPasAtSiteArrival
            rheometryPlasticViscosityPasAtPour
            rheometryPlasticViscosityPasPredictionType
            rheometryYieldStressPaAtPlantExit
            rheometryYieldStressPaAtSiteArrival
            rheometryYieldStressPaAtPour
            rheometryYieldStressPaPredictionType
            rheometryStaticYieldStressTargetMinPa
            rheometryStaticYieldStressTargetMaxPa
            rheometryPlasticViscosityTargetMinPas
            rheometryPlasticViscosityTargetMaxPas
            waterAdditions
            additionalWaterMeasured
            additionalWaterDetected
            washoutWaterMeasured
            additionalWaterPerM3
            midPourWaterAdded
            prePourWaterAdded
            unclassifiedWaterAdded
            waterAddedAtPlant
            timezone
            tempAtLoadMix
            tempAtSiteArrival
            tempAtPour
            tempAtPlantExit
            consistenceSpeedPattern
            speedPatternAtSite
            consistencePredictionType
            deliveryTags {
              __typename
              id
              rmcId
              name
              usageCount
              createdAt
              updatedAt
            }
            batchToDepartureTimeMinutes
            outboundTransitTimeMinutes
            siteWaitTimeMinutes
            pouringTimeMinutes
            leavingSiteTimeMinutes
            totalSiteTimeMinutes
            inboundTransitTimeMinutes
            totalCycleTimeMinutes
            deliveryManualTests {
              __typename
              id
              docketId
              type
              result
              testResult
              unit
              testTime
              createdBy
              comment
              mediaS3Key
              accepted
              acceptanceReason
              reviewedBy
            }
            allowableWaterToAddLitres
            excessWaterAddedDuringBatchingLitres
            mixDesignCode
            docketTargetWeights {
              __typename
              maxWaterCementRatio
              aggregate {
                __typename
                name
                type
                maxSizeMM
                value
                units
              }
              fillers {
                __typename
                type
                value
                units
              }
              water {
                __typename
                name
                value
                units
              }
              binders {
                __typename
                type
                value
                units
              }
              admixture {
                __typename
                name
                value
                units
                type
              }
              reinforcement {
                __typename
                name
                value
                units
              }
            }
            docketBatchedWeights {
              __typename
              aggregate {
                __typename
                name
                type
                maxSizeMM
                value
                units
              }
              fillers {
                __typename
                type
                value
                units
              }
              water {
                __typename
                name
                value
                units
              }
              binders {
                __typename
                type
                value
                units
              }
              admixture {
                __typename
                name
                value
                units
                type
              }
              reinforcement {
                __typename
                name
                value
                units
              }
            }
            docketTestResults {
              __typename
              type
              value
              units
              datetimeUTC
            }
            spinUpStatus
            spinUpStatusUpdateTime
            mediaCount
            commentCount
            comments
            spinUpStatusBeforeFirstNonSamplePour
            spinUpStatusBeforeLastSamplePour
            emptyDrumStage
            emptyDrumType
            emptyDrumTime
            truckConfig {
              __typename
              physical {
                __typename
                gearboxRatio
                hydraulicMotorDisplacementCc
                drumVolumeM3
                isChargingClockwise
                isPressureId1Charging
                isPressureBInsulated
                pressureSensorLocation
              }
              operations {
                __typename
                isDmTemperatureFault
                isDmFault
                isFmFault
                isCbFault
                isDmFitted
                isFmFitted
                maintenanceStatus
                cbMountingLocation
                cbMountingDirection
              }
              globalConfig {
                __typename
                isWhitelisted
                isOffTheRoad
                isVirtual
                rpmSensor
                misc
                manufacturer
                model
                noConsistence
                noConsistenceDescription
              }
            }
            concreteVolumeM3AtPlantExit
            concreteVolumeM3AtSiteArrival
            concreteVolumeM3AtPour
            concreteVolumeM3AtSiteExit
            airPercentAtPlantExit
            airPercentAtSiteArrival
            airPercentAtPour
            airPercentAtSiteExit
            airPercentAtLoadMix
            weatherTempDegcAtPlant
            weatherCodeAtPlant
            weatherTempDegcAtSiteArrival
            weatherCodeAtSiteArrival
            deviceHealthStatus
          }
          cursor
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      take
    };
    if (startDatetime) {
      gqlAPIServiceArguments.startDatetime = startDatetime;
    }
    if (endDatetime) {
      gqlAPIServiceArguments.endDatetime = endDatetime;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <CubeOrdersGetDeliveriesForRmcQuery>(
      response.data.cubeOrdersGetDeliveriesForRmc
    );
  }
  async CubeOrdersGetOrderTrips(
    rmcId: string,
    orderCode: string,
    plantCodes?: Array<string>
  ): Promise<Array<CubeOrdersGetOrderTripsQuery>> {
    const statement = `query CubeOrdersGetOrderTrips($rmcId: String!, $orderCode: String!, $plantCodes: [String!]) {
        cubeOrdersGetOrderTrips(
          rmcId: $rmcId
          orderCode: $orderCode
          plantCodes: $plantCodes
        ) {
          __typename
          rmcId
          truckPlate
          extTruckName
          tripStartTime
          tripEndTime
          datetimeBatch
          slumpCode
          orderCode
          docketId
          commercialProductCode
          commercialProductDescription
          technicalProductCode
          technicalProductDescription
          customerName
          deliveredQuantity
          plantCode
          plantName
          jobsiteCode
          jobsiteDescription
          pourTime
          pourEvents
          pourLocation
          siteLocation
          plantLocation
          loadingPoint
          leftBatchPlant
          arrivedAtSite
          leftSite
          consistenceMmAtLoadMix
          consistenceMmAtPlantExit
          consistenceMmAtSiteArrival
          consistenceMmAtPour
          consistenceClass
          consistenceTarget
          waterAdditions
          additionalWaterMeasured
          timezone
          tempAtLoadMix
          tempAtSiteArrival
          tempAtPour
          tempAtPlantExit
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      orderCode
    };
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <Array<CubeOrdersGetOrderTripsQuery>>(
      response.data.cubeOrdersGetOrderTrips
    );
  }
  async CubeOrdersGetTruckTrips(
    registration?: string,
    startDatetime?: string,
    endDatetime?: string,
    plantCodes?: Array<string>
  ): Promise<Array<CubeOrdersGetTruckTripsQuery>> {
    const statement = `query CubeOrdersGetTruckTrips($registration: String, $startDatetime: String, $endDatetime: String, $plantCodes: [String!]) {
        cubeOrdersGetTruckTrips(
          registration: $registration
          startDatetime: $startDatetime
          endDatetime: $endDatetime
          plantCodes: $plantCodes
        ) {
          __typename
          rmcId
          truckPlate
          extTruckName
          tripStartTime
          tripEndTime
          datetimeBatch
          slumpCode
          orderCode
          docketId
          commercialProductCode
          commercialProductDescription
          technicalProductCode
          technicalProductDescription
          customerName
          deliveredQuantity
          plantCode
          plantName
          jobsiteCode
          jobsiteDescription
          pourTime
          pourEvents
          pourLocation
          siteLocation
          plantLocation
          loadingPoint
          leftBatchPlant
          arrivedAtSite
          leftSite
          consistenceMmAtLoadMix
          consistenceMmAtPlantExit
          consistenceMmAtSiteArrival
          consistenceMmAtPour
          consistenceClass
          consistenceTarget
          waterAdditions
          additionalWaterMeasured
          timezone
          tempAtLoadMix
          tempAtSiteArrival
          tempAtPour
          tempAtPlantExit
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (registration) {
      gqlAPIServiceArguments.registration = registration;
    }
    if (startDatetime) {
      gqlAPIServiceArguments.startDatetime = startDatetime;
    }
    if (endDatetime) {
      gqlAPIServiceArguments.endDatetime = endDatetime;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <Array<CubeOrdersGetTruckTripsQuery>>(
      response.data.cubeOrdersGetTruckTrips
    );
  }
  async CubeOrdersGetOrderDelivery(
    rmcId: string,
    docketId: string
  ): Promise<CubeOrdersGetOrderDeliveryQuery> {
    const statement = `query CubeOrdersGetOrderDelivery($rmcId: String!, $docketId: String!) {
        cubeOrdersGetOrderDelivery(rmcId: $rmcId, docketId: $docketId) {
          __typename
          rmcId
          truckPlate
          extTruckName
          tripStartTime
          tripEndTime
          datetimeBatch
          slumpCode
          orderCode
          docketId
          commercialProductCode
          commercialProductDescription
          technicalProductCode
          technicalProductDescription
          customerName
          deliveredQuantity
          plantCode
          plantName
          jobsiteCode
          jobsiteDescription
          pourTime
          pourEvents
          pourLocation
          siteLocation
          plantLocation
          loadingPoint
          leftBatchPlant
          arrivedAtSite
          leftSite
          consistenceMmAtLoadMix
          consistenceMmAtPlantExit
          consistenceMmAtSiteArrival
          consistenceMmAtPour
          consistenceClass
          consistenceTarget
          waterAdditions
          additionalWaterMeasured
          timezone
          tempAtLoadMix
          tempAtSiteArrival
          tempAtPour
          tempAtPlantExit
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      docketId
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <CubeOrdersGetOrderDeliveryQuery>(
      response.data.cubeOrdersGetOrderDelivery
    );
  }
  async CubeOrdersGetOrderDeliveryTimeseries(
    rmcId: string,
    docketId: string,
    plantCodes?: Array<string>
  ): Promise<CubeOrdersGetOrderDeliveryTimeseriesQuery> {
    const statement = `query CubeOrdersGetOrderDeliveryTimeseries($rmcId: String!, $docketId: String!, $plantCodes: [String!]) {
        cubeOrdersGetOrderDeliveryTimeseries(
          rmcId: $rmcId
          docketId: $docketId
          plantCodes: $plantCodes
        ) {
          __typename
          timeseries {
            __typename
            timestamp
            geo
            rpm
            pressure
            pressureABarMean
            pressureBBarMean
            temp
            consistenceMm
            consistenceMmQualifier
            consistenceMinMm
            consistenceMaxMm
            rheometryPlasticViscosityPas
            rheometryStaticYieldStressPa
            gpsLongitudes
            gpsLatitudes
            percentAir
            concreteVolume
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      docketId
    };
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <CubeOrdersGetOrderDeliveryTimeseriesQuery>(
      response.data.cubeOrdersGetOrderDeliveryTimeseries
    );
  }
  async OrderSvcGetOrdersForRmc(
    rmcId: string,
    take: number,
    startDatetime?: string,
    productDescription?: string,
    productCode?: string,
    aggregateSize?: string,
    deliveryQuantity?: number,
    consistenceTarget?: number,
    consistenceClass?: string,
    endDatetime?: string,
    orderId?: string,
    customerIds?: Array<string>,
    siteDescription?: string,
    docketId?: string,
    batchPlant?: string,
    truckRegistration?: string,
    extTruckName?: string,
    siteCodes?: Array<string>,
    customerName?: string,
    plantCodes?: Array<string>,
    hasAddtWaterDetected?: boolean,
    hasAddtWaterMeasured?: boolean,
    hasWashoutWaterMeasured?: boolean,
    hasAddtWaterPerM3?: boolean,
    hasMidPourWaterAdded?: boolean,
    hasPrePourWaterAdded?: boolean,
    hasUnclassifiedWaterAdded?: boolean,
    hasWaterAddedAtPlant?: boolean,
    hasMedia?: boolean,
    hasComments?: boolean,
    hasTests?: boolean,
    hasExcessWaterAddedDuringBatching?: boolean,
    cursor?: string,
    sortField?: OrderSortField,
    sortDir?: SortDirection
  ): Promise<OrderSvcGetOrdersForRmcQuery> {
    const statement = `query OrderSvcGetOrdersForRmc($rmcId: String!, $startDatetime: String, $productDescription: String, $productCode: String, $aggregateSize: String, $deliveryQuantity: Float, $consistenceTarget: Int, $consistenceClass: String, $endDatetime: String, $orderId: String, $customerIds: [String!], $siteDescription: String, $docketId: String, $batchPlant: String, $truckRegistration: String, $extTruckName: String, $siteCodes: [String!], $customerName: String, $plantCodes: [String!], $hasAddtWaterDetected: Boolean, $hasAddtWaterMeasured: Boolean, $hasWashoutWaterMeasured: Boolean, $hasAddtWaterPerM3: Boolean, $hasMidPourWaterAdded: Boolean, $hasPrePourWaterAdded: Boolean, $hasUnclassifiedWaterAdded: Boolean, $hasWaterAddedAtPlant: Boolean, $hasMedia: Boolean, $hasComments: Boolean, $hasTests: Boolean, $hasExcessWaterAddedDuringBatching: Boolean, $take: Int!, $cursor: String, $sortField: OrderSortField, $sortDir: SortDirection) {
        orderSvcGetOrdersForRmc(
          rmcId: $rmcId
          startDatetime: $startDatetime
          productDescription: $productDescription
          productCode: $productCode
          aggregateSize: $aggregateSize
          deliveryQuantity: $deliveryQuantity
          consistenceTarget: $consistenceTarget
          consistenceClass: $consistenceClass
          endDatetime: $endDatetime
          orderId: $orderId
          customerIds: $customerIds
          siteDescription: $siteDescription
          docketId: $docketId
          batchPlant: $batchPlant
          truckRegistration: $truckRegistration
          extTruckName: $extTruckName
          siteCodes: $siteCodes
          customerName: $customerName
          plantCodes: $plantCodes
          hasAddtWaterDetected: $hasAddtWaterDetected
          hasAddtWaterMeasured: $hasAddtWaterMeasured
          hasWashoutWaterMeasured: $hasWashoutWaterMeasured
          hasAddtWaterPerM3: $hasAddtWaterPerM3
          hasMidPourWaterAdded: $hasMidPourWaterAdded
          hasPrePourWaterAdded: $hasPrePourWaterAdded
          hasUnclassifiedWaterAdded: $hasUnclassifiedWaterAdded
          hasWaterAddedAtPlant: $hasWaterAddedAtPlant
          hasMedia: $hasMedia
          hasComments: $hasComments
          hasTests: $hasTests
          hasExcessWaterAddedDuringBatching: $hasExcessWaterAddedDuringBatching
          take: $take
          cursor: $cursor
          sortField: $sortField
          sortDir: $sortDir
        ) {
          __typename
          orders {
            __typename
            rmcId
            orderCode
            slumpCode
            jobsiteDescription
            jobsiteCode
            commercialProductCode
            commercialProductDescription
            aggregateSize
            deliveryQuantity
            consistenceTarget
            consistenceClass
            rmcCustomerName
            deliveries
            volumeDelivered
            firstBatchingTimestamp
            lastBatchingTimestamp
            timezone
          }
          cursor
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      take
    };
    if (startDatetime) {
      gqlAPIServiceArguments.startDatetime = startDatetime;
    }
    if (productDescription) {
      gqlAPIServiceArguments.productDescription = productDescription;
    }
    if (productCode) {
      gqlAPIServiceArguments.productCode = productCode;
    }
    if (aggregateSize) {
      gqlAPIServiceArguments.aggregateSize = aggregateSize;
    }
    if (deliveryQuantity) {
      gqlAPIServiceArguments.deliveryQuantity = deliveryQuantity;
    }
    if (consistenceTarget) {
      gqlAPIServiceArguments.consistenceTarget = consistenceTarget;
    }
    if (consistenceClass) {
      gqlAPIServiceArguments.consistenceClass = consistenceClass;
    }
    if (endDatetime) {
      gqlAPIServiceArguments.endDatetime = endDatetime;
    }
    if (orderId) {
      gqlAPIServiceArguments.orderId = orderId;
    }
    if (customerIds) {
      gqlAPIServiceArguments.customerIds = customerIds;
    }
    if (siteDescription) {
      gqlAPIServiceArguments.siteDescription = siteDescription;
    }
    if (docketId) {
      gqlAPIServiceArguments.docketId = docketId;
    }
    if (batchPlant) {
      gqlAPIServiceArguments.batchPlant = batchPlant;
    }
    if (truckRegistration) {
      gqlAPIServiceArguments.truckRegistration = truckRegistration;
    }
    if (extTruckName) {
      gqlAPIServiceArguments.extTruckName = extTruckName;
    }
    if (siteCodes) {
      gqlAPIServiceArguments.siteCodes = siteCodes;
    }
    if (customerName) {
      gqlAPIServiceArguments.customerName = customerName;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    if (hasAddtWaterDetected) {
      gqlAPIServiceArguments.hasAddtWaterDetected = hasAddtWaterDetected;
    }
    if (hasAddtWaterMeasured) {
      gqlAPIServiceArguments.hasAddtWaterMeasured = hasAddtWaterMeasured;
    }
    if (hasWashoutWaterMeasured) {
      gqlAPIServiceArguments.hasWashoutWaterMeasured = hasWashoutWaterMeasured;
    }
    if (hasAddtWaterPerM3) {
      gqlAPIServiceArguments.hasAddtWaterPerM3 = hasAddtWaterPerM3;
    }
    if (hasMidPourWaterAdded) {
      gqlAPIServiceArguments.hasMidPourWaterAdded = hasMidPourWaterAdded;
    }
    if (hasPrePourWaterAdded) {
      gqlAPIServiceArguments.hasPrePourWaterAdded = hasPrePourWaterAdded;
    }
    if (hasUnclassifiedWaterAdded) {
      gqlAPIServiceArguments.hasUnclassifiedWaterAdded = hasUnclassifiedWaterAdded;
    }
    if (hasWaterAddedAtPlant) {
      gqlAPIServiceArguments.hasWaterAddedAtPlant = hasWaterAddedAtPlant;
    }
    if (hasMedia) {
      gqlAPIServiceArguments.hasMedia = hasMedia;
    }
    if (hasComments) {
      gqlAPIServiceArguments.hasComments = hasComments;
    }
    if (hasTests) {
      gqlAPIServiceArguments.hasTests = hasTests;
    }
    if (hasExcessWaterAddedDuringBatching) {
      gqlAPIServiceArguments.hasExcessWaterAddedDuringBatching = hasExcessWaterAddedDuringBatching;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    if (sortField) {
      gqlAPIServiceArguments.sortField = sortField;
    }
    if (sortDir) {
      gqlAPIServiceArguments.sortDir = sortDir;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetOrdersForRmcQuery>response.data.orderSvcGetOrdersForRmc;
  }
  async OrderSvcGetDeliveriesForRmc(
    rmcId: string,
    take: number,
    startDatetime?: string,
    productDescription?: string,
    productCode?: string,
    aggregateSize?: string,
    deliveryQuantity?: number,
    consistenceTarget?: number,
    consistenceClass?: string,
    endDatetime?: string,
    orderId?: string,
    customerIds?: Array<string>,
    siteDescription?: string,
    docketId?: string,
    batchPlant?: string,
    truckRegistration?: string,
    extTruckName?: string,
    siteCodes?: Array<string>,
    customerName?: string,
    plantCodes?: Array<string>,
    tags?: Array<string>,
    docketId1?: string,
    hasAddtWaterDetected?: boolean,
    hasAddtWaterMeasured?: boolean,
    hasWashoutWaterMeasured?: boolean,
    hasAddtWaterPerM3?: boolean,
    hasMidPourWaterAdded?: boolean,
    hasPrePourWaterAdded?: boolean,
    hasUnclassifiedWaterAdded?: boolean,
    hasWaterAddedAtPlant?: boolean,
    hasMedia?: boolean,
    hasComments?: boolean,
    hasTests?: boolean,
    hasExcessWaterAddedDuringBatching?: boolean,
    cursor?: number,
    sortField?: DeliverySortField,
    sortDir?: SortDirection
  ): Promise<OrderSvcGetDeliveriesForRmcQuery> {
    const statement = `query OrderSvcGetDeliveriesForRmc($rmcId: String!, $startDatetime: String, $productDescription: String, $productCode: String, $aggregateSize: String, $deliveryQuantity: Float, $consistenceTarget: Int, $consistenceClass: String, $endDatetime: String, $orderId: String, $customerIds: [String!], $siteDescription: String, $docketId: String, $batchPlant: String, $truckRegistration: String, $extTruckName: String, $siteCodes: [String!], $customerName: String, $plantCodes: [String!], $tags: [String!], $docketId1: String, $hasAddtWaterDetected: Boolean, $hasAddtWaterMeasured: Boolean, $hasWashoutWaterMeasured: Boolean, $hasAddtWaterPerM3: Boolean, $hasMidPourWaterAdded: Boolean, $hasPrePourWaterAdded: Boolean, $hasUnclassifiedWaterAdded: Boolean, $hasWaterAddedAtPlant: Boolean, $hasMedia: Boolean, $hasComments: Boolean, $hasTests: Boolean, $hasExcessWaterAddedDuringBatching: Boolean, $take: Int!, $cursor: Int, $sortField: DeliverySortField, $sortDir: SortDirection) {
        orderSvcGetDeliveriesForRmc(
          rmcId: $rmcId
          startDatetime: $startDatetime
          productDescription: $productDescription
          productCode: $productCode
          aggregateSize: $aggregateSize
          deliveryQuantity: $deliveryQuantity
          consistenceTarget: $consistenceTarget
          consistenceClass: $consistenceClass
          endDatetime: $endDatetime
          orderId: $orderId
          customerIds: $customerIds
          siteDescription: $siteDescription
          docketId: $docketId
          batchPlant: $batchPlant
          truckRegistration: $truckRegistration
          extTruckName: $extTruckName
          siteCodes: $siteCodes
          customerName: $customerName
          plantCodes: $plantCodes
          tags: $tags
          docketId1: $docketId1
          hasAddtWaterDetected: $hasAddtWaterDetected
          hasAddtWaterMeasured: $hasAddtWaterMeasured
          hasWashoutWaterMeasured: $hasWashoutWaterMeasured
          hasAddtWaterPerM3: $hasAddtWaterPerM3
          hasMidPourWaterAdded: $hasMidPourWaterAdded
          hasPrePourWaterAdded: $hasPrePourWaterAdded
          hasUnclassifiedWaterAdded: $hasUnclassifiedWaterAdded
          hasWaterAddedAtPlant: $hasWaterAddedAtPlant
          hasMedia: $hasMedia
          hasComments: $hasComments
          hasTests: $hasTests
          hasExcessWaterAddedDuringBatching: $hasExcessWaterAddedDuringBatching
          take: $take
          cursor: $cursor
          sortField: $sortField
          sortDir: $sortDir
        ) {
          __typename
          deliveries {
            __typename
            rmcId
            truckPlate
            extTruckName
            truckImei
            tripStartTime
            tripEndTime
            datetimeBatch
            slumpCode
            orderCode
            docketId
            docketId1
            commercialProductCode
            commercialProductDescription
            technicalProductCode
            technicalProductDescription
            deliveredQuantity
            plantCode
            jobsiteCode
            jobsiteDescription
            pourTime
            pourEvents
            pourLocation
            siteLocation
            plantLocation
            plantName
            loadingPoint
            leftBatchPlant
            arrivedAtSite
            leftSite
            consistenceMmAtLoadMix
            consistenceMmAtLoadMixOk
            consistenceMmQualifierAtLoadMix
            consistenceMmAtPlantExit
            consistenceMmAtPlantExitOk
            consistenceMmQualifierAtPlantExit
            consistenceMmAtSiteArrival
            consistenceMmAtSiteArrivalOk
            consistenceMmQualifierAtSiteArrival
            consistenceMmAtPour
            consistenceMmAtPourOk
            consistenceMmQualifierAtPour
            consistenceClass
            consistenceTarget
            consistenceClassMax
            consistenceClassMin
            consistenceLowerLimitSpot
            consistenceStandard
            consistenceTestType
            consistenceUpperLimitSpot
            customerName
            rheometryPlasticViscosityPasAtPlantExit
            rheometryPlasticViscosityPasAtSiteArrival
            rheometryPlasticViscosityPasAtPour
            rheometryPlasticViscosityPasPredictionType
            rheometryYieldStressPaAtPlantExit
            rheometryYieldStressPaAtSiteArrival
            rheometryYieldStressPaAtPour
            rheometryYieldStressPaPredictionType
            rheometryStaticYieldStressTargetMinPa
            rheometryStaticYieldStressTargetMaxPa
            rheometryPlasticViscosityTargetMinPas
            rheometryPlasticViscosityTargetMaxPas
            waterAdditions
            additionalWaterMeasured
            additionalWaterDetected
            washoutWaterMeasured
            additionalWaterPerM3
            midPourWaterAdded
            prePourWaterAdded
            unclassifiedWaterAdded
            waterAddedAtPlant
            timezone
            tempAtLoadMix
            tempAtSiteArrival
            tempAtPour
            tempAtPlantExit
            consistenceSpeedPattern
            speedPatternAtSite
            consistencePredictionType
            deliveryTags {
              __typename
              id
              rmcId
              name
              usageCount
              createdAt
              updatedAt
            }
            batchToDepartureTimeMinutes
            outboundTransitTimeMinutes
            siteWaitTimeMinutes
            pouringTimeMinutes
            leavingSiteTimeMinutes
            totalSiteTimeMinutes
            inboundTransitTimeMinutes
            totalCycleTimeMinutes
            deliveryManualTests {
              __typename
              id
              docketId
              type
              result
              testResult
              unit
              testTime
              createdBy
              comment
              mediaS3Key
              accepted
              acceptanceReason
              reviewedBy
            }
            allowableWaterToAddLitres
            excessWaterAddedDuringBatchingLitres
            mixDesignCode
            docketTargetWeights {
              __typename
              maxWaterCementRatio
              aggregate {
                __typename
                name
                type
                maxSizeMM
                value
                units
              }
              fillers {
                __typename
                type
                value
                units
              }
              water {
                __typename
                name
                value
                units
              }
              binders {
                __typename
                type
                value
                units
              }
              admixture {
                __typename
                name
                value
                units
                type
              }
              reinforcement {
                __typename
                name
                value
                units
              }
            }
            docketBatchedWeights {
              __typename
              aggregate {
                __typename
                name
                type
                maxSizeMM
                value
                units
              }
              fillers {
                __typename
                type
                value
                units
              }
              water {
                __typename
                name
                value
                units
              }
              binders {
                __typename
                type
                value
                units
              }
              admixture {
                __typename
                name
                value
                units
                type
              }
              reinforcement {
                __typename
                name
                value
                units
              }
            }
            docketTestResults {
              __typename
              type
              value
              units
              datetimeUTC
            }
            spinUpStatus
            spinUpStatusUpdateTime
            mediaCount
            commentCount
            comments
            spinUpStatusBeforeFirstNonSamplePour
            spinUpStatusBeforeLastSamplePour
            emptyDrumStage
            emptyDrumType
            emptyDrumTime
            truckConfig {
              __typename
              physical {
                __typename
                gearboxRatio
                hydraulicMotorDisplacementCc
                drumVolumeM3
                isChargingClockwise
                isPressureId1Charging
                isPressureBInsulated
                pressureSensorLocation
              }
              operations {
                __typename
                isDmTemperatureFault
                isDmFault
                isFmFault
                isCbFault
                isDmFitted
                isFmFitted
                maintenanceStatus
                cbMountingLocation
                cbMountingDirection
              }
              globalConfig {
                __typename
                isWhitelisted
                isOffTheRoad
                isVirtual
                rpmSensor
                misc
                manufacturer
                model
                noConsistence
                noConsistenceDescription
              }
            }
            concreteVolumeM3AtPlantExit
            concreteVolumeM3AtSiteArrival
            concreteVolumeM3AtPour
            concreteVolumeM3AtSiteExit
            airPercentAtPlantExit
            airPercentAtSiteArrival
            airPercentAtPour
            airPercentAtSiteExit
            airPercentAtLoadMix
            weatherTempDegcAtPlant
            weatherCodeAtPlant
            weatherTempDegcAtSiteArrival
            weatherCodeAtSiteArrival
            deviceHealthStatus
          }
          cursor
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      take
    };
    if (startDatetime) {
      gqlAPIServiceArguments.startDatetime = startDatetime;
    }
    if (productDescription) {
      gqlAPIServiceArguments.productDescription = productDescription;
    }
    if (productCode) {
      gqlAPIServiceArguments.productCode = productCode;
    }
    if (aggregateSize) {
      gqlAPIServiceArguments.aggregateSize = aggregateSize;
    }
    if (deliveryQuantity) {
      gqlAPIServiceArguments.deliveryQuantity = deliveryQuantity;
    }
    if (consistenceTarget) {
      gqlAPIServiceArguments.consistenceTarget = consistenceTarget;
    }
    if (consistenceClass) {
      gqlAPIServiceArguments.consistenceClass = consistenceClass;
    }
    if (endDatetime) {
      gqlAPIServiceArguments.endDatetime = endDatetime;
    }
    if (orderId) {
      gqlAPIServiceArguments.orderId = orderId;
    }
    if (customerIds) {
      gqlAPIServiceArguments.customerIds = customerIds;
    }
    if (siteDescription) {
      gqlAPIServiceArguments.siteDescription = siteDescription;
    }
    if (docketId) {
      gqlAPIServiceArguments.docketId = docketId;
    }
    if (batchPlant) {
      gqlAPIServiceArguments.batchPlant = batchPlant;
    }
    if (truckRegistration) {
      gqlAPIServiceArguments.truckRegistration = truckRegistration;
    }
    if (extTruckName) {
      gqlAPIServiceArguments.extTruckName = extTruckName;
    }
    if (siteCodes) {
      gqlAPIServiceArguments.siteCodes = siteCodes;
    }
    if (customerName) {
      gqlAPIServiceArguments.customerName = customerName;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    if (tags) {
      gqlAPIServiceArguments.tags = tags;
    }
    if (docketId1) {
      gqlAPIServiceArguments.docketId1 = docketId1;
    }
    if (hasAddtWaterDetected) {
      gqlAPIServiceArguments.hasAddtWaterDetected = hasAddtWaterDetected;
    }
    if (hasAddtWaterMeasured) {
      gqlAPIServiceArguments.hasAddtWaterMeasured = hasAddtWaterMeasured;
    }
    if (hasWashoutWaterMeasured) {
      gqlAPIServiceArguments.hasWashoutWaterMeasured = hasWashoutWaterMeasured;
    }
    if (hasAddtWaterPerM3) {
      gqlAPIServiceArguments.hasAddtWaterPerM3 = hasAddtWaterPerM3;
    }
    if (hasMidPourWaterAdded) {
      gqlAPIServiceArguments.hasMidPourWaterAdded = hasMidPourWaterAdded;
    }
    if (hasPrePourWaterAdded) {
      gqlAPIServiceArguments.hasPrePourWaterAdded = hasPrePourWaterAdded;
    }
    if (hasUnclassifiedWaterAdded) {
      gqlAPIServiceArguments.hasUnclassifiedWaterAdded = hasUnclassifiedWaterAdded;
    }
    if (hasWaterAddedAtPlant) {
      gqlAPIServiceArguments.hasWaterAddedAtPlant = hasWaterAddedAtPlant;
    }
    if (hasMedia) {
      gqlAPIServiceArguments.hasMedia = hasMedia;
    }
    if (hasComments) {
      gqlAPIServiceArguments.hasComments = hasComments;
    }
    if (hasTests) {
      gqlAPIServiceArguments.hasTests = hasTests;
    }
    if (hasExcessWaterAddedDuringBatching) {
      gqlAPIServiceArguments.hasExcessWaterAddedDuringBatching = hasExcessWaterAddedDuringBatching;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    if (sortField) {
      gqlAPIServiceArguments.sortField = sortField;
    }
    if (sortDir) {
      gqlAPIServiceArguments.sortDir = sortDir;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetDeliveriesForRmcQuery>(
      response.data.orderSvcGetDeliveriesForRmc
    );
  }
  async OrderSvcDownloadDeliveriesForRmc(
    rmcId: string,
    take: number,
    url: string,
    startDatetime?: string,
    productDescription?: string,
    productCode?: string,
    aggregateSize?: string,
    deliveryQuantity?: number,
    consistenceTarget?: number,
    consistenceClass?: string,
    endDatetime?: string,
    orderId?: string,
    customerIds?: Array<string>,
    siteDescription?: string,
    docketId?: string,
    batchPlant?: string,
    truckRegistration?: string,
    extTruckName?: string,
    siteCodes?: Array<string>,
    customerName?: string,
    plantCodes?: Array<string>,
    tags?: Array<string>,
    docketId1?: string,
    hasAddtWaterDetected?: boolean,
    hasAddtWaterMeasured?: boolean,
    hasWashoutWaterMeasured?: boolean,
    hasAddtWaterPerM3?: boolean,
    hasMidPourWaterAdded?: boolean,
    hasPrePourWaterAdded?: boolean,
    hasUnclassifiedWaterAdded?: boolean,
    hasWaterAddedAtPlant?: boolean,
    hasMedia?: boolean,
    hasComments?: boolean,
    hasTests?: boolean,
    hasExcessWaterAddedDuringBatching?: boolean,
    cursor?: number,
    sortField?: DeliverySortField,
    sortDir?: SortDirection,
    jobId?: string,
    selectedFields?: Array<orderSvcDownloadDeliveriesSelectedFields>,
    timeZoneOption?: string
  ): Promise<OrderSvcDownloadDeliveriesForRmcQuery> {
    const statement = `query OrderSvcDownloadDeliveriesForRmc($rmcId: String!, $startDatetime: String, $productDescription: String, $productCode: String, $aggregateSize: String, $deliveryQuantity: Float, $consistenceTarget: Int, $consistenceClass: String, $endDatetime: String, $orderId: String, $customerIds: [String!], $siteDescription: String, $docketId: String, $batchPlant: String, $truckRegistration: String, $extTruckName: String, $siteCodes: [String!], $customerName: String, $plantCodes: [String!], $tags: [String!], $docketId1: String, $hasAddtWaterDetected: Boolean, $hasAddtWaterMeasured: Boolean, $hasWashoutWaterMeasured: Boolean, $hasAddtWaterPerM3: Boolean, $hasMidPourWaterAdded: Boolean, $hasPrePourWaterAdded: Boolean, $hasUnclassifiedWaterAdded: Boolean, $hasWaterAddedAtPlant: Boolean, $hasMedia: Boolean, $hasComments: Boolean, $hasTests: Boolean, $hasExcessWaterAddedDuringBatching: Boolean, $take: Int!, $cursor: Int, $sortField: DeliverySortField, $sortDir: SortDirection, $jobId: String, $selectedFields: [orderSvcDownloadDeliveriesSelectedFields!], $url: String!, $timeZoneOption: String) {
        orderSvcDownloadDeliveriesForRmc(
          rmcId: $rmcId
          startDatetime: $startDatetime
          productDescription: $productDescription
          productCode: $productCode
          aggregateSize: $aggregateSize
          deliveryQuantity: $deliveryQuantity
          consistenceTarget: $consistenceTarget
          consistenceClass: $consistenceClass
          endDatetime: $endDatetime
          orderId: $orderId
          customerIds: $customerIds
          siteDescription: $siteDescription
          docketId: $docketId
          batchPlant: $batchPlant
          truckRegistration: $truckRegistration
          extTruckName: $extTruckName
          siteCodes: $siteCodes
          customerName: $customerName
          plantCodes: $plantCodes
          tags: $tags
          docketId1: $docketId1
          hasAddtWaterDetected: $hasAddtWaterDetected
          hasAddtWaterMeasured: $hasAddtWaterMeasured
          hasWashoutWaterMeasured: $hasWashoutWaterMeasured
          hasAddtWaterPerM3: $hasAddtWaterPerM3
          hasMidPourWaterAdded: $hasMidPourWaterAdded
          hasPrePourWaterAdded: $hasPrePourWaterAdded
          hasUnclassifiedWaterAdded: $hasUnclassifiedWaterAdded
          hasWaterAddedAtPlant: $hasWaterAddedAtPlant
          hasMedia: $hasMedia
          hasComments: $hasComments
          hasTests: $hasTests
          hasExcessWaterAddedDuringBatching: $hasExcessWaterAddedDuringBatching
          take: $take
          cursor: $cursor
          sortField: $sortField
          sortDir: $sortDir
          jobId: $jobId
          selectedFields: $selectedFields
          url: $url
          timeZoneOption: $timeZoneOption
        ) {
          __typename
          jobId
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      take,
      url
    };
    if (startDatetime) {
      gqlAPIServiceArguments.startDatetime = startDatetime;
    }
    if (productDescription) {
      gqlAPIServiceArguments.productDescription = productDescription;
    }
    if (productCode) {
      gqlAPIServiceArguments.productCode = productCode;
    }
    if (aggregateSize) {
      gqlAPIServiceArguments.aggregateSize = aggregateSize;
    }
    if (deliveryQuantity) {
      gqlAPIServiceArguments.deliveryQuantity = deliveryQuantity;
    }
    if (consistenceTarget) {
      gqlAPIServiceArguments.consistenceTarget = consistenceTarget;
    }
    if (consistenceClass) {
      gqlAPIServiceArguments.consistenceClass = consistenceClass;
    }
    if (endDatetime) {
      gqlAPIServiceArguments.endDatetime = endDatetime;
    }
    if (orderId) {
      gqlAPIServiceArguments.orderId = orderId;
    }
    if (customerIds) {
      gqlAPIServiceArguments.customerIds = customerIds;
    }
    if (siteDescription) {
      gqlAPIServiceArguments.siteDescription = siteDescription;
    }
    if (docketId) {
      gqlAPIServiceArguments.docketId = docketId;
    }
    if (batchPlant) {
      gqlAPIServiceArguments.batchPlant = batchPlant;
    }
    if (truckRegistration) {
      gqlAPIServiceArguments.truckRegistration = truckRegistration;
    }
    if (extTruckName) {
      gqlAPIServiceArguments.extTruckName = extTruckName;
    }
    if (siteCodes) {
      gqlAPIServiceArguments.siteCodes = siteCodes;
    }
    if (customerName) {
      gqlAPIServiceArguments.customerName = customerName;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    if (tags) {
      gqlAPIServiceArguments.tags = tags;
    }
    if (docketId1) {
      gqlAPIServiceArguments.docketId1 = docketId1;
    }
    if (hasAddtWaterDetected) {
      gqlAPIServiceArguments.hasAddtWaterDetected = hasAddtWaterDetected;
    }
    if (hasAddtWaterMeasured) {
      gqlAPIServiceArguments.hasAddtWaterMeasured = hasAddtWaterMeasured;
    }
    if (hasWashoutWaterMeasured) {
      gqlAPIServiceArguments.hasWashoutWaterMeasured = hasWashoutWaterMeasured;
    }
    if (hasAddtWaterPerM3) {
      gqlAPIServiceArguments.hasAddtWaterPerM3 = hasAddtWaterPerM3;
    }
    if (hasMidPourWaterAdded) {
      gqlAPIServiceArguments.hasMidPourWaterAdded = hasMidPourWaterAdded;
    }
    if (hasPrePourWaterAdded) {
      gqlAPIServiceArguments.hasPrePourWaterAdded = hasPrePourWaterAdded;
    }
    if (hasUnclassifiedWaterAdded) {
      gqlAPIServiceArguments.hasUnclassifiedWaterAdded = hasUnclassifiedWaterAdded;
    }
    if (hasWaterAddedAtPlant) {
      gqlAPIServiceArguments.hasWaterAddedAtPlant = hasWaterAddedAtPlant;
    }
    if (hasMedia) {
      gqlAPIServiceArguments.hasMedia = hasMedia;
    }
    if (hasComments) {
      gqlAPIServiceArguments.hasComments = hasComments;
    }
    if (hasTests) {
      gqlAPIServiceArguments.hasTests = hasTests;
    }
    if (hasExcessWaterAddedDuringBatching) {
      gqlAPIServiceArguments.hasExcessWaterAddedDuringBatching = hasExcessWaterAddedDuringBatching;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    if (sortField) {
      gqlAPIServiceArguments.sortField = sortField;
    }
    if (sortDir) {
      gqlAPIServiceArguments.sortDir = sortDir;
    }
    if (jobId) {
      gqlAPIServiceArguments.jobId = jobId;
    }
    if (selectedFields) {
      gqlAPIServiceArguments.selectedFields = selectedFields;
    }
    if (timeZoneOption) {
      gqlAPIServiceArguments.timeZoneOption = timeZoneOption;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcDownloadDeliveriesForRmcQuery>(
      response.data.orderSvcDownloadDeliveriesForRmc
    );
  }
  async OrderSvcGetOrderTrips(
    rmcId: string,
    orderCode: string,
    plantCodes?: Array<string>
  ): Promise<Array<OrderSvcGetOrderTripsQuery>> {
    const statement = `query OrderSvcGetOrderTrips($rmcId: String!, $orderCode: String!, $plantCodes: [String!]) {
        orderSvcGetOrderTrips(
          rmcId: $rmcId
          orderCode: $orderCode
          plantCodes: $plantCodes
        ) {
          __typename
          rmcId
          truckPlate
          extTruckName
          truckImei
          tripStartTime
          tripEndTime
          datetimeBatch
          slumpCode
          orderCode
          docketId
          docketId1
          commercialProductCode
          commercialProductDescription
          technicalProductCode
          technicalProductDescription
          deliveredQuantity
          plantCode
          jobsiteCode
          jobsiteDescription
          pourTime
          pourEvents
          pourLocation
          siteLocation
          plantLocation
          plantName
          loadingPoint
          leftBatchPlant
          arrivedAtSite
          leftSite
          consistenceMmAtLoadMix
          consistenceMmAtLoadMixOk
          consistenceMmQualifierAtLoadMix
          consistenceMmAtPlantExit
          consistenceMmAtPlantExitOk
          consistenceMmQualifierAtPlantExit
          consistenceMmAtSiteArrival
          consistenceMmAtSiteArrivalOk
          consistenceMmQualifierAtSiteArrival
          consistenceMmAtPour
          consistenceMmAtPourOk
          consistenceMmQualifierAtPour
          consistenceClass
          consistenceTarget
          consistenceClassMax
          consistenceClassMin
          consistenceLowerLimitSpot
          consistenceStandard
          consistenceTestType
          consistenceUpperLimitSpot
          customerName
          rheometryPlasticViscosityPasAtPlantExit
          rheometryPlasticViscosityPasAtSiteArrival
          rheometryPlasticViscosityPasAtPour
          rheometryPlasticViscosityPasPredictionType
          rheometryYieldStressPaAtPlantExit
          rheometryYieldStressPaAtSiteArrival
          rheometryYieldStressPaAtPour
          rheometryYieldStressPaPredictionType
          rheometryStaticYieldStressTargetMinPa
          rheometryStaticYieldStressTargetMaxPa
          rheometryPlasticViscosityTargetMinPas
          rheometryPlasticViscosityTargetMaxPas
          waterAdditions
          additionalWaterMeasured
          additionalWaterDetected
          washoutWaterMeasured
          additionalWaterPerM3
          midPourWaterAdded
          prePourWaterAdded
          unclassifiedWaterAdded
          waterAddedAtPlant
          timezone
          tempAtLoadMix
          tempAtSiteArrival
          tempAtPour
          tempAtPlantExit
          consistenceSpeedPattern
          speedPatternAtSite
          consistencePredictionType
          deliveryTags {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          batchToDepartureTimeMinutes
          outboundTransitTimeMinutes
          siteWaitTimeMinutes
          pouringTimeMinutes
          leavingSiteTimeMinutes
          totalSiteTimeMinutes
          inboundTransitTimeMinutes
          totalCycleTimeMinutes
          deliveryManualTests {
            __typename
            id
            docketId
            type
            result
            testResult
            unit
            testTime
            createdBy
            comment
            mediaS3Key
            accepted
            acceptanceReason
            reviewedBy
          }
          allowableWaterToAddLitres
          excessWaterAddedDuringBatchingLitres
          mixDesignCode
          docketTargetWeights {
            __typename
            maxWaterCementRatio
            aggregate {
              __typename
              name
              type
              maxSizeMM
              value
              units
            }
            fillers {
              __typename
              type
              value
              units
            }
            water {
              __typename
              name
              value
              units
            }
            binders {
              __typename
              type
              value
              units
            }
            admixture {
              __typename
              name
              value
              units
              type
            }
            reinforcement {
              __typename
              name
              value
              units
            }
          }
          docketBatchedWeights {
            __typename
            aggregate {
              __typename
              name
              type
              maxSizeMM
              value
              units
            }
            fillers {
              __typename
              type
              value
              units
            }
            water {
              __typename
              name
              value
              units
            }
            binders {
              __typename
              type
              value
              units
            }
            admixture {
              __typename
              name
              value
              units
              type
            }
            reinforcement {
              __typename
              name
              value
              units
            }
          }
          docketTestResults {
            __typename
            type
            value
            units
            datetimeUTC
          }
          spinUpStatus
          spinUpStatusUpdateTime
          mediaCount
          commentCount
          comments
          spinUpStatusBeforeFirstNonSamplePour
          spinUpStatusBeforeLastSamplePour
          emptyDrumStage
          emptyDrumType
          emptyDrumTime
          truckConfig {
            __typename
            physical {
              __typename
              gearboxRatio
              hydraulicMotorDisplacementCc
              drumVolumeM3
              isChargingClockwise
              isPressureId1Charging
              isPressureBInsulated
              pressureSensorLocation
            }
            operations {
              __typename
              isDmTemperatureFault
              isDmFault
              isFmFault
              isCbFault
              isDmFitted
              isFmFitted
              maintenanceStatus
              cbMountingLocation
              cbMountingDirection
            }
            globalConfig {
              __typename
              isWhitelisted
              isOffTheRoad
              isVirtual
              rpmSensor
              misc
              manufacturer
              model
              noConsistence
              noConsistenceDescription
            }
          }
          concreteVolumeM3AtPlantExit
          concreteVolumeM3AtSiteArrival
          concreteVolumeM3AtPour
          concreteVolumeM3AtSiteExit
          airPercentAtPlantExit
          airPercentAtSiteArrival
          airPercentAtPour
          airPercentAtSiteExit
          airPercentAtLoadMix
          weatherTempDegcAtPlant
          weatherCodeAtPlant
          weatherTempDegcAtSiteArrival
          weatherCodeAtSiteArrival
          deviceHealthStatus
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      orderCode
    };
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <Array<OrderSvcGetOrderTripsQuery>>(
      response.data.orderSvcGetOrderTrips
    );
  }
  async OrderSvcGetTruckTrips(
    registration?: string,
    startDatetime?: string,
    endDatetime?: string,
    plantCodes?: Array<string>
  ): Promise<Array<OrderSvcGetTruckTripsQuery>> {
    const statement = `query OrderSvcGetTruckTrips($registration: String, $startDatetime: String, $endDatetime: String, $plantCodes: [String!]) {
        orderSvcGetTruckTrips(
          registration: $registration
          startDatetime: $startDatetime
          endDatetime: $endDatetime
          plantCodes: $plantCodes
        ) {
          __typename
          rmcId
          truckPlate
          extTruckName
          truckImei
          tripStartTime
          tripEndTime
          datetimeBatch
          slumpCode
          orderCode
          docketId
          docketId1
          commercialProductCode
          commercialProductDescription
          technicalProductCode
          technicalProductDescription
          deliveredQuantity
          plantCode
          jobsiteCode
          jobsiteDescription
          pourTime
          pourEvents
          pourLocation
          siteLocation
          plantLocation
          plantName
          loadingPoint
          leftBatchPlant
          arrivedAtSite
          leftSite
          consistenceMmAtLoadMix
          consistenceMmAtLoadMixOk
          consistenceMmQualifierAtLoadMix
          consistenceMmAtPlantExit
          consistenceMmAtPlantExitOk
          consistenceMmQualifierAtPlantExit
          consistenceMmAtSiteArrival
          consistenceMmAtSiteArrivalOk
          consistenceMmQualifierAtSiteArrival
          consistenceMmAtPour
          consistenceMmAtPourOk
          consistenceMmQualifierAtPour
          consistenceClass
          consistenceTarget
          consistenceClassMax
          consistenceClassMin
          consistenceLowerLimitSpot
          consistenceStandard
          consistenceTestType
          consistenceUpperLimitSpot
          customerName
          rheometryPlasticViscosityPasAtPlantExit
          rheometryPlasticViscosityPasAtSiteArrival
          rheometryPlasticViscosityPasAtPour
          rheometryPlasticViscosityPasPredictionType
          rheometryYieldStressPaAtPlantExit
          rheometryYieldStressPaAtSiteArrival
          rheometryYieldStressPaAtPour
          rheometryYieldStressPaPredictionType
          rheometryStaticYieldStressTargetMinPa
          rheometryStaticYieldStressTargetMaxPa
          rheometryPlasticViscosityTargetMinPas
          rheometryPlasticViscosityTargetMaxPas
          waterAdditions
          additionalWaterMeasured
          additionalWaterDetected
          washoutWaterMeasured
          additionalWaterPerM3
          midPourWaterAdded
          prePourWaterAdded
          unclassifiedWaterAdded
          waterAddedAtPlant
          timezone
          tempAtLoadMix
          tempAtSiteArrival
          tempAtPour
          tempAtPlantExit
          consistenceSpeedPattern
          speedPatternAtSite
          consistencePredictionType
          deliveryTags {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          batchToDepartureTimeMinutes
          outboundTransitTimeMinutes
          siteWaitTimeMinutes
          pouringTimeMinutes
          leavingSiteTimeMinutes
          totalSiteTimeMinutes
          inboundTransitTimeMinutes
          totalCycleTimeMinutes
          deliveryManualTests {
            __typename
            id
            docketId
            type
            result
            testResult
            unit
            testTime
            createdBy
            comment
            mediaS3Key
            accepted
            acceptanceReason
            reviewedBy
          }
          allowableWaterToAddLitres
          excessWaterAddedDuringBatchingLitres
          mixDesignCode
          docketTargetWeights {
            __typename
            maxWaterCementRatio
            aggregate {
              __typename
              name
              type
              maxSizeMM
              value
              units
            }
            fillers {
              __typename
              type
              value
              units
            }
            water {
              __typename
              name
              value
              units
            }
            binders {
              __typename
              type
              value
              units
            }
            admixture {
              __typename
              name
              value
              units
              type
            }
            reinforcement {
              __typename
              name
              value
              units
            }
          }
          docketBatchedWeights {
            __typename
            aggregate {
              __typename
              name
              type
              maxSizeMM
              value
              units
            }
            fillers {
              __typename
              type
              value
              units
            }
            water {
              __typename
              name
              value
              units
            }
            binders {
              __typename
              type
              value
              units
            }
            admixture {
              __typename
              name
              value
              units
              type
            }
            reinforcement {
              __typename
              name
              value
              units
            }
          }
          docketTestResults {
            __typename
            type
            value
            units
            datetimeUTC
          }
          spinUpStatus
          spinUpStatusUpdateTime
          mediaCount
          commentCount
          comments
          spinUpStatusBeforeFirstNonSamplePour
          spinUpStatusBeforeLastSamplePour
          emptyDrumStage
          emptyDrumType
          emptyDrumTime
          truckConfig {
            __typename
            physical {
              __typename
              gearboxRatio
              hydraulicMotorDisplacementCc
              drumVolumeM3
              isChargingClockwise
              isPressureId1Charging
              isPressureBInsulated
              pressureSensorLocation
            }
            operations {
              __typename
              isDmTemperatureFault
              isDmFault
              isFmFault
              isCbFault
              isDmFitted
              isFmFitted
              maintenanceStatus
              cbMountingLocation
              cbMountingDirection
            }
            globalConfig {
              __typename
              isWhitelisted
              isOffTheRoad
              isVirtual
              rpmSensor
              misc
              manufacturer
              model
              noConsistence
              noConsistenceDescription
            }
          }
          concreteVolumeM3AtPlantExit
          concreteVolumeM3AtSiteArrival
          concreteVolumeM3AtPour
          concreteVolumeM3AtSiteExit
          airPercentAtPlantExit
          airPercentAtSiteArrival
          airPercentAtPour
          airPercentAtSiteExit
          airPercentAtLoadMix
          weatherTempDegcAtPlant
          weatherCodeAtPlant
          weatherTempDegcAtSiteArrival
          weatherCodeAtSiteArrival
          deviceHealthStatus
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (registration) {
      gqlAPIServiceArguments.registration = registration;
    }
    if (startDatetime) {
      gqlAPIServiceArguments.startDatetime = startDatetime;
    }
    if (endDatetime) {
      gqlAPIServiceArguments.endDatetime = endDatetime;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <Array<OrderSvcGetTruckTripsQuery>>(
      response.data.orderSvcGetTruckTrips
    );
  }
  async OrderSvcGetOrderDelivery(
    rmcId: string,
    docketId: string,
    plantCodes?: Array<string>
  ): Promise<OrderSvcGetOrderDeliveryQuery> {
    const statement = `query OrderSvcGetOrderDelivery($rmcId: String!, $docketId: String!, $plantCodes: [String!]) {
        orderSvcGetOrderDelivery(
          rmcId: $rmcId
          docketId: $docketId
          plantCodes: $plantCodes
        ) {
          __typename
          rmcId
          truckPlate
          extTruckName
          truckImei
          tripStartTime
          tripEndTime
          datetimeBatch
          slumpCode
          orderCode
          docketId
          docketId1
          commercialProductCode
          commercialProductDescription
          technicalProductCode
          technicalProductDescription
          deliveredQuantity
          plantCode
          jobsiteCode
          jobsiteDescription
          pourTime
          pourEvents
          pourLocation
          siteLocation
          plantLocation
          plantName
          loadingPoint
          leftBatchPlant
          arrivedAtSite
          leftSite
          consistenceMmAtLoadMix
          consistenceMmAtLoadMixOk
          consistenceMmQualifierAtLoadMix
          consistenceMmAtPlantExit
          consistenceMmAtPlantExitOk
          consistenceMmQualifierAtPlantExit
          consistenceMmAtSiteArrival
          consistenceMmAtSiteArrivalOk
          consistenceMmQualifierAtSiteArrival
          consistenceMmAtPour
          consistenceMmAtPourOk
          consistenceMmQualifierAtPour
          consistenceClass
          consistenceTarget
          consistenceClassMax
          consistenceClassMin
          consistenceLowerLimitSpot
          consistenceStandard
          consistenceTestType
          consistenceUpperLimitSpot
          customerName
          rheometryPlasticViscosityPasAtPlantExit
          rheometryPlasticViscosityPasAtSiteArrival
          rheometryPlasticViscosityPasAtPour
          rheometryPlasticViscosityPasPredictionType
          rheometryYieldStressPaAtPlantExit
          rheometryYieldStressPaAtSiteArrival
          rheometryYieldStressPaAtPour
          rheometryYieldStressPaPredictionType
          rheometryStaticYieldStressTargetMinPa
          rheometryStaticYieldStressTargetMaxPa
          rheometryPlasticViscosityTargetMinPas
          rheometryPlasticViscosityTargetMaxPas
          waterAdditions
          additionalWaterMeasured
          additionalWaterDetected
          washoutWaterMeasured
          additionalWaterPerM3
          midPourWaterAdded
          prePourWaterAdded
          unclassifiedWaterAdded
          waterAddedAtPlant
          timezone
          tempAtLoadMix
          tempAtSiteArrival
          tempAtPour
          tempAtPlantExit
          consistenceSpeedPattern
          speedPatternAtSite
          consistencePredictionType
          deliveryTags {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          batchToDepartureTimeMinutes
          outboundTransitTimeMinutes
          siteWaitTimeMinutes
          pouringTimeMinutes
          leavingSiteTimeMinutes
          totalSiteTimeMinutes
          inboundTransitTimeMinutes
          totalCycleTimeMinutes
          deliveryManualTests {
            __typename
            id
            docketId
            type
            result
            testResult
            unit
            testTime
            createdBy
            comment
            mediaS3Key
            accepted
            acceptanceReason
            reviewedBy
          }
          allowableWaterToAddLitres
          excessWaterAddedDuringBatchingLitres
          mixDesignCode
          docketTargetWeights {
            __typename
            maxWaterCementRatio
            aggregate {
              __typename
              name
              type
              maxSizeMM
              value
              units
            }
            fillers {
              __typename
              type
              value
              units
            }
            water {
              __typename
              name
              value
              units
            }
            binders {
              __typename
              type
              value
              units
            }
            admixture {
              __typename
              name
              value
              units
              type
            }
            reinforcement {
              __typename
              name
              value
              units
            }
          }
          docketBatchedWeights {
            __typename
            aggregate {
              __typename
              name
              type
              maxSizeMM
              value
              units
            }
            fillers {
              __typename
              type
              value
              units
            }
            water {
              __typename
              name
              value
              units
            }
            binders {
              __typename
              type
              value
              units
            }
            admixture {
              __typename
              name
              value
              units
              type
            }
            reinforcement {
              __typename
              name
              value
              units
            }
          }
          docketTestResults {
            __typename
            type
            value
            units
            datetimeUTC
          }
          spinUpStatus
          spinUpStatusUpdateTime
          mediaCount
          commentCount
          comments
          spinUpStatusBeforeFirstNonSamplePour
          spinUpStatusBeforeLastSamplePour
          emptyDrumStage
          emptyDrumType
          emptyDrumTime
          truckConfig {
            __typename
            physical {
              __typename
              gearboxRatio
              hydraulicMotorDisplacementCc
              drumVolumeM3
              isChargingClockwise
              isPressureId1Charging
              isPressureBInsulated
              pressureSensorLocation
            }
            operations {
              __typename
              isDmTemperatureFault
              isDmFault
              isFmFault
              isCbFault
              isDmFitted
              isFmFitted
              maintenanceStatus
              cbMountingLocation
              cbMountingDirection
            }
            globalConfig {
              __typename
              isWhitelisted
              isOffTheRoad
              isVirtual
              rpmSensor
              misc
              manufacturer
              model
              noConsistence
              noConsistenceDescription
            }
          }
          concreteVolumeM3AtPlantExit
          concreteVolumeM3AtSiteArrival
          concreteVolumeM3AtPour
          concreteVolumeM3AtSiteExit
          airPercentAtPlantExit
          airPercentAtSiteArrival
          airPercentAtPour
          airPercentAtSiteExit
          airPercentAtLoadMix
          weatherTempDegcAtPlant
          weatherCodeAtPlant
          weatherTempDegcAtSiteArrival
          weatherCodeAtSiteArrival
          deviceHealthStatus
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      docketId
    };
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetOrderDeliveryQuery>(
      response.data.orderSvcGetOrderDelivery
    );
  }
  async OrderSvcGetOrderDeliveryTimeseries(
    rmcId: string,
    docketId: string,
    customerId?: string,
    plantCodes?: Array<string>
  ): Promise<OrderSvcGetOrderDeliveryTimeseriesQuery> {
    const statement = `query OrderSvcGetOrderDeliveryTimeseries($rmcId: String!, $docketId: String!, $customerId: String, $plantCodes: [String!]) {
        orderSvcGetOrderDeliveryTimeseries(
          rmcId: $rmcId
          docketId: $docketId
          customerId: $customerId
          plantCodes: $plantCodes
        ) {
          __typename
          timeseries {
            __typename
            timestamp
            geo
            rpm
            pressure
            pressureABarMean
            pressureBBarMean
            temp
            consistenceMm
            consistenceMmQualifier
            consistenceMinMm
            consistenceMaxMm
            rheometryPlasticViscosityPas
            rheometryStaticYieldStressPa
            gpsLongitudes
            gpsLatitudes
            percentAir
            concreteVolume
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      docketId
    };
    if (customerId) {
      gqlAPIServiceArguments.customerId = customerId;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetOrderDeliveryTimeseriesQuery>(
      response.data.orderSvcGetOrderDeliveryTimeseries
    );
  }
  async OrderSvcGetDocket(
    rmcId: string,
    docketId?: string,
    customerId?: string,
    plantCodes?: Array<string>
  ): Promise<OrderSvcGetDocketQuery> {
    const statement = `query OrderSvcGetDocket($rmcId: String!, $docketId: String, $customerId: String, $plantCodes: [String!]) {
        orderSvcGetDocket(
          rmcId: $rmcId
          docketId: $docketId
          customerId: $customerId
          plantCodes: $plantCodes
        ) {
          __typename
          id
          rmcId
          status
          docketId
          docketId1
          orderCode
          slumpCode
          slumpDescription
          truckPlate
          extTruckName
          truckId
          truckImei
          truckReg
          jobsiteCode
          jobsiteDescription
          jobsiteLongitude
          jobsiteLatitude
          plantCode
          plantLongitude
          plantLatitude
          rmcCustomerId
          rmcCustomerName
          datetimeBatchLocal
          datetimeBatch
          aggregateSizeCode
          aggregateSizeDescription
          deliveredQuantity
          technicalProductCode
          technicalProductDescription
          commercialProductCode
          commercialProductDescription
          unitDescription
          unitCode
          consistenceClass
          consistenceTarget
          consistenceClassMax
          consistenceClassMin
          consistenceStandard
          consistenceTestType
          consistenceLowerLimitSpot
          consistenceUpperLimitSpot
          allowableWaterToAddLitres
          excessWaterAddedDuringBatchingLitres
          mixDesignCode
          targetWeights {
            __typename
            maxWaterCementRatio
            aggregate {
              __typename
              name
              type
              maxSizeMM
              value
              units
            }
            fillers {
              __typename
              type
              value
              units
            }
            water {
              __typename
              name
              value
              units
            }
            binders {
              __typename
              type
              value
              units
            }
            admixture {
              __typename
              name
              value
              units
              type
            }
            reinforcement {
              __typename
              name
              value
              units
            }
          }
          batchedWeights {
            __typename
            aggregate {
              __typename
              name
              type
              maxSizeMM
              value
              units
            }
            fillers {
              __typename
              type
              value
              units
            }
            water {
              __typename
              name
              value
              units
            }
            binders {
              __typename
              type
              value
              units
            }
            admixture {
              __typename
              name
              value
              units
              type
            }
            reinforcement {
              __typename
              name
              value
              units
            }
          }
          testResults {
            __typename
            type
            value
            units
            datetimeUTC
          }
          truckConfig {
            __typename
            physical {
              __typename
              gearboxRatio
              hydraulicMotorDisplacementCc
              drumVolumeM3
              isChargingClockwise
              isPressureId1Charging
              isPressureBInsulated
              pressureSensorLocation
            }
            operations {
              __typename
              isDmTemperatureFault
              isDmFault
              isFmFault
              isCbFault
              isDmFitted
              isFmFitted
              maintenanceStatus
              cbMountingLocation
              cbMountingDirection
            }
            globalConfig {
              __typename
              isWhitelisted
              isOffTheRoad
              isVirtual
              rpmSensor
              misc
              manufacturer
              model
              noConsistence
              noConsistenceDescription
            }
          }
          timezone
          weatherTempDegcAtPlant
          weatherCodeAtPlant
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId
    };
    if (docketId) {
      gqlAPIServiceArguments.docketId = docketId;
    }
    if (customerId) {
      gqlAPIServiceArguments.customerId = customerId;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetDocketQuery>response.data.orderSvcGetDocket;
  }
  async OrderSvcGetJobsitePourLocations(
    rmcId: string,
    jobsiteCode: string,
    startDatetime?: string,
    endDatetime?: string,
    plantCodes?: Array<string>
  ): Promise<Array<OrderSvcGetJobsitePourLocationsQuery>> {
    const statement = `query OrderSvcGetJobsitePourLocations($rmcId: String!, $jobsiteCode: String!, $startDatetime: String, $endDatetime: String, $plantCodes: [String!]) {
        orderSvcGetJobsitePourLocations(
          rmcId: $rmcId
          jobsiteCode: $jobsiteCode
          startDatetime: $startDatetime
          endDatetime: $endDatetime
          plantCodes: $plantCodes
        ) {
          __typename
          docketId
          pourLocation
          pourTime
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      jobsiteCode
    };
    if (startDatetime) {
      gqlAPIServiceArguments.startDatetime = startDatetime;
    }
    if (endDatetime) {
      gqlAPIServiceArguments.endDatetime = endDatetime;
    }
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <Array<OrderSvcGetJobsitePourLocationsQuery>>(
      response.data.orderSvcGetJobsitePourLocations
    );
  }
  async OrderSvcGetDeliveryHealth(
    docketId: string,
    plantCodes?: Array<string>
  ): Promise<Array<OrderSvcGetDeliveryHealthQuery>> {
    const statement = `query OrderSvcGetDeliveryHealth($docketId: String!, $plantCodes: [String!]) {
        orderSvcGetDeliveryHealth(docketId: $docketId, plantCodes: $plantCodes) {
          __typename
          checks
        }
      }`;
    const gqlAPIServiceArguments: any = {
      docketId
    };
    if (plantCodes) {
      gqlAPIServiceArguments.plantCodes = plantCodes;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <Array<OrderSvcGetDeliveryHealthQuery>>(
      response.data.orderSvcGetDeliveryHealth
    );
  }
  async OrderSvcSearchTags(
    rmcId: string,
    query: string,
    limit?: number,
    nextToken?: string
  ): Promise<OrderSvcSearchTagsQuery> {
    const statement = `query OrderSvcSearchTags($rmcId: String!, $query: String!, $limit: Int, $nextToken: String) {
        orderSvcSearchTags(
          rmcId: $rmcId
          query: $query
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          tags {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      query
    };
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcSearchTagsQuery>response.data.orderSvcSearchTags;
  }
  async OrderSvcGetTagsByRmc(
    rmcId: string,
    limit?: number,
    nextToken?: string
  ): Promise<OrderSvcGetTagsByRmcQuery> {
    const statement = `query OrderSvcGetTagsByRmc($rmcId: String!, $limit: Int, $nextToken: String) {
        orderSvcGetTagsByRmc(rmcId: $rmcId, limit: $limit, nextToken: $nextToken) {
          __typename
          tags {
            __typename
            id
            rmcId
            name
            usageCount
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId
    };
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetTagsByRmcQuery>response.data.orderSvcGetTagsByRmc;
  }
  async OrderSvcGetJobsitesForRmc(
    rmcId: string,
    jobsiteCode?: string,
    jobsiteDescription?: string,
    plantCode?: string,
    take?: number,
    cursor?: string
  ): Promise<OrderSvcGetJobsitesForRmcQuery> {
    const statement = `query OrderSvcGetJobsitesForRmc($rmcId: String!, $jobsiteCode: String, $jobsiteDescription: String, $plantCode: String, $take: Int, $cursor: String) {
        orderSvcGetJobsitesForRmc(
          rmcId: $rmcId
          jobsiteCode: $jobsiteCode
          jobsiteDescription: $jobsiteDescription
          plantCode: $plantCode
          take: $take
          cursor: $cursor
        ) {
          __typename
          jobsites {
            __typename
            jobsiteCode
            jobsiteDescription
          }
          cursor
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId
    };
    if (jobsiteCode) {
      gqlAPIServiceArguments.jobsiteCode = jobsiteCode;
    }
    if (jobsiteDescription) {
      gqlAPIServiceArguments.jobsiteDescription = jobsiteDescription;
    }
    if (plantCode) {
      gqlAPIServiceArguments.plantCode = plantCode;
    }
    if (take) {
      gqlAPIServiceArguments.take = take;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetJobsitesForRmcQuery>(
      response.data.orderSvcGetJobsitesForRmc
    );
  }
  async OrderSvcGetCustomersForRmc(
    rmcId: string,
    customerName?: string,
    customerIds?: Array<string>,
    take?: number,
    cursor?: string
  ): Promise<OrderSvcGetCustomersForRmcQuery> {
    const statement = `query OrderSvcGetCustomersForRmc($rmcId: String!, $customerName: String, $customerIds: [String!], $take: Int, $cursor: String) {
        orderSvcGetCustomersForRmc(
          rmcId: $rmcId
          customerName: $customerName
          customerIds: $customerIds
          take: $take
          cursor: $cursor
        ) {
          __typename
          customers {
            __typename
            customerId
            customerName
          }
          cursor
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId
    };
    if (customerName) {
      gqlAPIServiceArguments.customerName = customerName;
    }
    if (customerIds) {
      gqlAPIServiceArguments.customerIds = customerIds;
    }
    if (take) {
      gqlAPIServiceArguments.take = take;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetCustomersForRmcQuery>(
      response.data.orderSvcGetCustomersForRmc
    );
  }
  async OrderSvcGetManualTestMediaFileLink(
    rmcId: string,
    testId: number
  ): Promise<OrderSvcGetManualTestMediaFileLinkQuery> {
    const statement = `query OrderSvcGetManualTestMediaFileLink($rmcId: String!, $testId: Int!) {
        orderSvcGetManualTestMediaFileLink(rmcId: $rmcId, testId: $testId) {
          __typename
          mediaFileLink
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      testId
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetManualTestMediaFileLinkQuery>(
      response.data.orderSvcGetManualTestMediaFileLink
    );
  }
  async OrderSvcListPendingManualTests(
    rmcId: string,
    take?: number,
    cursor?: string
  ): Promise<OrderSvcListPendingManualTestsQuery> {
    const statement = `query OrderSvcListPendingManualTests($rmcId: String!, $take: Int, $cursor: String) {
        orderSvcListPendingManualTests(rmcId: $rmcId, take: $take, cursor: $cursor) {
          __typename
          manualTests {
            __typename
            id
            docketId
            type
            result
            testResult
            unit
            testTime
            createdBy
            comment
            mediaS3Key
            accepted
            acceptanceReason
            reviewedBy
          }
          cursor
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId
    };
    if (take) {
      gqlAPIServiceArguments.take = take;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcListPendingManualTestsQuery>(
      response.data.orderSvcListPendingManualTests
    );
  }
  async OrderSvcSearchOrderSvcTrip(
    rmcId: string,
    queryFilter: string,
    queryId?: number,
    sortField?: DeliverySortField,
    sortDir?: SortDirection,
    take?: number,
    cursor?: number
  ): Promise<OrderSvcSearchOrderSvcTripQuery> {
    const statement = `query OrderSvcSearchOrderSvcTrip($rmcId: String!, $queryFilter: AWSJSON!, $queryId: Int, $sortField: DeliverySortField, $sortDir: SortDirection, $take: Int, $cursor: Int) {
        orderSvcSearchOrderSvcTrip(
          rmcId: $rmcId
          queryFilter: $queryFilter
          queryId: $queryId
          sortField: $sortField
          sortDir: $sortDir
          take: $take
          cursor: $cursor
        ) {
          __typename
          deliveries {
            __typename
            rmcId
            truckPlate
            extTruckName
            truckImei
            tripStartTime
            tripEndTime
            datetimeBatch
            slumpCode
            orderCode
            docketId
            docketId1
            commercialProductCode
            commercialProductDescription
            technicalProductCode
            technicalProductDescription
            deliveredQuantity
            plantCode
            jobsiteCode
            jobsiteDescription
            pourTime
            pourEvents
            pourLocation
            siteLocation
            plantLocation
            plantName
            loadingPoint
            leftBatchPlant
            arrivedAtSite
            leftSite
            consistenceMmAtLoadMix
            consistenceMmAtLoadMixOk
            consistenceMmQualifierAtLoadMix
            consistenceMmAtPlantExit
            consistenceMmAtPlantExitOk
            consistenceMmQualifierAtPlantExit
            consistenceMmAtSiteArrival
            consistenceMmAtSiteArrivalOk
            consistenceMmQualifierAtSiteArrival
            consistenceMmAtPour
            consistenceMmAtPourOk
            consistenceMmQualifierAtPour
            consistenceClass
            consistenceTarget
            consistenceClassMax
            consistenceClassMin
            consistenceLowerLimitSpot
            consistenceStandard
            consistenceTestType
            consistenceUpperLimitSpot
            customerName
            rheometryPlasticViscosityPasAtPlantExit
            rheometryPlasticViscosityPasAtSiteArrival
            rheometryPlasticViscosityPasAtPour
            rheometryPlasticViscosityPasPredictionType
            rheometryYieldStressPaAtPlantExit
            rheometryYieldStressPaAtSiteArrival
            rheometryYieldStressPaAtPour
            rheometryYieldStressPaPredictionType
            rheometryStaticYieldStressTargetMinPa
            rheometryStaticYieldStressTargetMaxPa
            rheometryPlasticViscosityTargetMinPas
            rheometryPlasticViscosityTargetMaxPas
            waterAdditions
            additionalWaterMeasured
            additionalWaterDetected
            washoutWaterMeasured
            additionalWaterPerM3
            midPourWaterAdded
            prePourWaterAdded
            unclassifiedWaterAdded
            waterAddedAtPlant
            timezone
            tempAtLoadMix
            tempAtSiteArrival
            tempAtPour
            tempAtPlantExit
            consistenceSpeedPattern
            speedPatternAtSite
            consistencePredictionType
            deliveryTags {
              __typename
              id
              rmcId
              name
              usageCount
              createdAt
              updatedAt
            }
            batchToDepartureTimeMinutes
            outboundTransitTimeMinutes
            siteWaitTimeMinutes
            pouringTimeMinutes
            leavingSiteTimeMinutes
            totalSiteTimeMinutes
            inboundTransitTimeMinutes
            totalCycleTimeMinutes
            deliveryManualTests {
              __typename
              id
              docketId
              type
              result
              testResult
              unit
              testTime
              createdBy
              comment
              mediaS3Key
              accepted
              acceptanceReason
              reviewedBy
            }
            allowableWaterToAddLitres
            excessWaterAddedDuringBatchingLitres
            mixDesignCode
            docketTargetWeights {
              __typename
              maxWaterCementRatio
              aggregate {
                __typename
                name
                type
                maxSizeMM
                value
                units
              }
              fillers {
                __typename
                type
                value
                units
              }
              water {
                __typename
                name
                value
                units
              }
              binders {
                __typename
                type
                value
                units
              }
              admixture {
                __typename
                name
                value
                units
                type
              }
              reinforcement {
                __typename
                name
                value
                units
              }
            }
            docketBatchedWeights {
              __typename
              aggregate {
                __typename
                name
                type
                maxSizeMM
                value
                units
              }
              fillers {
                __typename
                type
                value
                units
              }
              water {
                __typename
                name
                value
                units
              }
              binders {
                __typename
                type
                value
                units
              }
              admixture {
                __typename
                name
                value
                units
                type
              }
              reinforcement {
                __typename
                name
                value
                units
              }
            }
            docketTestResults {
              __typename
              type
              value
              units
              datetimeUTC
            }
            spinUpStatus
            spinUpStatusUpdateTime
            mediaCount
            commentCount
            comments
            spinUpStatusBeforeFirstNonSamplePour
            spinUpStatusBeforeLastSamplePour
            emptyDrumStage
            emptyDrumType
            emptyDrumTime
            truckConfig {
              __typename
              physical {
                __typename
                gearboxRatio
                hydraulicMotorDisplacementCc
                drumVolumeM3
                isChargingClockwise
                isPressureId1Charging
                isPressureBInsulated
                pressureSensorLocation
              }
              operations {
                __typename
                isDmTemperatureFault
                isDmFault
                isFmFault
                isCbFault
                isDmFitted
                isFmFitted
                maintenanceStatus
                cbMountingLocation
                cbMountingDirection
              }
              globalConfig {
                __typename
                isWhitelisted
                isOffTheRoad
                isVirtual
                rpmSensor
                misc
                manufacturer
                model
                noConsistence
                noConsistenceDescription
              }
            }
            concreteVolumeM3AtPlantExit
            concreteVolumeM3AtSiteArrival
            concreteVolumeM3AtPour
            concreteVolumeM3AtSiteExit
            airPercentAtPlantExit
            airPercentAtSiteArrival
            airPercentAtPour
            airPercentAtSiteExit
            airPercentAtLoadMix
            weatherTempDegcAtPlant
            weatherCodeAtPlant
            weatherTempDegcAtSiteArrival
            weatherCodeAtSiteArrival
            deviceHealthStatus
          }
          cursor
          errors
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      queryFilter
    };
    if (queryId) {
      gqlAPIServiceArguments.queryId = queryId;
    }
    if (sortField) {
      gqlAPIServiceArguments.sortField = sortField;
    }
    if (sortDir) {
      gqlAPIServiceArguments.sortDir = sortDir;
    }
    if (take) {
      gqlAPIServiceArguments.take = take;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcSearchOrderSvcTripQuery>(
      response.data.orderSvcSearchOrderSvcTrip
    );
  }
  async OrderSvcGetUserQuery(id: number): Promise<OrderSvcGetUserQueryQuery> {
    const statement = `query OrderSvcGetUserQuery($id: Int!) {
        orderSvcGetUserQuery(id: $id) {
          __typename
          id
          name
          type
          description
          usageCount
          queryPayload
          createdBy
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcGetUserQueryQuery>response.data.orderSvcGetUserQuery;
  }
  async OrderSvcListUserQueries(
    take?: number,
    cursor?: string
  ): Promise<OrderSvcListUserQueriesQuery> {
    const statement = `query OrderSvcListUserQueries($take: Int, $cursor: String) {
        orderSvcListUserQueries(take: $take, cursor: $cursor) {
          __typename
          queries {
            __typename
            id
            name
            type
            description
            usageCount
            queryPayload
            createdBy
            createdAt
            updatedAt
          }
          cursor
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (take) {
      gqlAPIServiceArguments.take = take;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcListUserQueriesQuery>response.data.orderSvcListUserQueries;
  }
  async OrderSvcSearchOrderSvcOrder(
    rmcId: string,
    queryFilter: string,
    queryId?: number,
    sortField?: OrderSortField,
    sortDir?: SortDirection,
    take?: number,
    cursor?: string
  ): Promise<OrderSvcSearchOrderSvcOrderQuery> {
    const statement = `query OrderSvcSearchOrderSvcOrder($rmcId: String!, $queryFilter: AWSJSON!, $queryId: Int, $sortField: OrderSortField, $sortDir: SortDirection, $take: Int, $cursor: String) {
        orderSvcSearchOrderSvcOrder(
          rmcId: $rmcId
          queryFilter: $queryFilter
          queryId: $queryId
          sortField: $sortField
          sortDir: $sortDir
          take: $take
          cursor: $cursor
        ) {
          __typename
          orders {
            __typename
            rmcId
            orderCode
            slumpCode
            jobsiteDescription
            jobsiteCode
            commercialProductCode
            commercialProductDescription
            aggregateSize
            deliveryQuantity
            consistenceTarget
            consistenceClass
            rmcCustomerName
            deliveries
            volumeDelivered
            firstBatchingTimestamp
            lastBatchingTimestamp
            timezone
          }
          cursor
          errors
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId,
      queryFilter
    };
    if (queryId) {
      gqlAPIServiceArguments.queryId = queryId;
    }
    if (sortField) {
      gqlAPIServiceArguments.sortField = sortField;
    }
    if (sortDir) {
      gqlAPIServiceArguments.sortDir = sortDir;
    }
    if (take) {
      gqlAPIServiceArguments.take = take;
    }
    if (cursor) {
      gqlAPIServiceArguments.cursor = cursor;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <OrderSvcSearchOrderSvcOrderQuery>(
      response.data.orderSvcSearchOrderSvcOrder
    );
  }
  async UserServiceRequestReportUpload(
    tenant: string,
    fileName: string
  ): Promise<UserServiceRequestReportUploadQuery> {
    const statement = `query UserServiceRequestReportUpload($tenant: String!, $fileName: String!) {
        userServiceRequestReportUpload(tenant: $tenant, fileName: $fileName) {
          __typename
          success
          item
          items
        }
      }`;
    const gqlAPIServiceArguments: any = {
      tenant,
      fileName
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserServiceRequestReportUploadQuery>(
      response.data.userServiceRequestReportUpload
    );
  }
  async UserServiceListReports(
    tenant: string
  ): Promise<UserServiceListReportsQuery> {
    const statement = `query UserServiceListReports($tenant: String!) {
        userServiceListReports(tenant: $tenant) {
          __typename
          success
          item
          items
        }
      }`;
    const gqlAPIServiceArguments: any = {
      tenant
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserServiceListReportsQuery>response.data.userServiceListReports;
  }
  async UserServiceRequestReportFileLink(
    tenant: string,
    uploadKey: string
  ): Promise<UserServiceRequestReportFileLinkQuery> {
    const statement = `query UserServiceRequestReportFileLink($tenant: String!, $uploadKey: String!) {
        userServiceRequestReportFileLink(tenant: $tenant, uploadKey: $uploadKey) {
          __typename
          success
          item
          items
        }
      }`;
    const gqlAPIServiceArguments: any = {
      tenant,
      uploadKey
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserServiceRequestReportFileLinkQuery>(
      response.data.userServiceRequestReportFileLink
    );
  }
  async UserServiceDeleteReport(
    tenant: string,
    uploadKey: string
  ): Promise<UserServiceDeleteReportQuery> {
    const statement = `query UserServiceDeleteReport($tenant: String!, $uploadKey: String!) {
        userServiceDeleteReport(tenant: $tenant, uploadKey: $uploadKey) {
          __typename
          success
          item
          items
        }
      }`;
    const gqlAPIServiceArguments: any = {
      tenant,
      uploadKey
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserServiceDeleteReportQuery>response.data.userServiceDeleteReport;
  }
  async UserSvcListRmcUsers(
    rmcProvider: string,
    search?: string
  ): Promise<UserSvcListRmcUsersQuery> {
    const statement = `query UserSvcListRmcUsers($rmcProvider: String!, $search: String) {
        userSvcListRmcUsers(rmcProvider: $rmcProvider, search: $search) {
          __typename
          items {
            __typename
            username
            email
            phoneNumber
            givenName
            familyName
            jobTitle
            status
            enabled
            groups
            created
            lastModified
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcProvider
    };
    if (search) {
      gqlAPIServiceArguments.search = search;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcListRmcUsersQuery>response.data.userSvcListRmcUsers;
  }
  async UserSvcGetUser(username: string): Promise<UserSvcGetUserQuery> {
    const statement = `query UserSvcGetUser($username: String!) {
        userSvcGetUser(username: $username) {
          __typename
          user {
            __typename
            username
            email
            phoneNumber
            givenName
            familyName
            jobTitle
            status
            enabled
            groups
            created
            lastModified
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      username
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcGetUserQuery>response.data.userSvcGetUser;
  }
  async UserSvcRbacGetUser(subId: string): Promise<UserSvcRbacGetUserQuery> {
    const statement = `query UserSvcRbacGetUser($subId: ID!) {
        userSvcRbacGetUser(subId: $subId) {
          __typename
          subId
          tenant
          firstName
          lastName
          groups {
            __typename
            id
            parentId
            tenant
            name
            description
            roles {
              __typename
              id
              name
              description
              abilities {
                __typename
                id
                action
                subject
                fields
                conditions
                inverted
                description
                readonly
              }
              readonly
            }
          }
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      subId
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacGetUserQuery>response.data.userSvcRbacGetUser;
  }
  async UserSvcRbacListUsers(
    tenant: string,
    limit?: number,
    nextToken?: string
  ): Promise<UserSvcRbacListUsersQuery> {
    const statement = `query UserSvcRbacListUsers($tenant: String!, $limit: Int, $nextToken: String) {
        userSvcRbacListUsers(tenant: $tenant, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            subId
            tenant
            firstName
            lastName
            groups {
              __typename
              id
              parentId
              tenant
              name
              description
              roles {
                __typename
                id
                name
                description
                abilities {
                  __typename
                  id
                  action
                  subject
                  fields
                  conditions
                  inverted
                  description
                  readonly
                }
                readonly
              }
            }
            roles {
              __typename
              id
              name
              description
              abilities {
                __typename
                id
                action
                subject
                fields
                conditions
                inverted
                description
                readonly
              }
              readonly
            }
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      tenant
    };
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacListUsersQuery>response.data.userSvcRbacListUsers;
  }
  async UserSvcRbacGetGroup(id: string): Promise<UserSvcRbacGetGroupQuery> {
    const statement = `query UserSvcRbacGetGroup($id: ID!) {
        userSvcRbacGetGroup(id: $id) {
          __typename
          id
          parentId
          tenant
          name
          description
          roles {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacGetGroupQuery>response.data.userSvcRbacGetGroup;
  }
  async UserSvcRbacListGroups(
    tenant: string,
    limit?: number,
    nextToken?: string
  ): Promise<UserSvcRbacListGroupsQuery> {
    const statement = `query UserSvcRbacListGroups($tenant: String!, $limit: Int, $nextToken: String) {
        userSvcRbacListGroups(tenant: $tenant, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            parentId
            tenant
            name
            description
            roles {
              __typename
              id
              name
              description
              abilities {
                __typename
                id
                action
                subject
                fields
                conditions
                inverted
                description
                readonly
              }
              readonly
            }
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      tenant
    };
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacListGroupsQuery>response.data.userSvcRbacListGroups;
  }
  async UserSvcRbacGetRole(id: string): Promise<UserSvcRbacGetRoleQuery> {
    const statement = `query UserSvcRbacGetRole($id: ID!) {
        userSvcRbacGetRole(id: $id) {
          __typename
          id
          name
          description
          abilities {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacGetRoleQuery>response.data.userSvcRbacGetRole;
  }
  async UserSvcRbacListRoles(
    limit?: number,
    nextToken?: string
  ): Promise<UserSvcRbacListRolesQuery> {
    const statement = `query UserSvcRbacListRoles($limit: Int, $nextToken: String) {
        userSvcRbacListRoles(limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            description
            abilities {
              __typename
              id
              action
              subject
              fields
              conditions
              inverted
              description
              readonly
            }
            readonly
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacListRolesQuery>response.data.userSvcRbacListRoles;
  }
  async UserSvcRbacGetAbility(id: string): Promise<UserSvcRbacGetAbilityQuery> {
    const statement = `query UserSvcRbacGetAbility($id: ID!) {
        userSvcRbacGetAbility(id: $id) {
          __typename
          id
          action
          subject
          fields
          conditions
          inverted
          description
          readonly
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacGetAbilityQuery>response.data.userSvcRbacGetAbility;
  }
  async UserSvcRbacListAbilities(
    roleId?: string,
    limit?: number,
    nextToken?: string
  ): Promise<UserSvcRbacListAbilitiesQuery> {
    const statement = `query UserSvcRbacListAbilities($roleId: ID, $limit: Int, $nextToken: String) {
        userSvcRbacListAbilities(roleId: $roleId, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            action
            subject
            fields
            conditions
            inverted
            description
            readonly
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (roleId) {
      gqlAPIServiceArguments.roleId = roleId;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <UserSvcRbacListAbilitiesQuery>(
      response.data.userSvcRbacListAbilities
    );
  }
  async UserSvcRbacHasRole(subId: string, id: string): Promise<boolean | null> {
    const statement = `query UserSvcRbacHasRole($subId: ID!, $id: ID!) {
        userSvcRbacHasRole(subId: $subId, id: $id)
      }`;
    const gqlAPIServiceArguments: any = {
      subId,
      id
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <boolean | null>response.data.userSvcRbacHasRole;
  }
  async UserSvcRbacHasPermission(
    subId: string,
    action: string,
    subject: string,
    resource?: string
  ): Promise<boolean | null> {
    const statement = `query UserSvcRbacHasPermission($subId: ID!, $action: String!, $subject: String!, $resource: AWSJSON) {
        userSvcRbacHasPermission(
          subId: $subId
          action: $action
          subject: $subject
          resource: $resource
        )
      }`;
    const gqlAPIServiceArguments: any = {
      subId,
      action,
      subject
    };
    if (resource) {
      gqlAPIServiceArguments.resource = resource;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <boolean | null>response.data.userSvcRbacHasPermission;
  }
  async LocationSvcGetHierarchy(
    rmc: string,
    taxonomyId?: string
  ): Promise<Array<LocationSvcGetHierarchyQuery>> {
    const statement = `query LocationSvcGetHierarchy($rmc: String!, $taxonomyId: String) {
        locationSvcGetHierarchy(rmc: $rmc, taxonomyId: $taxonomyId) {
          __typename
          id
          parentId
          rmc
          groupName
          groupType
          groupDescription
          batchPlantIds
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmc
    };
    if (taxonomyId) {
      gqlAPIServiceArguments.taxonomyId = taxonomyId;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <Array<LocationSvcGetHierarchyQuery>>(
      response.data.locationSvcGetHierarchy
    );
  }
  async WeatherSvcGetWeatherData(
    lat: number,
    lon: number,
    datetime: string
  ): Promise<WeatherSvcGetWeatherDataQuery> {
    const statement = `query WeatherSvcGetWeatherData($lat: Float!, $lon: Float!, $datetime: String!) {
        weatherSvcGetWeatherData(lat: $lat, lon: $lon, datetime: $datetime) {
          __typename
          weatherTemp
          weatherCode
          weatherDesc
        }
      }`;
    const gqlAPIServiceArguments: any = {
      lat,
      lon,
      datetime
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <WeatherSvcGetWeatherDataQuery>(
      response.data.weatherSvcGetWeatherData
    );
  }
  async LocationSvcGetLocationsForRMCProvider(
    rmcId: string,
    locationType?: string,
    ownerId?: string,
    lastDeliveryTimestamp?: number,
    name?: string,
    status?: string,
    nextToken?: string
  ): Promise<LocationSvcGetLocationsForRMCProviderQuery> {
    const statement = `query LocationSvcGetLocationsForRMCProvider($rmcId: String!, $locationType: String, $ownerId: String, $lastDeliveryTimestamp: Float, $name: String, $status: String, $nextToken: String) {
        locationSvcGetLocationsForRMCProvider(
          rmcId: $rmcId
          locationType: $locationType
          ownerId: $ownerId
          lastDeliveryTimestamp: $lastDeliveryTimestamp
          name: $name
          status: $status
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            Owner
            OwnerId
            ParentId
            Name
            Type
            Lng
            Lat
            Polygon
            Status
            Timezone
            TimezoneDate
            LoadingPoints
            LastDeliveryTimestamp
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId
    };
    if (locationType) {
      gqlAPIServiceArguments.locationType = locationType;
    }
    if (ownerId) {
      gqlAPIServiceArguments.ownerId = ownerId;
    }
    if (lastDeliveryTimestamp) {
      gqlAPIServiceArguments.lastDeliveryTimestamp = lastDeliveryTimestamp;
    }
    if (name) {
      gqlAPIServiceArguments.name = name;
    }
    if (status) {
      gqlAPIServiceArguments.status = status;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <LocationSvcGetLocationsForRMCProviderQuery>(
      response.data.locationSvcGetLocationsForRMCProvider
    );
  }
  async LocationSvcGetLatestDeliveryLocations(
    rmcId: string,
    locationType?: string,
    name?: string,
    nextToken?: string
  ): Promise<LocationSvcGetLatestDeliveryLocationsQuery> {
    const statement = `query LocationSvcGetLatestDeliveryLocations($rmcId: String!, $locationType: String, $name: String, $nextToken: String) {
        locationSvcGetLatestDeliveryLocations(
          rmcId: $rmcId
          locationType: $locationType
          name: $name
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            Owner
            OwnerId
            ParentId
            Name
            Type
            Lng
            Lat
            Polygon
            Status
            Timezone
            TimezoneDate
            LoadingPoints
            LastDeliveryTimestamp
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcId
    };
    if (locationType) {
      gqlAPIServiceArguments.locationType = locationType;
    }
    if (name) {
      gqlAPIServiceArguments.name = name;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <LocationSvcGetLatestDeliveryLocationsQuery>(
      response.data.locationSvcGetLatestDeliveryLocations
    );
  }
  async BfdSvcListImeis(
    limit?: number,
    nextToken?: string
  ): Promise<BfdSvcListImeisQuery> {
    const statement = `query BfdSvcListImeis($limit: Int, $nextToken: String) {
        bfdSvcListImeis(limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            imei
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <BfdSvcListImeisQuery>response.data.bfdSvcListImeis;
  }
  async BfdSvcGetImei(imei: string): Promise<BfdSvcGetImeiQuery> {
    const statement = `query BfdSvcGetImei($imei: String!) {
        bfdSvcGetImei(imei: $imei) {
          __typename
          imei
        }
      }`;
    const gqlAPIServiceArguments: any = {
      imei
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <BfdSvcGetImeiQuery>response.data.bfdSvcGetImei;
  }
  async DashboardSvcGetBatchingPerformanceDashboard(
    startDate: string,
    endDate: string,
    granularity: Granularity,
    plantCodes: Array<string>,
    rmcId: string
  ): Promise<DashboardSvcGetBatchingPerformanceDashboardQuery> {
    const statement = `query DashboardSvcGetBatchingPerformanceDashboard($startDate: String!, $endDate: String!, $granularity: Granularity!, $plantCodes: [String!]!, $rmcId: String!) {
        dashboardSvcGetBatchingPerformanceDashboard(
          startDate: $startDate
          endDate: $endDate
          granularity: $granularity
          plantCodes: $plantCodes
          rmcId: $rmcId
        ) {
          __typename
          deliveries {
            __typename
            rmcId
            docketId
            plantCode
            plantName
            siteName
            consistenceClass
            consistenceMmAtSiteArrival
            consistenceMmAtPlantExit
            consistenceMmQualifierAtPlantExit
            consistenceMmQualifierAtSiteArrival
            statusAtPlantExit
            statusAtSiteArrival
          }
          metadata {
            __typename
            granularity
            period
            periodLabel
            plantCodes
            generatedAt
            consistenceClassHistogramRange {
              __typename
              consistenceClass
              consistenceClassRange {
                __typename
                min_mm
                max_mm
              }
            }
            consistenceTestTypeRange {
              __typename
              slumpTest {
                __typename
                min_mm
                max_mm
              }
              flowTest {
                __typename
                min_mm
                max_mm
              }
              slumpflowTest {
                __typename
                min_mm
                max_mm
              }
            }
          }
          thresholds {
            __typename
            plantPerformance {
              __typename
              metric
              bands {
                __typename
                status
                min
                max
              }
            }
            percentMixedAtPlant {
              __typename
              metric
              bands {
                __typename
                status
                min
                max
              }
            }
            periodOverPeriodChange {
              __typename
              metric
              bands {
                __typename
                status
                min
                max
              }
            }
          }
          plantLeaderboard {
            __typename
            maxScore
            rankings {
              __typename
              rank
              plantCode
              plantName
              score
            }
          }
          plantPerformance {
            __typename
            unit
            siteArrival {
              __typename
              plantCode
              plantName
              value
              deliveriesWithDigitalConsistence
            }
            plantExit {
              __typename
              plantCode
              plantName
              value
              deliveriesWithDigitalConsistence
            }
          }
          plantPerformanceOverTime {
            __typename
            unit
            siteArrival {
              __typename
              last6Weeks {
                __typename
                all {
                  __typename
                  key
                  label
                  points {
                    __typename
                    bucket
                    bucketLabel
                    value
                    deliveriesWithDigitalConsistence
                  }
                }
                byPlant {
                  __typename
                  plantCode
                  series {
                    __typename
                    key
                    label
                    points {
                      __typename
                      bucket
                      bucketLabel
                      value
                      deliveriesWithDigitalConsistence
                    }
                  }
                }
              }
              last6Months {
                __typename
                all {
                  __typename
                  key
                  label
                  points {
                    __typename
                    bucket
                    bucketLabel
                    value
                    deliveriesWithDigitalConsistence
                  }
                }
                byPlant {
                  __typename
                  plantCode
                  series {
                    __typename
                    key
                    label
                    points {
                      __typename
                      bucket
                      bucketLabel
                      value
                      deliveriesWithDigitalConsistence
                    }
                  }
                }
              }
            }
            plantExit {
              __typename
              last6Weeks {
                __typename
                all {
                  __typename
                  key
                  label
                  points {
                    __typename
                    bucket
                    bucketLabel
                    value
                    deliveriesWithDigitalConsistence
                  }
                }
                byPlant {
                  __typename
                  plantCode
                  series {
                    __typename
                    key
                    label
                    points {
                      __typename
                      bucket
                      bucketLabel
                      value
                      deliveriesWithDigitalConsistence
                    }
                  }
                }
              }
              last6Months {
                __typename
                all {
                  __typename
                  key
                  label
                  points {
                    __typename
                    bucket
                    bucketLabel
                    value
                    deliveriesWithDigitalConsistence
                  }
                }
                byPlant {
                  __typename
                  plantCode
                  series {
                    __typename
                    key
                    label
                    points {
                      __typename
                      bucket
                      bucketLabel
                      value
                      deliveriesWithDigitalConsistence
                    }
                  }
                }
              }
            }
          }
          periodOverPeriodChange {
            __typename
            unit
            comparison {
              __typename
              granularity
              currentPeriod {
                __typename
                key
                label
              }
              previousPeriod {
                __typename
                key
                label
              }
            }
            siteArrival {
              __typename
              plantCode
              plantName
              value
              currentValue
              previousValue
              deliveriesWithDigitalConsistence
            }
            plantExit {
              __typename
              plantCode
              plantName
              value
              currentValue
              previousValue
              deliveriesWithDigitalConsistence
            }
          }
          percentMixedAtPlant {
            __typename
            unit
            values {
              __typename
              plantCode
              plantName
              value
              deliveriesWithDigitalConsistence
            }
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      startDate,
      endDate,
      granularity,
      plantCodes,
      rmcId
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    })) as any;
    return <DashboardSvcGetBatchingPerformanceDashboardQuery>(
      response.data.dashboardSvcGetBatchingPerformanceDashboard
    );
  }
  SubscribeLoadingPointSpeedPatternListener(
    rmcProvider: string,
    plantCode: string,
    loadingPoint: string
  ): Observable<
    GraphQLResult<
      Pick<__SubscriptionContainer, "subscribeLoadingPointSpeedPattern">
    >
  > {
    const statement = `subscription SubscribeLoadingPointSpeedPattern($rmcProvider: String!, $plantCode: String!, $loadingPoint: String!) {
        subscribeLoadingPointSpeedPattern(
          rmcProvider: $rmcProvider
          plantCode: $plantCode
          loadingPoint: $loadingPoint
        ) {
          __typename
          imei
          eventType
          rmcProvider
          plantCode
          loadingPoint
          truckPlate
          datetimeBatch
          leftBatchPlant
          systemDatetimeUtcStr
          batchSpeedPattern
          batchSpeedPatternTime
          drumVectorRpm
        }
      }`;
    const gqlAPIServiceArguments: any = {
      rmcProvider,
      plantCode,
      loadingPoint
    };
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    }) as any;
  }

  LocationSvcOnLocationUpdateListener(
    owner: string,
    rmcCustomerId?: string
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, "locationSvcOnLocationUpdate">>
  > {
    const statement = `subscription LocationSvcOnLocationUpdate($owner: String!, $rmcCustomerId: String) {
        locationSvcOnLocationUpdate(owner: $owner, rmcCustomerId: $rmcCustomerId) {
          __typename
          owner
          owner_id
          parent_id
          name
          type
          lng
          lat
          polygon
          status
          timezone
          timezone_date
          loading_points
          last_delivery_timestamp
        }
      }`;
    const gqlAPIServiceArguments: any = {
      owner
    };
    if (rmcCustomerId) {
      gqlAPIServiceArguments.rmcCustomerId = rmcCustomerId;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    }) as any;
  }

  OnOrderSvcDownloadFileCompleteListener(
    jobId: string
  ): Observable<
    GraphQLResult<
      Pick<__SubscriptionContainer, "onOrderSvcDownloadFileComplete">
    >
  > {
    const statement = `subscription OnOrderSvcDownloadFileComplete($jobId: String!) {
        onOrderSvcDownloadFileComplete(jobId: $jobId) {
          __typename
          jobId
          status
          csvFileLink
        }
      }`;
    const gqlAPIServiceArguments: any = {
      jobId
    };
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments
    }) as any;
  }
}
